webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fcm; });


var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: "AIzaSyB0YsJ_LfJ0A1MRwlhw4QBNovuvCjZAmZk",
  authDomain: "getnet-c2357.firebaseapp.com",
  databaseURL: "https://getnet-c2357.firebaseio.com",
  projectId: "getnet-c2357",
  storageBucket: "getnet-c2357.appspot.com",
  messagingSenderId: "1069309486841"
});

var db = firebaseApp.database();
var storage = firebaseApp.storage();
var auth = firebaseApp.auth();
var fcm = firebaseApp.messaging();

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQMAAADDCAMAAACxkIT5AAAARVBMVEX4+Pezuav7+/qwt6j29vXDx72/xLnh4960uqzo6ubs7erS1c3v8O3AxLm0uau8wbXIzMLO0cnZ3NXj5eDV2dHb3tirsqJsRgppAAAHwUlEQVR4nO2ciWKjug6Gg8ViwMQQAu//qNeSF0wKSW6bUwZX38x0sgBFP7Jsy4LLhWEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYJkGEUJvk4ugz+y1EftNym2I8+uR+BzFqyHYA6POjz+8XEGO2KwGqUP4BEZR8ogCK0CcfFET/zAtIhProc/zPeSVB+o4gppcaZHD0Sf7XFG9oUKXtCOq1BBkUR5/l5xER9zc0yOY83uXo0/8AormX8mowxl3fEIA84erR/XT6AbRQPcA7135XDpC3o434GWKUPxHAyVCceuhY/1wBFKE82o4fkL8YF78twnDamCCGj7gBitAcbct3Ue/2A6816I+25Zu8My5+F3nSsPi5pnDeyaR4PTewY4c3RhBw0iTbKw0gk8M01vVY3Qv5QgYYz9kzPNcAsrZx0wH8ORZPVTjrXPKZBkaBy8oqIZpnkiWoAehmw6bpL2mwk0EX9e64MjkNViOeOEMgmj0RUouJS55IXPJxmqplILzrCan5gfYNQUwlEFnvw8Pe2DIxDaC25oh6WXOD0Dx21h/S0sBbK6r1x6Wyn2+vQyWmgbVVVA9fehFEu7lXShr4gPi1B/AOspl+T0sDa8zWd97Ocn+307GtgfX4zUSjtvJsrUEkNT5wdm6nFmySYEuflPwACqvBdvC/0Zf5nLgGLkO8PQiwX4rU/aC1l3pbg/5vaDCwBm+1hdTjgYuJelMDGxO3BkkpaZBJq8HmgDizk+jU+8YM7MS52XKD8skYKSkNJmvoxhTZjwXTHyu7OdPXKbKvyUt/zpTNttGL8cvc2e21OYxOS4OQQ1mXqIRiE7WxT2oaBHOEWpaWAFq/11/IpZmpo/JbVLjOaITQwx/LqUblRUKoeqzGJpTfiXFzj/Q0eChEjYx7ssaSmgYZdJuFl2K/jC09DTKQ9RebxOVJIW+CGhgGtV57v4xb48O0NQA5NDktuOIPVf29GgyyC3R/r8Z6nNpCv6rFSVQDksHxcsOz1mR9sjbvpIWqX5YUf4A+aY3my1sZ3weGo235LjsZs+9ocNKmYMg3U6ffkKA9Z6+AiOYz93B0RxvyE8wk6AP38py1cN8h8uFH93SZnfV03obgUbe+68rS/HV00T/8af7Q33gbv2kxjKe/tw8x04H8u1ySuMeTYRiGYRiG8Xz+MR7/6pNBVF3XbgE1X14a6rbQemusj5s1fte6dhmypvYfu91XB0OEmvpSl0O1rErQToEPWvV/IfoZQLozAphdpgPvVMS5Is75HtPBzQwzlh2Ju9kVZleIhqvP85IybPBtuZKvle6uYOkX6XM9w0J2lINQ4hju9Osb6V+JWi43McN9vUsDtjxP3OhbW35jlxmXO71ozW2Os6hldESXTcjLeI4tD9XAVeOjBq4OFzOpIIeWVo4eFkfWGmT0kDx8fXWv6bCUioUlbUALFZANQ3+FpdwX83SzBw7WgC6MChqYE77KEeOX6iCuuEBiDWRp9TMmSh35QUMWZyGBRnpdb+H5SjbBihro45+i5BZR6Ea10BYohehWlfE8XfGpQ8UatEBekkvoCmOz8wPMRssefCUjHuUavEJgWoq0xmPL37J0H9JA2roS3xbwSoVHuOAqC3SxBqu2UNktG7NnEfmBaQodbnd3O44QVW2oYWitquU/o4FEm81FCvEAr2C48QZL0FdLRLEGoEg+MQGM3aJBjeajhS5AoF/EwcE7fomHDvmmoyA/IJ/MhW8LGK6DF1NttozXR1YamD5UKixZlU0R2j9WsEJDhrtKRhNg3KNA4sZPv7crS63Nv2I9mvhFrAY1Ob+PiVaSsAVW2sXjl1iDq7oZDzDdAHTmonp3x27FhIZ6Dh1A6TtKdSfayceDkH2Wh2pgXIAu3I4G5hrKXQ2aEeNbDkbC0BYohKBD6dCKFg3cgKgMGvgh0rEaZDl1i0XQoHu7LWRGOGNPZXoHav52D/R8ZfwdG4MdZdIntLMbJgUNZOU5LCCgBtfcdgV33zcurfdiY+LqGq01EBpkbnrI5tJ5DXCtWrbG43vfv4gQZVVhkNniB/ro0UHwA3tJfN+I188vkVJhdrnXN5rIZw5QF2B8vnRtwY2h3doUNQYsXXVHRHO1uxfG/NKr/mWDNxCDbfuu2MKeaEOX3tldZks3T6z8oMZ2cKNZg28LogytPPN3NGAVt3TFvBQurB90/874gDydKo+WsTJoRR7aPzaFRw1Mj2r9x2uAhaqyR58vyjCnosPU5PT0wICvbeG45kBtQTnTggb2dT9NA84fYb1iqtYa2OBeBw0otLTOKJw62f6AvEzfpruZP0IUDzLtkUctzNq+0b8KjXaMmvRSk29ZxYPajh/wEC4e0P1uLqJSLJzcxDzMnaGNNVhGCAdqANYPcN4DPhTig/VtgPj6LNRmtt27uJkXNaZS7HSjA/qvhpCUwaYPbrIhmtIdUd6E+zDXUQoF5sMW6Ku2bd2gfjQvfdJI5FOPDlrc1eOZqaG1wzzcXtn3lXl7a9ub+zQkHJR5E7JGFR0RHy92t3Om/N7GHPdcvSgWrcKSebOzbh7Cl/t/eWSaWH39+IYW8MPT1fy3h4dEhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmGYt/gf1flRBImwP3YAAAAASUVORK5CYII="

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yomanet.d6cc67e.png";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(897),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAIAAAAiOjnJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpGMTA3RjU1REE1NzJFMTExQTAyMzk5OEMwNUNEMDgyQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo4MzBGOEY2NzcyQTUxMUUxOEUwOUJGRTRGOEY3NjdGOCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4MzBGOEY2NjcyQTUxMUUxOEUwOUJGRTRGOEY3NjdGOCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1LjEgV2luZG93cyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkYxMDdGNTVEQTU3MkUxMTFBMDIzOTk4QzA1Q0QwODJCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkYxMDdGNTVEQTU3MkUxMTFBMDIzOTk4QzA1Q0QwODJCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+WwMSAQAAEBJJREFUeNrsnYl3FFUWxrtr6+pOZxGChEAIhE1WUXJk0UEEJ+Iy43bcHc/omb9s5pwR3FgUJRExBiIQIImBhOwrnb2T3lJd1VXdPbeqHFRIYhICqeX7DnCwsdOv3/vVd+979epdryRJ2WzWA0GLKgZdAAEsCGBBAAuCABYEsCCABUEACwJYEMCCIIAFASwIYEEQwIIAFgSwIAhgQQALAlgQBLAggAUBLAgCWBDAggAWBAEsCGBBAAuCABYEsCCABUEACwJYEMCCIIAFASwIYEEQwIIAFgSwoKwh9MMcxaELZpTXyzIMy7JehvF6vfRbx4t+ZTKZbDaT1gXUANace4TjeEHwGhaViCekKfolKXJSkiTCSvD5/AF/Tk7QnxMI5uYSdvQWVVU1TSPevAZ8EMD6nT0xjE8QGIaZisd7Ojr6unsGb9+OTkamEglNVbMGZ4aL6egQTzk5Obn5+SuLV5WuX7+mtPSR5cvonxRFIRtDZ+od5fJaOvTdiRJRFAmI3q7um42N3e0dsWiUIh1FQcbQvT5k5lt6NCSX8nhygsE1pWu379696bEt/kCA8CIDc7l7uR0s0e8nTFqamupqf77d15/W0hzPmQFu7qIgSCTRzylcubJ8/97H9+whvGRZptcBluuMiucplRL6e3p/qvq+q72dQiG9cp8/lvAiNFcUrTz4/JGdT+wmP0spCsByl1FpqVTND+cv11zQVE3wCYv4w3W80ultu3ZWvPIK5V561g+w3KBAIDA6PPL151/0d3fTLI+86kF8iiIr+Y8UvPzG61u2b0vKctZlYdFdYFFC7ff7u9raTx47Ho/FiKoH+nFmCn/kpRcPPHtQVpSMmyaM7gKLvOpmQ+PXX3ypqirHPYylFsrf1VTqUEXFc0crXLUY4aJ1LKKqpenGiWPHKXV/OFSRGIYhX6yuqsp6soePvuCeqSLjHqr6urtPf/YZ/Z3lHurlRNGQ2KK556WaGlEUXdLhrgCLhnMyHD7x6XFFSc13jWqx2OIF4dyZ79qamwlxN+QezgeLop4iy5/9+z/Rycn7X6m6n5hIPJ356iQ1w+fzOZ4t54MlCIK5qk6eseSIE1XfnjxFrskshXECrEWTTxRHhoYoufFZI7mhZrTebG66Xu8XRWeblpPB8hobqqqrvk9KSYaxyjclu6o59wM1iVu6uAywFi7yA7KH3q6u9pYW31IHwbsC4tjo6PXLly3VKoA1j2SZ8Xov11xMa2mPxXaw0Bzi+pW6pCRxHAew7JezD4VCXe0dvPWMgaLh5Pg4JVvUSKdmWo4FiwbvRkOjosjW3HBHrWqqb8hkMtZJ/gDWnOJgKpXqbG21bKyhzH2wv398ZJQXeIBlG1H4G7p9Ozw6ZlmwyLFkWe5qb+dYzpHR0IFg6dvYGaans0vfLmxhEVt93T3UWkfujncgWDRONFrDoZDXa+lvx3LcyNCQnEyyTlyFdyBYNE6KrIyNjrKcpQdMf9RsamoiHGaduOjgQLAYlo3HYlJiyuITLnLWlKxEJibgWDZxLIaJx2Oqqlq/qZlsJh6NOfL5QyfmWAxDdqWpNnhklFpI1wCWG2wClsejplK22AFsNFUFWHaaGNqlockpCWBBD2AAOBZgQYutbNbv9wMsuwyWvhOL5Vjr3yrRm/qAH5oFWIs3h89kcoJBu2x1ys3LB1j2UDqdzivIt/5WJ/2eJsdRU3ET2k6OlVdQYPEVBzNkL19RaPGb5QDrN7B4ni9c+ajFD0qgduYXFOTl5zvyQAdnJu/0Z0npWuuH7OKSNbwgOPI0B2dum6HgUlq2QbT2s3tej2fdhg13js0FWDaQqqorVj5aVFxs2fSFXCqYl7eubD01FRv97JRmMQyzdddOy6YvxFPZpo00w9BU3Cu0VTSkkdu2cwelxlY8R884A/zx8nIHP2Xv2Fs6BBb5wY7dj6esZwnUtpLSdes3bpCde6ayk+8VUoL11NNP5wSDFpx27Tv4jJfxOvhUUieDlUqllhUuL9+311KHrVNjNmze/NiO7XJSdnD1CofvbqA4eODQs48WFVkkRybvFHy+wy++4PgidQ4HS02l/IFAxd9eschyEdnVgUMHi0tKZFl2ds87HCyKNclkcvO2rfv+8oyy1AFRD4JbNj9z+LDigjoozt/oR0ZFydaRl17ctGWLsnQ+QTPBR5Yve/Xtt80bAwDLIUsP5F2vv/duUXExQbYk81PR53vj/fcKlj1CQdANFedcAZb+aKiiBHKDb3304bLCwoc8SaR5gyAIb374Qcm6dZIkuaSOoYv2vCclafmjK97/5OOi1cUPLSbS7EEMBN76x4cbH9viqjJgrqv+5ff7pxKJk8eOt7fc8oniA/UPinori4pee/ed1WtL3FZcznVgmc8vEE3nz1ZerrmQMSpiLvqn6BXuNW3rrp0vvf5aMC8v6b6ShS4thMmyLOHV2dZ27ptvB0MhYmuxTuYwy33lFeQfPHKk/MB+LZ1Wl2K6ALCWMqOnsKjISl1tbd3F2lg0ynH8/Zx8ZCIl+v07n3jimcPPmRNAci53Vh13dbHxrFFfjqwrMjHReO36jfqG8Pi4+eK0xetn4knTNHpXXn7eYzt27Nm7lyYHqqa506hcCpZ52N+9r/OGpKmp7o7O9uaW/t7eeDRGbHgNvOi3/k6TM+P92QzlZllzO2FObm5R8aot27dv2bY1r6AgnclMO+Wc6aMBlu2RoiDlMQ78VFVyk9S9hkRplmDk9TRtHB4cGg6FRoaGopMRSdIPRaL3UEfxgsDxnCj6c/PzVq5aRb+KS9bk5uWZ5zTfu6R+xxTT6QzLMu4Jjq4Ai3DhWLbjVuvP1T8REEdffdUf8CeTyWmDo16Bh2UJIMYYfnqFaNBUIkvNGlNIlkARRTPZzxrL+jQBJPeaFhfBp/+c6qpz9Onl+/c9Xr6H3u6GSaKTwcoaO4BFURwdHqmurGy92UwRjAhYvbbk72+9uWrNmjn5hxEKdRkHT+pB8P+h8E96lmH8ohiZmKw8fbq56QZr1Ctcu379oRcqyjZtnMk1AZYNZJ63QTO+Cz+cp+imhzljIGlEaT548PkjTz19gGHZpJz0LG4HUNgVKaR6m+rrz39XGTEqX5r/Qh9N3vnkvr2HKv7qz8lxsHU5EyxzKSE8NvbdyVMUg/S49seDbs2lgbLNmw5VVJSWraf/VBRlpnA2d4MkTEUD3/6eXqK5s7WVXrlrhYz+N0VWaOb40muvrtu4walZlwPBIoZEo97kma9OxKNRYeZzgnT/4Lhtu3aRda0xnpwmvBb2xBjH8wLPE5r9PT3XLl1ua25RU6og8DMVHiOs6R3PHa3Y/+zBabN+gGUtmUvqtT9W/3i2MmPMyP7UZmhcfYKP3GtX+ZPrysoCOTkeMyVPp+9sIL63i8y8izJxwbgjRPGuq7Wtqb7hdn8/5fLkkX9qQqZrUlh8+fXXPIyXbMxJvuUosMw7M2dPnb5ysZb+Pvdz3qkH9CeSPZ5lhYWlG8o2bN5UtHp1MBjkZr3VQ+SRI/b19HTcauvt6krEYpSwE8pz58MIi/LmbVvfeP890e930n5l54BFJNGInjr2GaXMd/L0+cq8eUx2FAgEgrm5wbxc+pOG3B8I0M83O8pcCZuKx8Pj42PDI4l43AyFC65XQGytKS19558f0Wclk0ln+JZDwOJ4jvF4Txw7fqO+QVyMUz0z5sqEub6ezdIUz/P74TbCo5mYL0r9C2Jr9dqSdz/+OCc3qDjCt2wPlrm0LQjCiU+PNV69Jtr2rNiUohSXlHzwr0/oKzjgaQvb7yA1s/XK0183Xrsu2vkEYgrflPh/9d9PKRrz9i9wb3uwRFG8VHPhcs0FBxw/TN+l41brmS+/4u8jYwNYixAEKcXubNU363FG5u6A1IRMt+HqtYs//EiQAawlG4PJcPj0519kKY92UMluyherq6rogqHLxr7pr13HQ19eyma/+fJELBLhnFVIki4Smoieoa8WjVJ8tylbdgWLevzSTzUdra2CEys7cDw3EQ6fPXWarhmblsm0H1h0BVP+MRQKXTh/nqKGx6Hyib7mX5oa665a/Ihe54BlXsFVp79RZMVJqdU0vsWy5yurYvp9dAFgPQy7arhS193R4WC7+vUS4rjI5GR15fc8xwOsBz5jmoonLv5Y7cjK79Omkk319f09vbarPmcnsMwt55cvXgyPjXPuAEs/80jVar4/Zz4GArAe1OU7MR6+fumKHXOOhZu0T+hq7+hsaxf9fhtl8XYCi1yqrrY2kYg7O2efxqo92Us1NZ5M1kZLD7YZIcquJsPhpvoGx+fs03x3nu/p7Opsa7XR/VB7gGXujWm8em0q7jq7MlMt6oG62p/NrAtgLV4Q5HlJkpoaGlySs98r3jCtwYEBuxi2DcDST7QShLbmFsrcWbeCpe+HTqUa6q7ZJc2yAVjGTdnMjev1jCvPA/q9abW3tMRjMVvYtg3AEny+4dDgQF+fa+Pgr0PFstFItOPWLVtEQ6uDpZ+/wDCtN5tTiuJ1Ydp+t3l7m39pytphsdTqQ0UpBSHV1tLscru6M4kJDQyEx8etvyne6mCR7Q+FBsdHxliAZVZwmZK62trpMrP4KrylwdKP2WCYrrY2TVNB1a9sMUznrVazZwDWwuNgOp3u7epm7LmL8oFEQ44bCoWikYjFLZyxeCdOjI+PjoywAOu3/J1JJBK3+/oFa6dZVgeLejApSYzr54N3ZQh93d1I3u9LA729XqB0V4bAsKH+AU3VrLzoYF2wyKVUVaUpIRKsu8Hi2MlwOBqZ5HgOYC0kc49ORiITYRZx8J5FBzmZHB0e4ViAtaAEKzw2JstYcJ9GmUwmNDBg5aIEFh0z867F8OAg9SAwmsa0GGZ8dNTK93YsCpbZX9R3yNxnyhPCY+NqKmXZ+bJ1wdI0jVJUZO7TD5vXm4jH47G4ZVf4GMtekUlJikaiWMGa6coju4pFIwBrns1i2Xg0pm+V8SIYTu/oakqlWTNC4Twdi2HI6qnvwNAsM5xoJILlhnlfkfFolNIsONYsXQSwFiLKTQHV7CsOsWgUYM1bCR0skDWb5GQyk7FogSfrgiVNTXkA1mwrDowiy3oFHgZgzUdJSYJjzRoLjUpSqvbHmhkAa9a0NJ1O61WTANZsjqUvZaXUlNfLAKy5kpVOa2nHlfBb/PUGveBP1pKGZU3H8ngy6YxedxTszDorTCkqOZY1txVZcUOPUbdNS0pJLZ3OgqCZpamaZXd/WBEs8qpATmB3+Z7Wm81W3iS55L1UuGLF8sJCa5b9tWhZObOucyqlAKAZE6ys/jQvTXEA1kLSCAA0SyZ6p2Q1QuG8Zz0AaMbOsXbzYAkQwIIAFgSwIAhgQQALAlgQBLAggAUBLAgCWBDAggAWBAEsCGBBAAuCABYEsCCABUEACwJYEMCCIIAFASwIYEEQwIIAFgSwIAhgQQALAlgQBLAggAUBLAgCWBDAggAWBAEsCGBBDhbHMIxlD6GH7Kv/CTAA+1AipcRPNaoAAAAASUVORK5CYII="

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(872),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(880),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(607)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(906),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(609)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(908),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yomanet.d6cc67e.png";

/***/ }),
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonp__);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {

    function axiosReq(request, callback) {
      console.log(request.url);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()(request).then(function (response) {
        console.log(response);
        callback(response.data);
      }).catch(function (error) {
        callback({ Success: false, Data: error });
      });
    }

    Vue.prototype.$GetWeatherXXXXXXXX = function (apiKey, lat, lng, callback) {
      var url = "https://api.darksky.net/forecast/";
      var options = '';
      options += apiKey + '/';
      options += lat + ',' + lng;
      options += '?';
      options += 'units=uk';
      options += '&';
      options += 'lang=en';
      options += '&';
      options += 'exclude=flags,summary,daily,minutely,hourly,alerts';

      url = url + options;

      var req = {
        url: url,
        method: 'get',
        responseType: 'json'
      };

      __WEBPACK_IMPORTED_MODULE_1_jsonp___default()(url, {}, function (error, data) {
        callback(error, data);
      });
    };

    Vue.prototype.$GetWeather = function (apiKey, lat, lng, callback) {
      var error = 'GetWeather Api is blocked !!';
      var data = null;

      error = null;
      data = {
        currently: {
          time: 0,
          summary: 'No Data',
          temperature: 0
        }
      };
      callback(error, data);
    };

    Vue.prototype.$GetPlace = function (placeId, latlng, callback) {
      var url = "https://maps.googleapis.com/maps/api/place/details/json?";

      url = url + "placeid=" + placeId;
      url = url + "&key=AIzaSyBoTa88_jMgJnMFJRiNzovZjTprk8MOxj0";
      url = url + "&language=he";
      var req = {
        url: url,
        method: 'get',
        responseType: 'json'
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default()(req).then(function (response) {
        callback({ success: true, data: response });
      }).catch(function (error) {
        callback({ success: false, data: error });
      });
    };

    Vue.prototype.$GetPlaceName = function (latlng, callback) {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'location': latlng }, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            callback({ success: true, data: results[0] });
          } else {
            callback({ success: false, data: {} });
          }
        } else {
          callback({ success: false, data: status });
        }
      });
    };

    Vue.prototype.$GetPolygonCenter = function (lats, lngs, callback) {
      try {
        var center = { lat: 0, lng: 0 };
        if (lats.length > 0 && lngs.length > 0) {
          lats.sort();
          lngs.sort();
          var lowLat = lats[0];
          var highLat = lats[lats.length - 1];
          var lowLng = lngs[0];
          var highLng = lngs[lngs.length - 1];
          var latCenter = lowLat + (highLat - lowLat) / 2;
          var lngCenter = lowLng + (highLng - lowLng) / 2;
          center = { lat: latCenter, lng: lngCenter };
        }

        callback({ success: true, data: center });
      } catch (error) {
        callback({ success: false, data: error });
      }
    };
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.prototype.$Log = function (msg) {
            if (this.$root.config.isDebug) {
                msg = this.$moment().format('DD.MM.YYYY HH:mm:ss ............') + msg;
                console.log(msg);
            }
        };

        Vue.prototype.$ForceLog = function (msg) {
            msg = this.$moment().format('DD.MM.YYYY HH:mm:ss ............') + msg;
            console.log(msg);
        };
    }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        Object.defineProperty(Vue.prototype, '$moment', { value: __WEBPACK_IMPORTED_MODULE_0_moment___default.a });
    }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Layout__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Login__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Projects__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Diaries__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Diaries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Diaries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Diary__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Diary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Diary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Customers__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Customers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Customers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Inspectors__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Inspectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Inspectors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Observers__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Observers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Observers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Contractors__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Contractors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Contractors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Entrepreneurs__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Entrepreneurs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Entrepreneurs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Users__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Reports__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Reports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_Reports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Settings__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_MyAccount__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_MyAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_MyAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Messages__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_Messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Plans__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Plans___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_Plans__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Plan__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Plan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Plan__);





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Diaries', component: __WEBPACK_IMPORTED_MODULE_5__pages_Diaries___default.a }]
    }, {
        path: '/MyAccount',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'MyAccount', component: __WEBPACK_IMPORTED_MODULE_15__pages_MyAccount___default.a }]
    }, {
        path: '/Plans',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Plans', component: __WEBPACK_IMPORTED_MODULE_17__pages_Plans___default.a }]
    }, {
        path: '/Plan/:planKey',
        name: 'Plan',
        component: __WEBPACK_IMPORTED_MODULE_18__pages_Plan___default.a
    }, {
        path: '/Diary/:diaryKey',
        name: 'Diary',
        component: __WEBPACK_IMPORTED_MODULE_6__pages_Diary___default.a
    }, {
        path: '/Projects',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Projects', component: __WEBPACK_IMPORTED_MODULE_4__pages_Projects___default.a }]
    }, {
        path: '/Customers',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Customers', component: __WEBPACK_IMPORTED_MODULE_7__pages_Customers___default.a }]
    }, {
        path: '/Contractors',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Contractors', component: __WEBPACK_IMPORTED_MODULE_10__pages_Contractors___default.a }]
    }, {
        path: '/Inspectors',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Inspectors', component: __WEBPACK_IMPORTED_MODULE_8__pages_Inspectors___default.a }]
    }, {
        path: '/Observers',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Observers', component: __WEBPACK_IMPORTED_MODULE_9__pages_Observers___default.a }]
    }, {
        path: '/Entrepreneurs',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Entrepreneurs', component: __WEBPACK_IMPORTED_MODULE_11__pages_Entrepreneurs___default.a }]
    }, {
        path: '/Users',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Users', component: __WEBPACK_IMPORTED_MODULE_12__pages_Users___default.a }]
    }, {
        path: '/Reports',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Reports', component: __WEBPACK_IMPORTED_MODULE_13__pages_Reports___default.a }]
    }, {
        path: '/Settings',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Settings', component: __WEBPACK_IMPORTED_MODULE_14__pages_Settings___default.a }]
    }, {
        path: '/Messages',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Layout___default.a,
        children: [{ path: '', name: 'Messages', component: __WEBPACK_IMPORTED_MODULE_16__pages_Messages___default.a }]
    }, {
        path: '/Login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Login___default.a
    }]
}));

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(605)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(904),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */
/***/ (function(module, exports) {

module.exports = {
	"ver": "גרסה",
	"new": "חדש",
	"musketeer": "מוסקטיר",
	"lastIncident": "אירוע אחרון",
	"more": "עוד פרטים",
	"incidentNo": "מס. אירוע",
	"createdBy": "נוצר ע.י.",
	"serviceNeeded": "שירות נדרש",
	"start": "התחלה",
	"eventLocation": "מיקום אירוע",
	"group": "קבוצת",
	"lastWeek": "שבוע אחרון...(הסטוריה)",
	"seeAll": "ראה הכל",
	"createIncident": "צור<br />אירוע",
	"police": "משטרה",
	"fire": "אש",
	"medical": "רפואה",
	"rescue": "הצלה",
	"setLocation": "בחר מקום (הכנס כתובת מדויקת או סמן מיקום במפה )",
	"locationDescription": "תן כותרת לאירוע (תיאור)",
	"create": "צור",
	"close": "סגור",
	"locationRequired": "חובה לבחור מיקום",
	"pointPolygon": "נא לבחור נקודה בתוך הפוליגון!!",
	"createSuccess": "אירוע נוצר בהצלחה.",
	"createFailed": "יצירת יארוע נכשלה!",
	"day": "יום",
	"hr": "שע.",
	"min": "דק.",
	"sec": "שנ.",
	"sendPublic": "שלח הודעה ציבורית",
	"emergencySettings": "הגדרות כיתת כוננות",
	"usersSettings": "הגדרות משתמשים",
	"accountsSettings": "הגדרות חשבונות",
	"incidentHistory": "הסטורית אירועים",
	"projects": "פרויקטים",
	"customers": "לקוחות",
	"rooms": "חדרים",
	"songHistory": "היסטוריית שירים",
	"users": "משתמשים",
	"reports": "דוחות",
	"settings": "הגדרות",
	"logout": "יציאה",
	"language": "שפה",
	"age": "גיל",
	"gender": "מין",
	"address": "כתובת",
	"phone": "טלפון",
	"location": "מיקום",
	"conditions": "תנאים",
	"description": "תיאור",
	"incidentInfo": "פרטי אירוע",
	"at": "ב",
	"or": "או",
	"sendMessage": "שלח הודעה",
	"mediaAttached": "קבצים מצורפים",
	"inviteMusketeers": "הזמן מוסקטיר",
	"resolveIncident": "סגור<br />אירוע",
	"resolveIncidentTitle": "סגור אירוע",
	"resolveSummary": "נא לכתוב סיכום אירוע",
	"reason": "סיבה",
	"resolvedBy": "נסגר ע.י.",
	"resolved": "Activity resolved.",
	"typeMessage": "כתוב הודעה",
	"resolve": "סגור",
	"resolveMistake": "טעות",
	"resolveOthers": "עזרה על ידי אחרים",
	"resolveMusketeers": "עזרה על ידי מוסקטירים",
	"resolveNoHelp": "לא קבל עזרה",
	"resolveTesting": "בדיקות",
	"history": "הסטוריה",
	"prev": "הקודם",
	"next": "הבא",
	"sendPublicMsg": "שלח הודעה ציבורית",
	"sendPublicMsgIntro": "אתה יכול לשלוח הודעה לכל המוסקטירים בשדה המוגדרת לחשבון שלך.",
	"sendTo": "שלח אל",
	"msgType": "סוג הודעה",
	"security": "בטחון",
	"successStory": "ספור הצלחה",
	"social": "חברתי",
	"defaultLanguage": "שלח בשפת ברירת מחדל",
	"english": "אנגלית",
	"hebrew": "עברית",
	"spanish": "ספרדית",
	"controlArea": "איזור שליטה",
	"definePolygon": "פוליגון מוגדר",
	"serviceUsers": "משתמשי שירות",
	"addFile": "הוסף קובץ",
	"subject": "נושא",
	"yourMsg": "כתוב הודעה",
	"newMsg": "הודעה חדשה",
	"send": "שלח",
	"imageOnly": "נא לבחור קובץ תמונה בלבד!!",
	"uploadImageSuccess": "Upload image success.",
	"uploadImageFailed": "העלאת תמונה נכשלה! ההודעה לא נשלחה!",
	"createContentFailed": "HE-Message failed! Could not create content!",
	"missingSubjectMessage": "HE-Please enter subject and message in all tabs!",
	"missingUsers": "HE-No users to send to!!",
	"messageSend": "HE-Message was sent.",
	"messageFailed": "HE-Message failed!!",
	"response": "התגובה שלך...",
	"emergencySetting": "הגדרת כיתת כוננים",
	"emergencySettingIntro": "אתה יכול להגדיר עד 10 musketeers בתור Stand-by, הם יקבלו התראות כאשר יש להתקשר כדי לעזור באזור מוגדר עבור החשבון שלך",
	"addMusketeer": "הוסף מוסקטיר",
	"userName": "שם משתמש",
	"email": "מייל",
	"account": "חשבון",
	"date": "תאריך",
	"noMusketeers": "No Musketeers !!",
	"musketeerDeleted": "Musketeer was deleted.",
	"musketeerDeleteFailed": "Failed to delete musketeer!",
	"maxMusketeer": "Max 10 musketeer exceded !!",
	"add": "הוסף",
	"invite": "הזמן",
	"musketeerExists": "This Musketeer already exists!",
	"inviteSuccess": "Invite success.",
	"inviteFailed": "Invite failed!",
	"missingMusketeer": "Please enter musketeer name or phone number!",
	"phoneNumber": "insert phone number",
	"musketeerName": "הכנס שם מוסקטיר",
	"usersSetting": "הגדרת משתמשים",
	"createUser": "צור משתמש",
	"editUser": "עדכן משתמש",
	"uploadPhoto": "העלאת תמונת משתמש",
	"replacePhoto": "החלף תמונה",
	"save": "שמור",
	"userSuccess": "משתמש נוצר בהצלחה.",
	"userFailed": "יצירת משתמש נכשלה!",
	"userUpdateSuccess": "Update user success.",
	"userUpdateFailed": "Update user failed!!",
	"updatePasswordFailed": "Update password failed!",
	"correctPassword": "Please enter correct password!",
	"noUsers": "No Users !!",
	"missingEmail": "* Please enter email address",
	"newPassword": "New Password",
	"confirmPassword": "Confirm Password",
	"disableUser": "Disable User",
	"enableUser": "Enable User",
	"deleteUser": "Delete User",
	"accountsSetting": "הגדרת חשבונות",
	"createAccount": "צור חשבון",
	"accountName": "שם חשבון",
	"dateCreated": "תאריך יצירה",
	"noAccounts": "אין חשבונות !!",
	"accountDetails": "פרטי חשבון",
	"controlCities": "ערי שליטה",
	"controlAreas": "אזורי שליטה",
	"communityId": "קוד סביבה",
	"newAccount": "חשבון חדש",
	"editAccount": "עריכת חשבון",
	"enableAccount": "הפעלת חשבון",
	"disableAccount": "ביטול חשבון",
	"deleteAccount": "מחיקת חשבון",
	"joinKey": "מפתח",
	"alertType": "סוג התראה",
	"uploadLogo": "העלאת לוגו",
	"logo": "לוגו",
	"name": "שם",
	"assistance": "עזרה",
	"selectCountries": "נא לבחור מדינות וערים לחשבון שלך",
	"country": "מדינה",
	"city": "עיר",
	"selectPolygon": "נא לבחור פוליגון לחשבון שלך",
	"missingName": "נא הכנס שם!",
	"missingCommunity": "נא הכנס קוד!",
	"updateAccountSuccess": "חשבון עודכן בהצלחה.",
	"updateAccountFailed": "עדכון חשבון נכשל!",
	"createAccountSuccess": "חשבון נוצר בהצלחה.",
	"createAccountSuccessNoUser": "חשבון נוצר בהצלחה. אך יצירת משתמש נכשלה!",
	"deleteAccountSuccess": "חשבון נמחק בהצלחה.",
	"deleteAccountFailed": "מחיקת חשבון נכשלה!!",
	"enableAccountSuccess": "חשבון הופעל בהצלחה",
	"enableAccountFailed": "הפעלת חשבון נכשלה!!",
	"disableAccountSuccess": "חשבון בוטל בהצלחה.",
	"disableAccountFailed": "ביטול חשבון נכשל!!",
	"newEvent": "אירוע חדש",
	"resolvedEvent": "אירוע נסגר",
	"playlist": "Playlist"
};

/***/ }),
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  methods: {
    appClick: function appClick(event) {
      var data = event.target.getAttribute("data");
      if (data != 'btnNew') {
        this.$root.btnNew = false;
      }
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_user_png__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_user_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_user_png__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DataMap',
  data: function data() {
    return {
      txtSearch: '',
      center: { lat: 32.699635, lng: 35.303546 },
      zoom: 10,
      marker: { lat: 32.699635, lng: 35.303546 },
      infoOptions: {
        pixelOffset: {
          width: 120,
          height: 0
        }
      },
      infoMarkerOptions: {
        width: 50,
        height: 50,
        pixelOffset: {
          width: 0,
          height: 35
        }
      },
      isOpen: true,
      isOpenInfo: false,
      selectedProject: {
        zIndex: 5000,
        '.key': '',
        Name: '',
        City: '',
        Address: '',
        Location: { lat: 0, lng: 0 },
        Info: '',
        StatusKey: 0,
        UserKey: '',
        Active: true,
        Images: []
      }
    };
  },
  created: function created() {
    this.$Log("Vue [DataMap] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [DataMap] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [DataMap] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [DataTable] is updated ...");
  },

  methods: {
    projectReady: function projectReady() {
      var vm = this;
      vm.$Log("Project Dom is Ready 00000");
    },
    getMapPoint: function getMapPoint(event) {
      var vm = this;

      vm.marker = { lat: event.latLng.lat(), lng: event.latLng.lng() };

      vm.$parent.addNew(vm.marker);
    },
    updateCenter: function updateCenter(event) {
      var vm = this;
    },
    dragend: function dragend() {
      var vm = this;
      vm.$Log("Drag end ... ");
    },
    selectProject: function selectProject(project) {
      project.zIndex = 5300;
      this.selectedProject = {
        zIndex: 5200,
        '.key': project['.key'],
        Name: project.Name,
        City: project.City,
        Address: project.Address,
        Location: project.Location,
        Info: project.Info,
        StatusKey: project.StatusKey,
        UserKey: project.UserKey,
        Active: project.Active,
        Images: project.Images
      };
      this.isOpenInfo = true;

      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedProject));
    },
    resetProject: function resetProject(project) {
      project.zIndex = 5000;
      this.isOpenInfo = false;
      this.selectedProject = {
        zIndex: 5000,
        '.key': '',
        Name: '',
        City: '',
        Address: '',
        Location: { lat: 0, lng: 0 },
        Info: '',
        StatusKey: '',
        UserKey: '',
        Active: true,
        Images: []
      };
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Note__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NoteEditor__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NoteEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NoteEditor__);




var pagesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('DiaryPages');



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DiaryPage',
  props: ['pageKey', 'txtSearch', 'page', 'location'],
  components: { Note: __WEBPACK_IMPORTED_MODULE_2__components_Note___default.a, NoteEditor: __WEBPACK_IMPORTED_MODULE_3__components_NoteEditor___default.a },
  data: function data() {
    return {
      currentDate: '',
      currentTime: '',
      diaryPage: null,
      isNew: false
    };
  },

  firebase: function firebase() {
    var vm = this;
    var notesPath = 'DiaryPages/' + vm.page.PageKey + '/Notes';
    var notesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref(notesPath);
    return {
      allNotes: notesRef.orderByKey()
    };
  },
  created: function created() {
    this.$Log("Vue [DiaryPage] is created ...");
    if (this.pageKey) {
      this.loadPage();
    }
  },
  ready: function ready() {
    this.$Log("Vue [DiaryPage] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [DiaryPage] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [DiaryPage] is updated ...");
  },

  computed: {
    weatherInfo: function weatherInfo() {
      var wth = 'אין נתונים';
      if (this.$root.weather) {
        if (this.$root.weather.currently) {
          wth = this.$root.weather.currently.summary + ' ' + Math.round(this.$root.weather.currently.temperature) + '°';
        }
      }
      return wth;
    },
    notes: function notes() {
      if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
        return this.diaryPage.Notes;
      }
    },
    filteredNotes: function filteredNotes() {
      var vm = this;
      var result = [];
      if (vm.diaryPage != undefined && vm.diaryPage != null && vm.diaryPage.Notes) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vm.diaryPage.Notes);

        var _loop = function _loop() {
          var k = keys[i];
          var note = vm.diaryPage.Notes[k];
          txt = String(vm.txtSearch);

          if (txt.length > 0) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(note).some(function (key) {
              console.log(key);
              if (key != "IsGeneral" && key != "IsInfo") {
                if (String(note[key]).trim().toLowerCase().indexOf(txt.trim().toLowerCase()) > -1) {
                  result.push(note);
                }
              }
            });
          } else {
            result.push(note);
          }
        };

        for (var i = 0; i < keys.length; i++) {
          var txt;

          _loop();
        }
      }

      return result;
    },
    notesGeneral: function notesGeneral() {
      var arr = [];
      for (var i = 0; i < this.filteredNotes.length; i++) {
        if (this.filteredNotes[i].IsGeneral) {
          arr.push(this.filteredNotes[i]);
        }
      }

      return arr;
    },
    notesInfo: function notesInfo() {
      var arr = [];
      for (var i = 0; i < this.filteredNotes.length; i++) {
        if (this.filteredNotes[i].IsInfo) {
          arr.push(this.filteredNotes[i]);
        }
      }

      return arr;
    },
    notesInspector: function notesInspector() {
      var arr = [];
      for (var i = 0; i < this.filteredNotes.length; i++) {
        if (!this.filteredNotes[i].IsInfo && !this.filteredNotes[i].IsGeneral) {
          if (this.filteredNotes[i].UserType == 'מפקח') {
            arr.push(this.filteredNotes[i]);
          }
        }
      }

      return arr;
    },
    notesContractor: function notesContractor() {
      var arr = [];
      for (var i = 0; i < this.filteredNotes.length; i++) {
        if (!this.filteredNotes[i].IsInfo && !this.filteredNotes[i].IsGeneral) {
          if (this.filteredNotes[i].UserType == 'מנהל עבודה') {
            arr.push(this.filteredNotes[i]);
          }
        }
      }

      return arr;
    }
  },
  watch: {
    pageKey: function pageKey(val) {
      this.loadPage();
    }
  },
  methods: {
    updateNotesCounter: function updateNotesCounter(vm, objNotes) {
      if (objNotes) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(objNotes);
        vm.counter = keys.length;
      } else {
        vm.counter = 0;
      }
    },
    loadPage: function loadPage() {
      var vm = this;

      vm.$root.isNewNote = false;
      vm.$root.isNewGeneralNote = false;
      vm.$root.isNewInfoNote = false;
      vm.diaryPage = null;
      var pageKey = vm.page.PageKey;
      if (pageKey == undefined) {
        pageKey = "";
      }
      pagesRef.orderByKey().equalTo(pageKey).once('value').then(function (snapshotPage) {
        var obj = snapshotPage.val();
        if (obj) {
          var keyP = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj)[0];
          if (obj[keyP].Notes) {
            var notesKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj[keyP].Notes);
            for (var k = 0; k < notesKeys.length; k++) {
              var key = notesKeys[k];
              obj[keyP].Notes[key]['.key'] = key;
            }
          }
          vm.diaryPage = obj[keyP];
        } else {}
      });
    },
    addInfoNote: function addInfoNote() {
      var vm = this;

      vm.currentDate = vm.$moment().format('DD/MM/YYYY');
      vm.currentTime = vm.$moment().format('HH:mm');
      vm.$root.isNewGeneralNote = false;
      vm.$root.isNewInfoNote = true;

      vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
        if (!error) {
          vm.$root.weather = data;
        }
      });
    },
    addGeneralNote: function addGeneralNote() {
      var vm = this;
      console.log('addGeneralNote()');

      vm.currentDate = vm.$moment().format('DD/MM/YYYY');
      vm.currentTime = vm.$moment().format('HH:mm');
      vm.$root.isNewGeneralNote = true;
      vm.$root.isNewInfoNote = false;

      vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
        if (!error) {
          vm.$root.weather = data;
        }
      });
    },
    addNote: function addNote() {
      var vm = this;

      vm.currentDate = vm.$moment().format('DD/MM/YYYY');
      vm.currentTime = vm.$moment().format('HH:mm');
      vm.$root.isNewNote = true;
      vm.$root.isNewGeneralNote = false;
      vm.$root.isNewInfoNote = false;

      vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
        if (!error) {
          vm.$root.weather = data;
        }
      });
    },
    canAdd: function canAdd() {
      return this.$parent.currentDate == this.page.Date && !this.$root.isObserver;
    },
    canEdit: function canEdit(note) {
      if (this.$parent.currentDate == this.page.Date) {
        return note.UserKey == this.$root.user['.key'];
      }
      return false;
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Note__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NoteEditor__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NoteEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NoteEditor__);




var pagesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('DiaryPages');



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DiaryPageMobile',
  props: ['pageKey', 'pages', 'page', 'location'],
  components: { Note: __WEBPACK_IMPORTED_MODULE_2__components_Note___default.a, NoteEditor: __WEBPACK_IMPORTED_MODULE_3__components_NoteEditor___default.a },
  data: function data() {
    return {
      currentDate: '',
      currentTime: '',
      diaryPage: null,
      isNew: false
    };
  },

  firebase: function firebase() {
    var vm = this;
    var notesPath = 'DiaryPages/' + vm.page.PageKey + '/Notes';
    var notesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref(notesPath);
    return {
      allNotes: notesRef.orderByKey()
    };
  },
  created: function created() {
    this.$Log("Vue [DiaryPageMobile] is created ...");
    if (this.pageKey) {
      this.loadPage();
    }
  },
  ready: function ready() {
    this.$Log("Vue [DiaryPageMobile] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [DiaryPageMobile] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [DiaryPageMobile] is updated ...");
  },

  computed: {
    weatherInfo: function weatherInfo() {
      var wth = 'אין נתונים';
      if (this.$root.weather) {
        if (this.$root.weather.currently) {
          wth = this.$root.weather.currently.summary + ' ' + Math.round(this.$root.weather.currently.temperature) + '°';
        }
      }
      return wth;
    },
    pageDate: function pageDate() {
      if (this.$root.activeDiaryPage && this.$root.activeDiaryPage.Date) {
        return this.$root.activeDiaryPage.Date;
      } else {
        return null;
      }
    },
    notes: function notes() {
      if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
        return this.diaryPage.Notes;
      }
    },
    notesGeneral: function notesGeneral() {
      var arr = [];
      if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.diaryPage.Notes);
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          if (this.diaryPage.Notes[k].IsGeneral) {
            arr.push(this.diaryPage.Notes[k]);
          }
        }
      }

      return arr;
    },
    notesInfo: function notesInfo() {
      var arr = [];
      if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.diaryPage.Notes);
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          if (this.diaryPage.Notes[k].IsInfo) {
            arr.push(this.diaryPage.Notes[k]);
          }
        }
      }

      return arr;
    },
    notesInspector: function notesInspector() {
      var arr = [];
      if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.diaryPage.Notes);
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          if (!this.diaryPage.Notes[k].IsInfo && !this.diaryPage.Notes[k].IsGeneral) {
            if (this.diaryPage.Notes[k].UserType == 'מפקח') {
              arr.push(this.diaryPage.Notes[k]);
            }
          }
        }
      }

      return arr;
    },
    notesContractor: function notesContractor() {
      var arr = [];
      if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.diaryPage.Notes);
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          if (!this.diaryPage.Notes[k].IsInfo && !this.diaryPage.Notes[k].IsGeneral) {
            if (this.diaryPage.Notes[k].UserType == 'מנהל עבודה') {
              arr.push(this.diaryPage.Notes[k]);
            }
          }
        }
      }

      return arr;
    }
  },
  watch: {},
  methods: {
    downloadPage: function downloadPage(page, event) {
      var vm = this;
      var docWeather = "מזג אויר";
      var weatherPath = 'DiaryPages/' + page.PageKey + '/Weather';
      var weatherRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref(weatherPath);
      weatherRef.orderByKey().once('value').then(function (snapWeather) {
        var objWeather = snapWeather.val();
        vm.downloadPageWithWeather(vm, objWeather, page, event);
      });
    },
    updateNotesCounter: function updateNotesCounter(vm, objNotes) {
      if (objNotes) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(objNotes);
        vm.counter = keys.length;
      } else {
        vm.counter = 0;
      }
    },
    loadPage: function loadPage() {
      var vm = this;
      console.log('DiaryPageMobile loadPage() ...');
      console.log('PageKey = ' + vm.PageKey);
      console.log('PageKey = ' + vm.page.PageKey);

      vm.$root.isNewNote = false;
      vm.$root.isNewGeneralNote = false;
      vm.$root.isNewInfoNote = false;
      vm.diaryPage = null;
      var pageKey = vm.page.PageKey;
      if (pageKey == undefined) {
        pageKey = "";
      }
      pagesRef.orderByKey().equalTo(pageKey).once('value').then(function (snapshotPage) {
        var obj = snapshotPage.val();
        if (obj) {
          var keyP = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj)[0];
          if (obj[keyP].Notes) {
            var notesKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj[keyP].Notes);
            for (var k = 0; k < notesKeys.length; k++) {
              var key = notesKeys[k];
              obj[keyP].Notes[key]['.key'] = key;
            }
          }
          vm.diaryPage = obj[keyP];
        } else {}
      });
    },
    addInfoNote: function addInfoNote() {
      var vm = this;

      vm.currentDate = vm.$moment().format('DD/MM/YYYY');
      vm.currentTime = vm.$moment().format('HH:mm');
      vm.$root.isNewGeneralNote = false;
      vm.$root.isNewInfoNote = true;

      vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
        if (!error) {
          vm.$root.weather = data;
        } else {
          console.error(error);
        }
      });
    },
    addGeneralNote: function addGeneralNote() {
      var vm = this;

      vm.currentDate = vm.$moment().format('DD/MM/YYYY');
      vm.currentTime = vm.$moment().format('HH:mm');
      vm.$root.isNewGeneralNote = true;
      vm.$root.isNewInfoNote = false;

      vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
        if (!error) {
          vm.$root.weather = data;
        } else {
          console.error(error);
        }
      });
    },
    addNote: function addNote() {
      var vm = this;

      vm.currentDate = vm.$moment().format('DD/MM/YYYY');
      vm.currentTime = vm.$moment().format('HH:mm');
      vm.$root.isNewNote = true;
      vm.$root.isNewGeneralNote = false;
      vm.$root.isNewInfoNote = false;

      vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
        if (!error) {
          vm.$root.weather = data;

          vm.currentDate = vm.$moment(data.currently.time * 1000).format('DD/MM/YYYY');
          vm.currentTime = vm.$moment(data.currently.time * 1000).format('HH:mm');
          vm.$root.isNewNote = true;
          vm.$root.isNewGeneralNote = false;
          vm.$root.isNewInfoNote = false;
        } else {
          console.error(error);
        }
      });
    },
    canAdd: function canAdd() {
      return this.$parent.currentDate == this.page.Date && !this.$root.isObserver;
    },
    canEdit: function canEdit(note) {
      if (this.$parent.currentDate == this.page.Date) {
        return note.UserKey == this.$root.user['.key'];
      }
      return false;
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FileFolderLabel',
  props: ['isRoot', 'Key', 'Name', 'Url', 'isFolder', 'isFile', 'path', 'canEdit'],
  data: function data() {
    return {
      isChecked: true,
      selectedKey: ''
    };
  },
  created: function created() {
    this.$Log("Vue [FileFolderLabel] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [FileFolderLabel] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [FileFolderLabel] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [FileFolderLabel] is updated ...");
  },

  computed: {
    Title: function Title() {
      var maxLength = 10;
      if (this.isRoot) {
        maxLength = 20;
      }

      if (this.Name && this.Name.length > maxLength) {
        return this.Name.substring(0, maxLength) + '...';
      } else {
        return this.Name;
      }
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      var vm = this;
      if (val) {
        if (vm.selectedKey == vm.Key) {
          if (vm.$root.confirm.caller == 'RemoveFolder') {
            vm.removeFolder();
          }
          if (vm.$root.confirm.caller == 'RemoveFile') {
            vm.removeFile();
          }
        }
      }
    }
  },
  methods: {
    selectFile: function selectFile(url) {
      if (url) {
        console.log("selectFile >>> " + url);
        this.$root.selectedFile = url;
      }
    },
    showAddFile: function showAddFile() {
      this.$root.confirmAddFile.path = this.path;
      this.$root.confirmAddFile.isVisible = true;
    },
    confirm: function confirm() {
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק מסמך זה?',
        caller: 'RemovePlan',
        isConfirmed: false
      };

      this.selectedKey = this.Key;

      if (this.isFile) {
        this.$root.confirm.question = 'האם אתה בטוח ברצונך למחוק מסמך זה?';
        this.$root.confirm.caller = 'RemoveFile';
      }

      if (this.isFolder) {
        this.$root.confirm.question = 'האם אתה בטוח ברצונך למחוק תיקייה זו?';
        this.$root.confirm.caller = 'RemoveFolder';
      }
    },
    remove: function remove() {
      plansRef.child(this.popup.data['.key']).remove();
    },
    download: function download() {},
    edit: function edit() {
      this.selectedKey = this.Key;
      this.$root.confirmAddFile.path = this.path;
      this.$root.confirmAddFile.isVisible = true;
    },
    removeFolder: function removeFolder() {
      var planeFolderRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref(this.path);
      planeFolderRef.remove();
      this.$root.isUpdatedPlan = true;
      this.selectedKey = '';
    },
    removeFile: function removeFile() {
      var planeFileRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref(this.path);
      planeFileRef.remove();
      this.$root.isUpdatedPlan = true;
      this.selectedKey = '';
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FileFolderLabel__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FileFolderLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FileFolderLabel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Folder',
  components: { VueLabel: __WEBPACK_IMPORTED_MODULE_1__components_FileFolderLabel___default.a },
  props: ['folderData', 'Key', 'isRoot', 'path', 'canEdit'],
  data: function data() {
    return {
      isChecked: true
    };
  },
  created: function created() {
    this.$Log("Vue [Folder] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Folder] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Folder] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Folder] is updated ...");
  },

  computed: {
    subFolders: function subFolders() {
      var arrFolders = [];
      if (this.folderData[this.Key].SubFolders) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.folderData[this.Key].SubFolders);
        for (var k = 0; k < keys.length; k++) {
          var key = keys[k];
          var folder = {};
          folder[key] = this.folderData[this.Key].SubFolders[key];
          folder.Path = this.path + "/SubFolders/" + key;
          arrFolders.push(folder);
        }
      }
      return arrFolders;
    },
    files: function files() {
      var arrFiles = [];
      if (this.folderData[this.Key].Files) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.folderData[this.Key].Files);
        for (var k = 0; k < keys.length; k++) {
          var key = keys[k];
          var file = {
            Key: key,
            Title: this.folderData[this.Key].Files[key].Title,
            Url: this.folderData[this.Key].Files[key].Url,
            Path: this.path + "/Files/" + key
          };
          arrFiles.push(file);
        }
      }
      return arrFiles;
    }
  },
  methods: {}
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logo',
  data: function data() {
    return {
      name: ''
    };
  },
  created: function created() {
    this.$Log("Vue [Logo] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Logo] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Logo] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Logo] is updated ...");
  },

  methods: {
    closeMobileMenu: function closeMobileMenu() {
      this.$root.activeMobileMenu = false;
    },
    menuClick: function menuClick(item) {
      this.$Log("Clicked item  >>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
      switch (item.page) {
        case 'Logout':
          this.confirmSignout();this.break;
        default:
          this.$router.push({ name: item.page });break;
      }
    },
    confirmSignout: function confirmSignout() {
      this.$root.confirm = {
        isVisible: true,
        title: 'יציאה',
        question: 'האם אתה בטוח ברצונך לצאת מהמערכת?',
        caller: 'Signout',
        isConfirmed: false
      };
    },
    signout: function signout() {
      this.$localStorage.remove('user');
      this.$root.user = null;
      this.$root.isHome = true;
      this.$router.push({ name: 'Login' });
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NoteEditor__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NoteEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NoteEditor__);



var pagesRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Pages');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Note',
  components: { NoteEditor: __WEBPACK_IMPORTED_MODULE_1__components_NoteEditor___default.a },
  props: ['noteData', 'index', 'canEdit'],
  data: function data() {
    return {
      isShow: false,
      isEdit: false,
      selectedNoteKey: '',
      page: ''
    };
  },
  created: function created() {
    this.$Log("Vue [Note] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Note] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Note] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Note] is updated ...");
  },

  computed: {
    txtId: function txtId() {
      return 'txt' + this.index;
    },
    noteInfo: function noteInfo() {
      var splittedNote = this.noteData.Info.split("\n");
      var noteText = '';
      for (var l = 0; l < splittedNote.length; l++) {
        noteText += splittedNote[l] + "<br/>";
      }
      return noteText;

      var noteText = this.noteData.Info.replace("\n", "<br/>");
      console.log(noteText);
      return noteText;
    },
    hasRecord: function hasRecord() {
      return this.noteData.Record && this.noteData.Record.length > 0;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveNote') {
        this.remove();
      }
    }
  },
  methods: {
    edit: function edit(noteData) {
      this.isEdit = true;
    },
    confirm: function confirm(key) {
      console.log("confirm >> " + key);
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveNote',
        isConfirmed: false
      };

      this.selectedNoteKey = key;
    },
    remove: function remove() {
      if (this.noteData['.key'] == this.selectedNoteKey) {
        console.log("Remove note >> " + this.selectedNoteKey);
        var notePath = "DiaryPages/" + this.$root.activeDiaryPage.PageKey + "/Notes/" + this.selectedNoteKey;
        var noteRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref(notePath);
        noteRef.remove();
        this.selectedNoteKey = '';
        this.$parent.loadPage();
      }
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Recorder__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Recorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Recorder__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NoteEditor',
  components: { Recorder: __WEBPACK_IMPORTED_MODULE_1__Recorder___default.a },
  props: ['noteData', 'index', 'date', 'time'],
  data: function data() {
    return {
      isShow: false,
      isEdit: false,
      isTopNote: false,
      isRecording: false,
      audioObj: null,
      showFile: false,
      showProgress: false,

      error: '',
      page: '',
      currentNote: {
        '.key': '',
        UserKey: '',
        UserFullName: '',
        UserType: '',
        Date: '',
        Time: '',
        Weather: '',
        Info: '',
        Attachments: [],
        Record: ''
      }
    };
  },
  created: function created() {
    this.$Log("Vue [NoteEditor] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [NoteEditor] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [NoteEditor] is mounted ...");
    var vm = this;


    if (this.noteData != undefined) {
      this.currentNote = this.noteData;
    } else {
      this.currentNote.Date = this.date;
      this.currentNote.Time = this.time;
      this.currentNote.UserKey = this.$root.user['.key'];
      this.currentNote.UserFullName = this.$root.user.FullName;
      this.currentNote.UserType = this.$root.user.Type;

      this.currentNote.Attachments = null;
    }
  },
  updated: function updated() {
    this.$Log("Vue [NoteEditor] is updated ...");
  },

  computed: {
    txtId: function txtId() {
      return 'txt' + this.index;
    },
    hasInfo: function hasInfo() {
      return this.currentNote.Info.trim().length;
    }
  },
  watch: {
    hasInfo: function hasInfo(val) {
      if (val) {
        this.error = "";
      }
    },
    isRecording: function isRecording(val) {
      if (val) {}
    }
  },
  methods: {
    upload: function upload(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var vm = this;

      var file = files[0];
      var image = new Image();
      var reader = new FileReader();

      reader.onload = function (ev) {
        vm.logoUrl = ev.target.result;
      };
      reader.readAsDataURL(file);

      vm.showFile = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["d" /* storage */].ref('attachments/' + file.name);

      var task = storageRef.put(file);

      if (vm.currentNote.Attachments == null) {
        vm.currentNote.Attachments = [];
      }

      var attachment = { Type: "File", FileName: file.name, FileUrl: '' };

      task.on('state_changed', function progress(snap) {
        vm.showProgress = true;
      }, function error(err) {
        vm.showFile = false;
        vm.showProgress = false;
      }, function complete() {
        attachment.FileUrl = task.snapshot.downloadURL;
        vm.currentNote.Attachments.push(attachment);
        vm.showFile = true;
        vm.showProgress = false;
      });
    },
    removeFile: function removeFile(file) {},
    save: function save() {
      if (!this.hasInfo) {
        this.error = "* חסר נתונים! לא ניתן לשמור!!";
      } else {

        if (this.currentNote.Attachments == null) {
          this.currentNote.Attachments = [];
        }

        if (this.audioObj && this.audioObj != "ERROR") {
          this.currentNote.Attachments.push(this.audioObj);
        }

        if (this.currentNote['.key'] == "") {
          this.insert();
        } else {
          this.update();
        }
      }
    },
    insert: function insert() {
      var vm = this;

      var note = {
        UserKey: vm.currentNote.UserKey,
        UserFullName: vm.currentNote.UserFullName,
        UserType: vm.currentNote.UserType,
        Date: vm.currentNote.Date,
        Time: vm.currentNote.Time,

        Info: vm.isTopNote ? "[פיקוח עליון]\n" + vm.currentNote.Info : vm.currentNote.Info,
        Attachments: vm.currentNote.Attachments,
        IsGeneral: vm.$root.isNewGeneralNote,
        IsInfo: vm.$root.isNewInfoNote,
        IsTopNote: vm.isTopNote,
        Record: vm.audioObj
      };

      if (this.$root.activeDiaryPage.PageKey != null) {
        var pagePath = "DiaryPages/" + vm.$root.activeDiaryPage.PageKey + "/Notes";
        var pagesRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref(pagePath);
        pagesRef.push(note).then(function (snap) {
          vm.$parent.loadPage();
        });
      } else {
        var notes = [];
        notes.push(note);
        var page = {
          Date: vm.currentNote.Date,
          Notes: notes,

          Weather: vm.$parent.page.Weather
        };
        var pagesRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref("DiaryPages");

        pagesRef.push(page).then(function (snap) {
          var pgKey = snap.key;
          vm.$root.activeDiaryPage.PageKey = pgKey;
          var diariesPagesRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Diaries/' + vm.$route.params.diaryKey + '/Pages');
          diariesPagesRef.push({ Date: vm.date, PageKey: pgKey }).then(function (snapDP) {
            if (vm.$parent.isEdit) {
              vm.$parent.$parent.loadPage();
            } else {
              vm.$parent.loadPage();
            }
            vm.cancel();
          });
        });
      }
    },
    update: function update() {
      var vm = this;
      var note = {
        UserKey: vm.currentNote.UserKey,
        UserFullName: vm.currentNote.UserFullName,
        UserType: vm.currentNote.UserType,
        Date: vm.currentNote.Date,
        Time: vm.currentNote.Time,

        Info: vm.isTopNote ? "[פיקוח עליון]\n" + vm.currentNote.Info : vm.currentNote.Info,
        IsGeneral: vm.currentNote.IsGeneral,
        IsInfo: vm.currentNote.IsInfo,
        IsTopNote: vm.isTopNote,
        Record: vm.audioObj
      };

      if (vm.currentNote.Attachments != undefined && vm.currentNote.Attachments.length > 0) {
        if (vm.noteData.Attachments == null) {
          note.Attachments = { 0: vm.currentNote.Attachments };
        } else {
          note.Attachments = vm.currentNote.Attachments;
        }
      }

      if (vm.$root.activeDiaryPage.PageKey != null) {
        var notePath = "DiaryPages/" + vm.$root.activeDiaryPage.PageKey + "/Notes/" + vm.currentNote['.key'];
        var noteRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref(notePath);
        noteRef.set(note).then(function (snap) {
          if (vm.$parent.isEdit) {
            vm.$parent.$parent.loadPage();
          } else {
            vm.$parent.loadPage();
          }
          vm.cancel();
        });
      } else {
        vm.cancel();
      }
    },
    cancel: function cancel() {
      if (this.currentNote['.key'] == "") {
        this.$root.isNewNote = false;
        this.$root.isNewGeneralNote = false;
        this.$root.isNewInfoNote = false;
      } else {
        this.$parent.isEdit = false;
        this.$root.isNewGeneralNote = false;
        this.$root.isNewInfoNote = false;
      }
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notification',
  data: function data() {
    return {
      mobileNumber: ''
    };
  },
  beforeCreate: function beforeCreate() {
    this.$Log("Vue [notification] is before create ...");
  },
  created: function created() {
    this.$Log("Vue [notification] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [notification] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [notification] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [notification] is updated ...");
    var vm = this;
    if (vm.$root.notification.isShow) {
      setTimeout(function () {
        vm.$root.notification = { isShow: false, activityId: null, info: '', from: '', event: '' };
      }, 5000);
    }
  },

  computed: {},
  methods: {
    selectActivity: function selectActivity(activityId) {
      if (activityId != null) {
        var vm = this;

        vm.$root.dialogPublicMessage = false;
        vm.$root.dialogUsersSettings = false;
        vm.$root.dialogEmergencySettings = false;
        vm.$root.dialogAcountsSettings = false;
        vm.$root.dialogAcountSettings = false;
        vm.$root.activeSubMenu = false;

        var inviteId = '';
        for (var i = 0; i < vm.$root.activities.length; i++) {
          if (vm.$root.activities[i].id == activityId) {
            inviteId = vm.$root.activities[i].activityInviteId;
            break;
          }
        }
        vm.$JoinActivity(inviteId, function (joinResult) {
          vm.$Log("$JoinActivity result >>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(joinResult));
          vm.$SelectActivity(vm, activityId);
        });
      }

      this.$root.notification = { isShow: false, from: '', event: '' };
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Pdf',
  props: ['url'],
  data: function data() {
    return {
      isShow: false,
      pdfContent: 'בחר קובץ מהתפריט'
    };
  },
  created: function created() {
    this.$Log("Vue [Pdf] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Pdf] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Pdf] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Pdf] is updated ...");
  },

  watch: {
    url: function url(val) {
      if (PDFObject.supportsPDFs) {
        PDFObject.embed(this.url, "#divPDF");
      } else {
        this.pdfContent = "PDF not supported";
      }
    }
  },
  computed: {},
  methods: {}
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jszip__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pdfjs_dist__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PdfMobile',
  props: ['url'],
  data: function data() {
    return {
      isShow: false,
      isLoaded: false,
      isZooming: false,
      pdfContent: 'בחר קובץ מהתפריט',
      pdfDoc: null,
      pageNum: 0,
      scale: 1.0,
      ctx: ''
    };
  },
  created: function created() {
    this.$Log("Vue [PdfMobile] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PdfMobile] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PdfMobile] is mounted ...");

    __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist___default.a.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.489/pdf.worker.min.js';
  },
  updated: function updated() {
    this.$Log("Vue [PdfMobile] is updated ...");
  },

  watch: {
    url: function url(val) {
      this.isLoaded = false;
      this.loadPDF();
    }
  },
  computed: {},
  methods: {
    loadPDF: function loadPDF() {
      var vm = this;
      vm.isLoaded = false;
      JSZipUtils.getBinaryContent(vm.url, function (err, data) {
        if (!err) {
          console.log(data);

          vm.pageNum = 1;
          __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist___default.a.getDocument(data).then(function getPdf(_pdfDoc) {
            vm.pdfDoc = _pdfDoc;

            vm.canvas = document.getElementById('pdfCanvas');
            vm.ctx = vm.canvas.getContext('2d');
            vm.pdfDoc.getPage(vm.pageNum).then(function (page) {
              var viewport = page.getViewport(vm.scale);
              vm.canvas.height = viewport.height;
              vm.canvas.width = viewport.width;

              var renderContext = {
                canvasContext: vm.ctx,
                viewport: viewport
              };
              page.render(renderContext);
              vm.isLoaded = true;
            });
          });
        }
      });
    },
    zoomMobile: function zoomMobile(sign) {
      var vm = this;

      try {
        vm.pageNum = 1;
        if (sign == "+") {
          vm.scale = vm.scale + 0.1;
        }
        if (sign == "-") {
          vm.scale = vm.scale - 0.1;
        }

        if (vm.scale < 0.25) {
          vm.scale = 0.25;
        }
        if (vm.scale > 4) {
          vm.scale = 4;
        }
        if (!vm.isZooming) {
          vm.canvas = document.getElementById('pdfCanvas');
          vm.ctx = vm.canvas.getContext('2d');
          vm.isZooming = true;
          vm.pdfDoc.getPage(vm.pageNum).then(function (page) {
            var viewport = page.getViewport(vm.scale);
            vm.canvas.height = viewport.height;
            vm.canvas.width = viewport.width;

            var renderContext = {
              canvasContext: vm.ctx,
              viewport: viewport
            };

            page.render(renderContext).then(function () {
              console.log("FINISHED RENDERING!");
              vm.isZooming = false;
            }, function () {
              console.log("ERROR");
              vm.isZooming = true;
            });
          });
        }
      } catch (e) {
        console.log("Canavs is zooming...");
      }
    },
    renderPDF: function renderPDF() {

      var vm = this;
      vm.pdfDoc = null;
      vm.pageNum = 1;
      vm.scale = 1;
      vm.canvas = document.getElementById('pdfCanvas');
      vm.ctx = canvas.getContext('2d');
      __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist___default.a.disableWorker = true;
      __WEBPACK_IMPORTED_MODULE_1_pdfjs_dist___default.a.getDocument(vm.url).then(function getPdf(_pdfDoc) {
        pdfDoc = _pdfDoc;
        renderPage(pageNum);
      });
    },
    base64ToUint8Array: function base64ToUint8Array(base64) {
      var raw = atob(base64);
      var uint8Array = new Uint8Array(new ArrayBuffer(raw.length));
      for (var i = 0; i < raw.length; i++) {
        uint8Array[i] = raw.charCodeAt(i);
      }
      return uint8Array;
    },
    renderPage: function renderPage(num) {
      pdfDoc.getPage(num).then(function (page) {
        var viewport = page.getViewport(scale);
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };
        page.render(renderContext);
      });

      document.getElementById('page_num').textContent = pageNum;
      document.getElementById('page_count').textContent = pdfDoc.numPages;
    },
    goPrevious: function goPrevious() {
      if (pageNum <= 1) return;
      pageNum--;
      renderPage(pageNum);
    },
    goNext: function goNext() {
      if (pageNum >= pdfDoc.numPages) return;
      pageNum++;
      renderPage(pageNum);
    },
    zoom: function zoom(newScale) {
      pdfDoc.getPage(pageNum).then(function (page) {
        var viewport = page.getViewport(newScale);
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };
        page.render(renderContext);
      });
    },
    zoomIn: function zoomIn() {
      var scaleSelect = document.getElementById("scaleSelect");
      var last = scaleSelect.options.length - 1;
      if (scaleSelect.selectedIndex < last) {
        scale = scaleSelect.options[scaleSelect.selectedIndex + 1].value;
        scaleSelect.selectedIndex += 1;
        zoom(scale);
      }
    },
    zoomOut: function zoomOut() {
      var scaleSelect = document.getElementById("scaleSelect");
      var last = scaleSelect.options.length - 1;
      if (scaleSelect.selectedIndex > 0) {
        scale = scaleSelect.options[scaleSelect.selectedIndex - 1].value;
        scaleSelect.selectedIndex -= 1;
        zoom(scale);
      }
    },
    zoomSelect: function zoomSelect() {
      var scaleSelect = document.getElementById("scaleSelect");
      scale = scaleSelect.options[scaleSelect.selectedIndex].value;
      zoom(scale);
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupAddDiaries',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$Log("Vue [PopupAddDiaries] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupAddDiaries] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupAddDiaries] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupAddDiaries] is updated ...");
  },

  methods: {
    confirmed: function confirmed(val) {
      var total = this.$root.confirmAddDiaries.totalDiaries;
      this.$root.confirmAddDiaries = {
        isVisible: false,
        totalDiaries: total,
        isConfirmed: val
      };
    },
    checkValue: function checkValue() {
      if (this.$root.confirmAddDiaries.totalDiaries < 1) {
        this.$root.confirmAddDiaries.totalDiaries = 1;
      }
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupAddFile',
  props: ['isVisible'],
  data: function data() {
    return {
      title: 'הוספת מסמך חדש',
      addType: 'File',
      folderName: '',
      fileName: '',
      showFile: false,
      showProgress: false,
      showReady: false,
      fileUrl: '',
      readyFileName: ''
    };
  },
  created: function created() {
    this.$Log("Vue [PopupAddFile] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupAddFile] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupAddFile] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupAddFile] is updated ...");
  },

  watch: {
    addType: function addType(val) {
      switch (val) {
        case 'File':
          this.title = 'הוספת מסמך חדש';break;
        case 'Folder':
          this.title = 'הוספת תיקייה חדשה';break;
      }
    }
  },
  methods: {
    confirmed: function confirmed(val) {
      this.$root.confirm = {
        isVisible: false,
        title: '',
        question: '',
        caller: this.$root.confirm.caller,
        isConfirmed: val
      };
    },
    upload: function upload(e) {
      var vm = this;
      vm.readyFileName = '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var file = files[0];
      var image = new Image();
      var reader = new FileReader();

      reader.onload = function (ev) {
        vm.logoUrl = ev.target.result;
      };
      reader.readAsDataURL(file);

      vm.showFile = true;
      vm.showProgress = true;

      var planKey = vm.$route.params.planKey;

      if (planKey) {
        var storageRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["d" /* storage */].ref('planes/' + planKey + '/' + file.name);
        var task = storageRef.put(file);

        task.on('state_changed', function progress(snap) {}, function error(err) {
          vm.showFile = false;
          vm.showProgress = false;
        }, function complete() {
          vm.fileUrl = task.snapshot.downloadURL;
          vm.showFile = false;
          vm.showProgress = false;
          vm.showReady = true;
          vm.readyFileName = file.name;
        });
      } else {
        vm.$root.alert.message = 'העלאת קובץ נכשלה!!';
        vm.$root.alert.isShow = true;
      }
    },
    save: function save() {
      if (this.addType == "File") {
        if (this.showReady) {
          this.insertFile();
        } else {
          alert("העלאת קובץ לא הסתיימה!");
        }
      }
      if (this.addType == "Folder") {
        this.insertFolder();
      }
    },
    insertFile: function insertFile() {
      var vm = this;
      var file = {
        Title: vm.fileName,
        Url: vm.fileUrl
      };
      var path = this.$root.confirmAddFile.path + "/Files";
      var planeFilesRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref(path).push(file);
      vm.$root.isUpdatedPlan = true;
      vm.reset();
    },
    updateFile: function updateFile() {},
    insertFolder: function insertFolder() {
      var vm = this;
      var folder = {
        Title: vm.folderName
      };
      var path = this.$root.confirmAddFile.path + "/SubFolders";
      var planeSubFoldersRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref(path).push(folder);
      vm.$root.isUpdatedPlan = true;
      vm.reset();
    },
    updateFolder: function updateFolder() {},
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.addType = 'File';
      this.folderName = '';
      this.fileName = '';
      this.showFile = false;
      this.showProgress = false;
      this.showReady = false;
      this.fileUrl = '';
      this.readyFileName = '';
      this.$root.confirmAddFile.path = '';
      this.$root.confirmAddFile.isVisible = false;
    }
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupConfim',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$Log("Vue [PopupConfim] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupConfim] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupConfim] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupConfim] is updated ...");
  },

  methods: {
    confirmed: function confirmed(val) {
      this.$root.confirm = {
        isVisible: false,
        title: '',
        question: '',
        caller: this.$root.confirm.caller,
        isConfirmed: val
      };
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);




var usersRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Users');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupCustomer',
  data: function data() {
    return {
      error: ''
    };
  },
  created: function created() {
    this.$Log("Vue [PopupCustomer] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupCustomer] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupCustomer] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupCustomer] is updated ...");
  },

  methods: {
    isValid: function isValid(callback) {
      var vm = this;
      if (vm.$parent.popup.data.FullName.trim().length <= 0) return callback(false);
      if (vm.$parent.popup.data.ContactPerson && vm.$parent.popup.data.ContactPerson.trim().length <= 0) return callback(false);
      if (vm.$parent.popup.data.Phone && vm.$parent.popup.data.Phone.trim().length <= 0) return callback(false);

      if (vm.$parent.popup.data.Username.trim().length <= 0) return callback(false);

      usersRef.orderByChild("Username").equalTo(vm.$parent.popup.data.Username.trim()).once('value').then(function (snapshot) {
        var obj = snapshot.val();
        if (obj) {
          var k = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj)[0];
          var usr = obj[k];
          if (usr.Type == 'רוכש') {
            callback(true);
          } else {
            callback("NO_USER");
          }
        } else {
          callback("NO_USER");
        }
      });
    },
    save: function save() {
      var vm = this;
      vm.error = "";
      vm.isValid(function (valid) {
        if (valid == true) {
          if (vm.$parent.popup.isEdit) {
            vm.$parent.update();
          } else {
            vm.$parent.insert();
          }
          vm.reset();
        } else if (valid == "NO_USER") {
          vm.error = " שם משתמש לא קיים !";
        } else {
          vm.error = "נא למלא את כל השדות!";
        }
      });
    },
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.error = "";
      this.$parent.popup = {
        isVisible: false,
        isEdit: false,
        title: '',
        data: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', TotalDiaries: 0, UsedDiaries: 0 }
      };
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);





var projectsRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Projects');
var usersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Users');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupDiary',
  data: function data() {
    return {
      error: '',
      txtSearchInspector: '',
      txtSearchObserver: '',
      txtSearchContractor: '',
      customers: [],

      projects: [],
      users: [],
      filteredInspectors: [],
      filteredContractors: [],
      filteredObservers: [],
      selectedInspectors: [],
      selectedContractors: [],
      selectedObservers: [],
      AddedUsers: {}
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      customers: usersRef.orderByChild("Type").equalTo("רוכש"),
      users: usersRef.orderByKey(),
      projects: vm.$root.isAdmin ? projectsRef.orderByKey() : projectsRef.orderByChild("UserKey").equalTo(vm.$root.user['.key'])
    };
  },
  created: function created() {
    this.$Log("Vue [PopupDiary] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupDiary] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupDiary] is mounted ...");
    this.refreshFiltered();
    this.refreshSelected();
  },
  updated: function updated() {
    this.$Log("Vue [PopupDiary] is updated ...");
  },

  computed: {},
  watch: {
    txtSearchInspector: function txtSearchInspector(val) {
      this.refreshFiltered();
    },
    txtSearchContractor: function txtSearchContractor(val) {
      this.refreshFiltered();
    },
    txtSearchObserver: function txtSearchObserver(val) {
      this.refreshFiltered();
    },
    '$parent.popup.isVisible': function $parentPopupIsVisible(val) {
      if (val) {
        this.refreshAddedUsers();
        this.refreshFiltered();
        this.refreshSelected();
      }
    }
  },
  methods: {
    refreshAddedUsers: function refreshAddedUsers() {
      var vm = this;

      for (var u = 0; u < vm.users.length; u++) {
        vm.users[u].IsSelected = false;
      }

      if (vm.$parent.popup.data.AddedUsers) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(vm.$parent.popup.data.AddedUsers);
        for (var k = 0; k < keys.length; k++) {
          var key = keys[k];
          console.log(">>>>>>>>>>>>  AddedUsers [key] = " + key);
          for (var u = 0; u < vm.users.length; u++) {

            console.log(vm.users[u]['.key'] + " == " + key + " [" + (vm.users[u]['.key'] == key) + "]");

            if (vm.users[u]['.key'] == key) {
              vm.users[u].IsConfirmed = vm.$parent.popup.data.AddedUsers[key].IsConfirmed;
              vm.users[u].IsSelected = true;
            }
          }
        }
      }

      for (var u = 0; u < vm.users.length; u++) {
        console.log(vm.users[u].FullName + " >>> " + vm.users[u]['.key'] + " >>> " + vm.users[u].IsSelected + " >>> ");
      }
    },
    refreshFiltered: function refreshFiltered() {
      this.filteredInspectors = this.filterUsers("מפקח", this.txtSearchInspector, false);
      this.filteredContractors = this.filterUsers("מנהל עבודה", this.txtSearchContractor, false);
      this.filteredObservers = this.filterUsers("משקיף", this.txtSearchObserver, false);
    },
    refreshSelected: function refreshSelected() {
      this.selectedInspectors = this.filterUsers("מפקח", "", true);
      this.selectedContractors = this.filterUsers("מנהל עבודה", "", true);
      this.selectedObservers = this.filterUsers("משקיף", "", true);
    },
    filterUsers: function filterUsers(type, searchTxt, selected) {
      var vm = this;
      var result = [];
      if (selected) {
        result = vm.users.filter(function (row) {
          if (row.Type == type && row.IsSelected) {
            console.log("filterUsers >>> " + type + " selected = " + selected);
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(row));
          }
          return row.Type == type && row.IsSelected;
        });
      } else if (searchTxt.length > 0) {
        var result = [];
        try {
          result = vm.users.filter(function (row) {
            if (row.Type == type && !row.IsSelected) {
              return row.Identity.trim().toLowerCase().indexOf(searchTxt.trim().toLowerCase()) > -1;
            }
          }).slice(0, 5);
        } catch (e) {
          result = [];
        }
      } else {
        result = [];
      }
      return result;
    },
    addUser: function addUser(item) {
      var vm = this;
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
      if (!this.$parent.popup.data.AddedUsers) {
        this.$parent.popup.data.AddedUsers = {};
      }
      var u = { IsConfirmed: false, UserKey: item['.key'] };
      var key = item['.key'];
      this.$parent.popup.data.AddedUsers[key] = { IsConfirmed: false, UserKey: item['.key'] };

      vm.users.find(function (usr) {
        if (usr['.key'] == key) {
          usr.IsSelected = true;
          return true;
        }
      });

      this.refreshFiltered();
      this.refreshSelected();
    },
    removeUser: function removeUser(item) {
      var vm = this;
      var key = item['.key'];
      delete this.$parent.popup.data.AddedUsers[key];
      vm.users.find(function (usr) {
        if (usr['.key'] == key) {
          usr.IsSelected = false;
          return true;
        }
      });

      this.refreshFiltered();
      this.refreshSelected();
    },
    setCustomerName: function setCustomerName() {
      for (var i = 0; i < this.customers.length; i++) {
        if (this.customers[i]['.key'] == this.$parent.popup.data.CustomerKey) {
          this.$parent.popup.data.CustomerName = this.customers[i].FullName;
          break;
        }
      }
    },
    setProjectName: function setProjectName() {
      for (var i = 0; i < this.projects.length; i++) {
        if (this.projects[i]['.key'] == this.$parent.popup.data.ProjectKey) {
          this.$parent.popup.data.ProjectName = this.projects[i].Name;
          break;
        }
      }
    },
    isValid: function isValid(callback) {
      if (this.$parent.popup.data.Title.trim().length <= 0) return callback(false);

      if (this.$parent.popup.data.CustomerKey == undefined) return callback(false);
      if (this.$parent.popup.data.CustomerKey.length <= 0) return callback(false);

      if (this.$parent.popup.data.ProjectKey.length <= 0) return callback(false);
      if (this.$parent.popup.data.Info.trim().length <= 0) return callback(false);


      callback(true);
    },
    save: function save() {

      var vm = this;
      vm.error = "";

      vm.isValid(function (valid) {
        if (valid == true) {
          if (vm.$parent.popup.isEdit) {
            vm.$parent.update();
          } else {
            vm.$parent.insert();
          }
          vm.reset();
        } else {
          vm.error = "נא למלא את כל השדות!";
        }
      });
    },
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.error = "";
      for (var u = 0; u < this.users.length; u++) {
        this.users[u].IsSelected = false;
      }

      this.txtSearchInspector = '';
      this.txtSearchObserver = '';
      this.txtSearchContractor = '';

      this.$parent.popup = {
        isVisible: false,
        isEdit: false,
        title: '',
        data: {
          '.key': '', Title: '',
          CustomerName: '',
          CustomerKey: '',
          ProjectName: '',
          ProjectKey: '',
          CreateDate: '',
          UpdateDate: '',
          SendToCustomer: false,
          SendToInspectors: false,
          SendToContractors: false,
          Info: '',
          AddedUsers: null
        }
      };
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupPackage',
  data: function data() {
    return {
      error: ''
    };
  },
  created: function created() {
    this.$Log("Vue [PopupPackage] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupPackage] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupPackage] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupPackage] is updated ...");
  },

  methods: {
    isValid: function isValid() {
      if (this.$parent.popup.data.Name.trim().length <= 0) return false;
      if (this.$parent.popup.data.Diaries <= 0) return false;
      if (this.$parent.popup.data.Price <= 0) return false;
      return true;
    },
    save: function save() {
      this.error = "";
      if (this.isValid()) {
        if (this.$parent.popup.isEdit) {
          this.$parent.update();
        } else {
          this.$parent.insert();
        }
        this.reset();
      } else {
        this.error = "נא למלא את כל השדות!";
      }
    },
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.error = "";
      this.$parent.popup = {
        isVisible: false,
        isEdit: false,
        title: '',
        data: { '.key': '', Name: '', Diaries: 0, Price: 0 }
      };
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



var usersRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Users');
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupPasswordReset',
  data: function data() {
    return {
      email: '',
      error: ''
    };
  },
  created: function created() {
    this.$Log("Vue [PopupPasswordReset] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupPasswordReset] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupPasswordReset] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupPasswordReset] is updated ...");
  },

  methods: {
    cancel: function cancel() {
      this.email = '';
      this.$parent.isPasswordReset = false;
    },
    sendPassword: function sendPassword() {
      var vm = this;
      if (vm.email.length > 0) {
        __WEBPACK_IMPORTED_MODULE_0__firebase__["c" /* auth */].sendPasswordResetEmail(vm.email).then(function () {
          vm.$root.alert.message = 'סיסמתך נשלחה למייל.';
        }, function (error) {
          vm.$root.alert.message = 'שליחת מייל נכשלה!';
        });

        vm.$parent.isPasswordReset = false;
        vm.$root.alert.isShow = true;
      } else {
        vm.error = "* נא הכנס כתובת מייל!";
      }
    },
    sendPasswordOLD: function sendPasswordOLD() {
      this.$parent.isPasswordReset = false;
      this.$root.alert.message = 'סיסמתך נשלחה למייל.';
      this.$root.alert.isShow = true;
    }
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_no_image_png__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_no_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_no_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);






var projectsRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Projects');
var plansRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Plans');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupPlan',
  data: function data() {
    return {
      error: '',
      selectedColor: '#ffffff',
      showFile: false,
      showProgress: false,
      logoUrl: '',
      activeImage: __WEBPACK_IMPORTED_MODULE_1__assets_no_image_png___default.a,
      hasImages: false,
      projects: []
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      projects: vm.$root.isAdmin ? projectsRef.orderByKey() : projectsRef.orderByChild("UserKey").equalTo(vm.$root.user['.key'])
    };
  },
  created: function created() {
    this.$Log("Vue [PopupPlan] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupPlan] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupPlan] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupPlan] is updated ...");
  },

  computed: {
    canEdit: function canEdit() {
      return true;
    },
    hasFiles: function hasFiles() {
      if (this.$parent.popup.data.Files != undefined && this.$parent.popup.data.Files.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    setProjectName: function setProjectName() {
      for (var i = 0; i < this.projects.length; i++) {
        if (this.projects[i]['.key'] == this.$parent.popup.data.ProjectKey) {
          this.$parent.popup.data.ProjectName = this.projects[i].Name;
          break;
        }
      }
    },
    setAddress: function setAddress(place) {
      this.$Log("setPlace(place) >>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(place));
      this.$parent.popup.data.Location = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    isValid: function isValid(callback) {
      if (this.$parent.popup.data.Name.trim().length <= 0) return false;
      if (this.$parent.popup.data.Info.trim().length <= 0) return false;
      if (this.$parent.popup.data.ProjectKey === undefined) return false;
      if (this.$parent.popup.data.ProjectName.trim().length <= 0) return false;
      if (this.$parent.popup.data.ProjectKey.trim().length <= 0) return false;

      return true;
    },
    save: function save() {
      var vm = this;
      vm.error = "";
      if (vm.isValid()) {
        if (vm.$parent.popup.isEdit) {
          vm.$parent.update();
        } else {
          vm.$parent.insert();
        }
        vm.reset();
      } else {
        vm.error = "נא למלא את כל השדות!";
      }
    },
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.error = "";
      this.$parent.popup = {
        isVisible: false,
        isEdit: false,
        title: '',
        data: {
          '.key': '',
          Name: '',
          Info: '',
          UserKey: '',
          ProjectKey: '',
          ProjectName: '',

          CreateDate: '',
          UpdateDate: ''
        }
      };
      this.activeImage = __WEBPACK_IMPORTED_MODULE_1__assets_no_image_png___default.a;
    },
    upload: function upload(e) {
      this.$emit('#fileUpload', e.target.files[0]);
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var vm = this;

      var file = files[0];
      var image = new Image();
      var reader = new FileReader();

      reader.onload = function (ev) {
        vm.logoUrl = ev.target.result;
      };
      reader.readAsDataURL(file);

      vm.showFile = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["d" /* storage */].ref('plans/' + file.name);

      var task = storageRef.put(file);

      vm.showProgress = true;

      task.on('state_changed', function progress(snap) {}, function error(err) {
        vm.showFile = false;
        vm.showProgress = false;
      }, function complete() {
        vm.showProgress = false;
        vm.logoUrl = task.snapshot.downloadURL;
        vm.$parent.popup.data.Images.push(task.snapshot.downloadURL);
        if (vm.activeImage == __WEBPACK_IMPORTED_MODULE_1__assets_no_image_png___default.a) {
          vm.activeImage = vm.$parent.popup.data.Images[0];
        }
      });
    },
    removeImage: function removeImage() {}
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_no_image_png__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_no_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_no_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(3);







var projectsRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* db */].ref('Projects');
var usersRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* db */].ref('Users');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupProject',
  components: { Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      txtSearchEntrepreneur: '',
      entrepreneurs: [],
      error: '',
      selectedColor: '#ffffff',
      showFile: false,
      showProgress: false,
      logoUrl: '',
      activeImage: __WEBPACK_IMPORTED_MODULE_2__assets_no_image_png___default.a,
      startDate: '',
      endDate: ''
    };
  },

  firebase: function firebase() {
    return {
      entrepreneurs: usersRef.orderByChild("Type").equalTo("יזם")
    };
  },
  created: function created() {
    this.$Log("Vue [PopupProject] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupProject] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupProject] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupProject] is updated ...");
    var vm = this;
    if (this.$parent.statuses != null) {
      for (var i = 0; i < this.$parent.statuses.length; i++) {
        if (this.$parent.statuses[i]['.key'] == this.$parent.popup.data.StatusKey) {
          this.selectedColor = this.$parent.statuses[i].Color;
          break;
        }
      }
    }

    if (vm.$parent.popup.data.Address == '') {
      vm.$GetPlaceName(vm.$parent.popup.data.Location, function (placeName) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(placeName));
        if (placeName.success) {
          vm.$parent.popup.data.Address = placeName.data.formatted_address;
          vm.$parent.popup.data.Address = vm.$parent.popup.data.Address.replace("Unnamed Road,", "");
        } else {
          vm.$parent.popup.data.Address = '';
          var gmapAddress = document.getElementById("gmapAddress").value = '';
          if (gmapAddress) {
            gmapAddress.value = '';
          }
        }
      });
    }


    if (this.$parent.popup.data.Images == undefined) {
      this.$parent.popup.data.Images = [];
      this.activeImage = __WEBPACK_IMPORTED_MODULE_2__assets_no_image_png___default.a;
    } else {
      if (this.$parent.popup.data.Images.length > 0) {
        if (this.activeImage == __WEBPACK_IMPORTED_MODULE_2__assets_no_image_png___default.a) {
          this.activeImage = this.$parent.popup.data.Images[0];
        }
      }
    }
  },

  computed: {
    canEdit: function canEdit() {
      return true;
    },
    hasImages: function hasImages() {
      if (this.$parent.popup.data.Images != undefined && this.$parent.popup.data.Images.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    filteredEntrepreneurs: function filteredEntrepreneurs() {
      var vm = this;
      var result = [];

      if (vm.txtSearchEntrepreneur.length > 0) {
        var result = [];
        try {
          result = vm.entrepreneurs.filter(function (row) {
            return row.FullName.trim().toLowerCase().indexOf(vm.txtSearchEntrepreneur.trim().toLowerCase()) > -1;
          }).slice(0, 5);
        } catch (e) {
          result = [];
        }
      } else {
        result = [];
      }

      return result;
    }
  },
  methods: {
    selectEntrepreneur: function selectEntrepreneur(item) {
      this.txtSearchEntrepreneur = "";
      this.$parent.popup.data.Entrepreneur = { UserKey: item['.key'], FullName: item.FullName };
    },
    removeEntrepreneur: function removeEntrepreneur() {
      this.txtSearchEntrepreneur = "";
      this.$parent.popup.data.Entrepreneur = { UserKey: '', FullName: '' };
    },
    setAddress: function setAddress(place) {
      this.$Log("setPlace(place) >>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(place));
      this.$parent.popup.data.Location = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    isValid: function isValid(callback) {
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$parent.popup.data));
      if (this.$parent.popup.data.Name.trim().length <= 0) {
        this.$Log("Missing Name !");return false;
      }
      if (this.$parent.popup.data.City.trim().length <= 0) {
        this.$Log("Missing City !");return false;
      }
      if (this.$parent.popup.data.Address.trim().length <= 0) {
        this.$Log("Missing Address !");return false;
      }
      if (this.$parent.popup.data.Info.trim().length <= 0) {
        this.$Log("Missing Info !");return false;
      }
      if (this.$parent.popup.data.StatusKey.trim().length <= 0) {
        this.$Log("Missing StatusKey !");return false;
      }
      if (this.$parent.popup.data.Location.lat == 0) {
        this.$Log("Missing Location.lat !");return false;
      }
      if (this.$parent.popup.data.Location.lng == 0) {
        this.$Log("Missing Location.lng !");return false;
      }
      if (this.$parent.popup.data.StartDate == undefined || this.$parent.popup.data.StartDate <= 0) {
        this.$Log("Missing StartDate !");return false;
      }
      if (this.$parent.popup.data.EndDate == undefined || this.$parent.popup.data.EndDate <= 0) {
        this.$Log("Missing EndDate !");return false;
      }

      return true;
    },
    save: function save() {
      var vm = this;
      vm.error = "";

      vm.$parent.popup.data.Location = { lat: 32.699635, lng: 35.303546 };
      console.log(vm.$parent.popup.data);
      var valid = vm.isValid();
      if (valid == true) {
        if (vm.$parent.popup.isEdit) {
          console.log(vm.$parent);
          vm.$parent.update();
        } else {
          vm.$parent.insert();
        }
        vm.reset();
      } else if (valid == "NO_USER") {
        vm.error = "שם משתמש לא קיים !";
      } else {
        vm.error = "נא למלא את כל השדות!";
      }
    },
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.error = "";
      this.$parent.popup = {
        isVisible: false,
        isEdit: false,
        title: '',
        data: {
          '.key': '',
          Name: '',
          City: '',
          Address: '',
          Location: { lat: 0, lng: 0 },
          Info: '',
          StatusKey: 0,
          UserKey: '',
          Active: true,
          Images: [],
          CreateDate: '',
          UpdateDate: '',
          StartDate: '',
          EndDate: '',
          Entrepreneur: { UserKey: '', FullName: '' }
        }
      };
      this.activeImage = __WEBPACK_IMPORTED_MODULE_2__assets_no_image_png___default.a;
    },
    upload: function upload(e) {
      this.$emit('#fileUpload', e.target.files[0]);
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var vm = this;

      var file = files[0];
      var image = new Image();
      var reader = new FileReader();

      reader.onload = function (ev) {
        vm.logoUrl = ev.target.result;
      };
      reader.readAsDataURL(file);

      vm.showFile = true;

      var storageRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["d" /* storage */].ref('images/' + file.name);

      var task = storageRef.put(file);

      vm.showProgress = true;

      task.on('state_changed', function progress(snap) {}, function error(err) {
        vm.showFile = false;
        vm.showProgress = false;
      }, function complete() {
        vm.showProgress = false;
        vm.logoUrl = task.snapshot.downloadURL;
        vm.$parent.popup.data.Images.push(task.snapshot.downloadURL);
        if (vm.activeImage == __WEBPACK_IMPORTED_MODULE_2__assets_no_image_png___default.a) {
          vm.activeImage = vm.$parent.popup.data.Images[0];
        }
      });
    },
    removeImage: function removeImage() {}
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



var usersRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Users');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupRegister',
  data: function data() {
    return {
      selectedType: "",
      userTypes: ['רוכש', 'מנהל עבודה', 'מפקח', 'משקיף'],
      error: '',
      FullName: '',
      Username: '',
      ContactPerson: '',
      Phone: '',
      Identity: '',
      Type: '',
      Password: '',
      PasswordConfirm: ''
    };
  },
  created: function created() {
    this.$Log("Vue [PopupRegister] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupRegister] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupRegister] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupRegister] is updated ...");
  },

  computed: {
    isCustomer: function isCustomer() {
      return this.selectedType == 'רוכש';
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.FullName.trim().length <= 0) {
        this.error = "נא הכנס שם מלא!";return false;
      }
      if (this.Username.trim().length <= 0) {
        this.error = "נא הכנס שם משתמש!";return false;
      }
      if (this.Identity.trim().length <= 0) {
        this.error = "נא הכנס שם תעודת זהות!";return false;
      }
      if (this.Type.trim().length <= 0) {
        this.error = "נא בחר סוג חשבון!";return false;
      }
      if (this.Password.trim().length <= 0) {
        this.error = "נא הכנס שם סיסמה!";return false;
      }
      if (this.Password.trim() != this.PasswordConfirm.trim()) {
        this.error = "אימות סיסמה נכשל!";return false;
      }
      return true;
    },
    signup: function signup() {
      var vm = this;
      if (vm.isValid()) {
        var user = {
          FullName: vm.FullName,
          Username: vm.Username.toLowerCase(),
          Identity: vm.Identity,
          Type: vm.Type,
          Password: vm.Password,
          TotalDiaries: 0,
          UsedDiaries: 0,
          MessagesCounter: 0,
          ContactPerson: '',
          Active: true,
          Approved: false
        };

        usersRef.orderByChild("Username").equalTo(vm.Username.toLowerCase()).once('value').then(function (snapshot) {
          var obj = snapshot.val();
          if (obj) {
            vm.error = "שם משתמש קיים במערכת! נא לבחור שם משתמש אחר!";
          } else {
            usersRef.push(user);
            vm.reset();
          }
        });
      } else {
        alert(vm.error);
      }
    },
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.error = "";
      this.$parent.isRegister = false;
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_color__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupStatus',
  components: { 'ColorPicker': __WEBPACK_IMPORTED_MODULE_0_vue_color__["Compact"] },
  data: function data() {
    return {
      error: '',
      colors: { hex: "#000000" }
    };
  },
  created: function created() {
    this.$Log("Vue [PopupStatus] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupStatus] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupStatus] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupStatus] is updated ...");
  },

  methods: {
    isValid: function isValid() {
      if (this.$parent.popup.data.Name.trim().length <= 0) return false;
      if (this.$parent.popup.data.Color.trim().length <= 0) return false;
      return true;
    },
    save: function save() {
      this.error = "";

      this.$parent.popup.data.Color = this.$parent.popup.colors.hex;
      if (this.isValid()) {
        if (this.$parent.popup.isEdit) {
          this.$parent.update();
        } else {
          this.$parent.insert();
        }
        this.reset();
      } else {
        this.error = "נא למלא את כל השדות!";
      }
    },
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.error = "";
      this.$parent.popup = {
        isVisible: false,
        isEdit: false,
        title: '',
        data: { '.key': '', Name: '', Color: '#000000' }
      };
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PopupUser',
  data: function data() {
    return {
      error: ''
    };
  },
  created: function created() {
    this.$Log("Vue [PopupUser] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [PopupUser] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [PopupUser] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [PopupUser] is updated ...");
  },

  computed: {
    isEntrepreneur: function isEntrepreneur() {
      return this.$parent.popup.data.Type == "יזם";
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.$parent.popup.data.FullName.trim().length <= 0) return false;
      if (!this.isEntrepreneur && this.$parent.popup.data.Username.trim().length <= 0) return false;
      if (this.$parent.popup.data.Identity.trim().length <= 0) return false;
      if (this.$parent.popup.data.Type.trim().length <= 0) return false;
      if (!this.isEntrepreneur && this.$parent.popup.data.Password.trim().length <= 0) return false;
      return true;
    },
    save: function save() {
      this.error = "";
      if (this.isValid()) {
        if (this.$parent.popup.isEdit) {
          this.$parent.update();
        } else {
          this.$parent.insert();
        }
        this.reset();
      } else {
        this.error = "נא למלא את כל השדות!";
      }
    },
    cancel: function cancel() {
      this.reset();
    },
    reset: function reset() {
      this.error = "";
      this.$parent.popup = {
        isVisible: false,
        isEdit: false,
        title: '',
        data: { '.key': '', Name: '', Diaries: 0, Price: 0 }
      };
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recordrtc__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recordrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recordrtc__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isRecording: false,
      audioRecorder: null,
      blob: null
    };
  },

  methods: {
    startRecording: function startRecording() {
      var vm = this;
      vm.$parent.isRecording = true;
      var mediaConstraints = { video: false, audio: true };
      navigator.mediaDevices.getUserMedia(mediaConstraints).then(function (audioStream) {
        vm.audioStream = audioStream;
        vm.isRecording = true;
        vm.audioRecorder = __WEBPACK_IMPORTED_MODULE_1_recordrtc___default()(audioStream, { type: 'audio' });
        vm.audioRecorder.startRecording();
      }).catch(function (err) {
        vm.$root.alert.message = vm.$t('audioErrorSSL');
        vm.$root.alert.isShow = true;
      });
    },
    stopRecording: function stopRecording() {
      var vm = this;
      vm.audioRecorder.stopRecording(function (singleWebM) {
        vm.isRecording = false;
        vm.blob = vm.audioRecorder.getBlob();
        vm.uploadAudio(vm.blob);
        vm.audioStream.getTracks()[0].stop();
      });
    },
    uploadAudio: function uploadAudio(blob) {
      var vm = this;
      var filename = vm.$moment().format('YYYYMMDDHHmmss') + '.mp3';
      var file = new File([blob], filename, { type: 'audio/webm' });
      var storageRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["d" /* storage */].ref('Records/' + file.name);
      var task = storageRef.put(file);
      task.on('state_changed', function progress(snap) {}, function error(err) {
        vm.$parent.audioObj = "ERROR";
      }, function complete() {
        vm.$parent.audioObj = { Type: "Record", FileName: file.name, FileUrl: task.snapshot.downloadURL };
      });
    }
  },
  destroyed: function destroyed() {
    try {
      this.$Log("destroyed recorder ....");
      this.stopRecording();
    } catch (e) {}
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);




var usersRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Users');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportCustomers',
  data: function data() {
    return {};
  },

  firebase: function firebase() {
    var vm = this;
    return {
      users: usersRef.orderByChild("Type").equalTo("רוכש")
    };
  },
  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.$parent.txtSearch.length > 0) {
        var result = [];
        try {
          var rowsCount = 0;
          result = vm.users.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                rowsCount++;
                return row;
              }
            });
          });
        } catch (e) {}
      } else {
        var result = vm.users;
      }

      return result;
    }
  },
  created: function created() {
    this.$Log("Vue [ReportCustomers] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [ReportCustomers] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [ReportCustomers] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [ReportCustomers] is updated ...");
  },

  methods: {
    getStatusColor: function getStatusColor(statusKey) {
      var selectedColor = '#F7941D';
      for (var i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i]['.key'] == statusKey) {
          selectedColor = this.statuses[i].Color;
          break;
        }
      }
      return selectedColor;
    },
    getStatusName: function getStatusName(statusKey) {
      var selectedName = '';
      for (var i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i]['.key'] == statusKey) {
          selectedName = this.statuses[i].Name;
          break;
        }
      }
      return selectedName;
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);





var diariesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Diaries');
var diaryPagesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('DiaryPages');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportDiaries',
  data: function data() {
    return {
      diaries: [],
      diaryPages: []
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      diaries: diariesRef.orderByKey(),
      diaryPages: diaryPagesRef.orderByKey()
    };
  },
  computed: {},
  created: function created() {
    this.$Log("Vue [ReportDiaries] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [ReportDiaries] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [ReportDiaries] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [ReportDiaries] is updated ...");
  },

  methods: {
    getNotesArr: function getNotesArr(page) {
      var notes = [];
      if (page && page.Notes) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(page.Notes);
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          var note = page.Notes[k];
          note['.key'] = k;
          notes.push(note);
        }
      }

      return notes;
    },
    pageSelected: function pageSelected(page) {

      var pageObj = {
        Date: page.Date,
        PageKey: page['.key']
      };

      var diaryRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Diaries/' + page.selectedDiaryKey + '/Pages');
      alert('Diaries/' + page.selectedDiaryKey + '/Pages');
      alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(pageObj));

      diaryRef.push(pageObj);
    },
    deleteNote: function deleteNote(page, note) {
      var noteRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('DiaryPages/' + page['.key'] + '/Notes/' + note['.key']);

      noteRef.remove();
    },
    deletePage: function deletePage(page) {
      var diaryPageRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('DiaryPages/' + page['.key']);

      diaryPageRef.remove();
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



var projectsRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Projects');
var statusesRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Statuses');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportProjects',
  data: function data() {
    return {
      selectedStatus: '',
      selectedLastUpdate: '',
      updatesList: [{ Value: 30, Text: '30 ימים' }, { Value: 60, Text: '60 ימים' }, { Value: 90, Text: '90 ימים' }, { Value: 180, Text: '6 חודשים' }, { Value: 365, Text: '12 חודשים' }]
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      projects: projectsRef.orderByKey(),
      statuses: statusesRef.orderByKey()
    };
  },
  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      var result = [];
      var today = this.$moment();


      if (vm.selectedStatus != "") {
        if (vm.selectedLastUpdate != "") {
          result = vm.projects.filter(function (row) {
            if (row.StatusKey == vm.selectedStatus) {
              var updateDate = vm.$moment(row.UpdateDate, 'DD/MM/YYYY');
              var duration = vm.$moment.duration(today.diff(updateDate));
              var days = duration.asDays();
              return days >= vm.selectedLastUpdate;
            } else {
              return false;
            }
          });
        } else {
          result = vm.projects.filter(function (row) {
            return row.StatusKey == vm.selectedStatus;
          });
        }
      } else {
        if (vm.selectedLastUpdate != "") {
          result = vm.projects.filter(function (row) {
            var updateDate = vm.$moment(row.UpdateDate, 'DD/MM/YYYY');
            var duration = vm.$moment.duration(today.diff(updateDate));
            var days = duration.asDays();

            return days >= vm.selectedLastUpdate;
          });
        } else {
          result = vm.projects;
        }
      }

      return result;
    }
  },
  created: function created() {
    this.$Log("Vue [ReportProjects] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [ReportProjects] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [ReportProjects] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [ReportProjects] is updated ...");
  },

  methods: {
    getStatusColor: function getStatusColor(statusKey) {
      var selectedColor = '#F7941D';
      for (var i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i]['.key'] == statusKey) {
          selectedColor = this.statuses[i].Color;
          break;
        }
      }
      return selectedColor;
    },
    getStatusName: function getStatusName(statusKey) {
      var selectedName = '';
      for (var i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i]['.key'] == statusKey) {
          selectedName = this.statuses[i].Name;
          break;
        }
      }
      return selectedName;
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Logo__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'subMenu',
  components: { Logo: __WEBPACK_IMPORTED_MODULE_1__components_Logo___default.a },
  data: function data() {
    return {
      menu: [{ title: "יומנים", icon: 'assignment', page: 'Diaries', adminOnly: true, customerOnly: true, userOnly: true }, { title: "פרויקטים", icon: 'business_center', page: 'Projects', adminOnly: true, customerOnly: true, userOnly: false }, { title: "תוכניות בנייה", icon: 'picture_as_pdf', page: 'Plans', adminOnly: true, customerOnly: true, userOnly: false }, { title: "לקוחות", icon: 'recent_actors', page: 'Customers', adminOnly: true, customerOnly: false, userOnly: false }, { title: "מנהלי עבודה", icon: 'streetview', page: 'Contractors', adminOnly: true, customerOnly: true, userOnly: false }, { title: "מפקחים", icon: 'record_voice_over', page: 'Inspectors', adminOnly: true, customerOnly: true, userOnly: false }, { title: "משקיפים", icon: 'remove_red_eye', page: 'Observers', adminOnly: true, customerOnly: true, userOnly: false }, { title: "יזמים", icon: 'local_atm', page: 'Entrepreneurs', adminOnly: true, customerOnly: false, userOnly: false }, { title: "משתמשים", icon: 'group', page: 'Users', adminOnly: true, customerOnly: false, userOnly: false }, { title: "דוחות", icon: 'equalizer', page: 'Reports', adminOnly: true, customerOnly: false, userOnly: false }, { title: "הודעות", icon: 'chat', page: 'Messages', adminOnly: false, customerOnly: false, userOnly: true }, { title: "הגדרות חשבון", icon: 'person', page: 'MyAccount', adminOnly: false, customerOnly: true, userOnly: true }, { title: "הגדרות", icon: 'settings', page: 'Settings', adminOnly: true, customerOnly: false, userOnly: false }]
    };
  },
  created: function created() {
    this.$Log("Vue [subMenu] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [subMenu] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [subMenu] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [subMenu] is updated ...");
  },

  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'Logout') {
        this.$root.logout();
      }
    }
  },
  methods: {
    showBadge: function showBadge(item) {
      if (item.page == 'Messages') {
        return this.$root.messagesCounter > 0;
      } else {
        return false;
      }
    },
    canRead: function canRead(item) {
      if (this.$root.user) {
        if (this.$root.user.Type === 'מנהל מערכת') {
          return item.adminOnly;
        } else if (this.$root.user.Type == 'רוכש') {
          return item.customerOnly;
        } else {
          return item.userOnly;
        }
      } else {
        return item.userOnly;
      }
    },
    menuClick: function menuClick(item) {
      this.$Log("Clicked item  >>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
      this.$router.push({ name: item.page });
    },
    confirmSignout: function confirmSignout() {
      this.$root.confirm = {
        isVisible: true,
        title: 'יציאה',
        question: 'האם אתה בטוח ברצונך לצאת מהמערכת?',
        caller: 'Logout',
        isConfirmed: false
      };
    }
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopupPackage__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopupPackage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PopupPackage__);



var packagesRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Packages');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TablePackages',
  components: { PopupPackage: __WEBPACK_IMPORTED_MODULE_1__PopupPackage___default.a },
  data: function data() {
    return {
      packages: [],
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', Name: '', Diaries: 0, Price: 0 }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      packages: packagesRef.orderByKey()
    };
  },
  created: function created() {
    this.$Log("Vue [TablePackages] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [TablePackages] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [TablePackages] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [TablePackages] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.packages != null && this.packages != undefined && this.packages.length > 0;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemovePackage') {
        this.remove();
      }
    }
  },
  methods: {
    currency: function currency(N) {
      N = parseFloat(N);
      if (!isNaN(N)) N = N.toFixed(2);else N = '0.00';
      return N + " ₪";
    },
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'חבילה חדשה',
        data: { '.key': '', Name: '', Diaries: 0, Price: 0 }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת חבילה',
        data: { '.key': row['.key'], Name: row.Name, Diaries: row.Diaries, Price: row.Price }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemovePackage',
        isConfirmed: false
      };
    },
    remove: function remove() {
      packagesRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var item = { Name: this.popup.data.Name, Diaries: this.popup.data.Diaries, Price: this.popup.data.Price };
      packagesRef.push(item);
    },
    update: function update() {
      var item = { Name: this.popup.data.Name, Diaries: this.popup.data.Diaries, Price: this.popup.data.Price };
      packagesRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_no_image_png__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_no_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_no_image_png__);



var projectsRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Projects');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableProjects',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$Log("Vue [TableProjects] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [TableProjects] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [TableProjects] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [TableProjects] is updated ...");
  },

  methods: {
    imageError: function imageError(row) {
      row.Images[0] = __WEBPACK_IMPORTED_MODULE_1__assets_no_image_png___default.a;
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



var settingsRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Settings');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableSettings',
  data: function data() {
    return {
      settings: [],
      isEdit: false
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      settings: settingsRef.orderByKey()
    };
  },
  created: function created() {
    this.$Log("Vue [TableSettings] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [TableSettings] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [TableSettings] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [TableSettings] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.settings != null && this.settings != undefined && this.settings.length > 0;
    }
  },
  methods: {}
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopupStatus__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopupStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PopupStatus__);



var statusesRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Statuses');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableStatuses',
  components: { PopupStatus: __WEBPACK_IMPORTED_MODULE_1__PopupStatus___default.a },
  data: function data() {
    return {
      statuses: [],
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', Name: '', Color: '#FF0000' },
        colors: { hex: "#000000" }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      statuses: statusesRef.orderByKey()
    };
  },
  created: function created() {
    this.$Log("Vue [TableStatuses] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [TableStatuses] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [TableStatuses] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [TableStatuses] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.statuses != null && this.statuses != undefined && this.statuses.length > 0;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveStatus') {
        this.remove();
      }
    }
  },
  methods: {
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'סטטוס חדש',
        data: { '.key': '', Name: '', Color: '#000000' },
        colors: { hex: "#000000" }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת סטטוס',
        data: { '.key': row['.key'], Name: row.Name, Color: row.Color },
        colors: { hex: row.Color }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveStatus',
        isConfirmed: false
      };
    },
    remove: function remove() {
      statusesRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var item = { Name: this.popup.data.Name, Color: this.popup.data.Color };
      statusesRef.push(item);
    },
    update: function update() {
      var item = { Name: this.popup.data.Name, Color: this.popup.data.Color };
      statusesRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_user_png__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_user_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_user_png__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Customers',
  data: function data() {
    return {
      txtSearch: '',
      isDelete: false,
      isEdit: false,
      isNew: false,
      selectedRow: {
        customerId: 0,
        customerApiKey: "",
        clubName: "",
        address: "",
        logo: "",
        banner: "",
        expiredDate: "",
        expiredDateStr: ""
      }
    };
  },
  created: function created() {
    this.$Log("Vue [Customers] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Customers] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Customers] is mounted ...");
    var vm = this;
    vm.$GetCustomers(vm, function (result) {
      vm.$Log("$GetCustomers result >> " + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(result));
      if (result.success) {
        if (result.data != "null") {
          vm.$root.customersList = JSON.parse(result.data);
        } else {
          vm.error = "Login failed! Wrong username or password!";
        }
      } else {
        vm.error = "Login failed! Wrong username or password!";
      }
    });
  },
  updated: function updated() {
    this.$Log("Vue [Customers] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    showForm: function showForm() {
      return this.isEdit || this.isNew;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          var rowsCount = 0;
          result = vm.$root.customersList.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (key != "logo") {
                if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                  rowsCount++;
                  return row;
                }
              }
            });
          });
        } catch (e) {}
      } else {
        var result = vm.$root.customersList;
      }

      return result;
    }
  },
  methods: {
    selectFile: function selectFile(e) {
      var vm = this;

      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        vm.file = null;
      } else {
        var fileType = files[0].name.split('.').pop();
        if (fileType.toLowerCase() == 'png' || fileType.toLowerCase() == 'jpg' || fileType.toLowerCase() == 'jpeg') {
          vm.file = files[0];
          var reader = new FileReader();
          reader.onload = function (ev) {
            vm.imgAccountAvt = ev.target.result;
          };
          reader.readAsDataURL(vm.file);
        } else {
          vm.file = null;
          vm.$root.alert.message = 'Please select image only (*.jpg/*.jpeg/*.png)!!';
          vm.$root.alert.isShow = true;
        }
      }
    },
    edit: function edit(row) {
      this.selectedRow = row;
      this.selectedRow = {
        customerId: row.customerId,
        customerApiKey: row.customerApiKey,
        clubName: row.clubName,
        address: row.address,
        logo: row.logo,
        banner: row.banner,
        expiredDate: row.expiredDate,
        expiredDateStr: row.expiredDateStr
      };
      this.isEdit = true;
    },
    confirm: function confirm(row) {
      this.selectedRow = {
        customerId: row.customerId,
        customerApiKey: row.customerApiKey,
        clubName: row.clubName,
        address: row.address,
        logo: row.logo,
        banner: row.banner,
        expiredDate: row.expiredDate,
        expiredDateStr: row.expiredDateStr
      };
      this.isDelete = true;
    },
    remove: function remove() {},
    cancel: function cancel() {
      this.selectedRow = {
        customerId: 0,
        customerApiKey: "",
        clubName: "",
        address: "",
        logo: "",
        banner: "",
        expiredDate: "",
        expiredDateStr: ""
      };
    },
    uploadImage: function uploadImage(vm, accountId, callback) {
      var uploadData = new FormData();
      uploadData.append("accountId", accountId);
      uploadData.append("file", vm.file);

      vm.$UploadAccountImage(uploadData, function (uploadResult) {
        callback(uploadResult);
      });
    },
    isValid: function isValid(isNew) {
      if (this.account.email != undefined) {
        if (this.account.email.trim().length == 0) {
          this.$root.alert.message = this.$t('missingEmail');
          this.$root.alert.isShow = true;
          return false;
        }
      } else {
        this.account.email = "";
      }

      if (isNew) {
        if (this.account.communityId != undefined) {
          this.account.communityId = this.account.communityId + "";
          if (this.account.communityId.trim().length == 0) {
            this.$root.alert.message = this.$t('missingCommunity');
            this.$root.alert.isShow = true;
            return false;
          }
        } else {
          this.account.communityId = "";
          this.$root.alert.message = this.$t('missingCommunity');
          this.$root.alert.isShow = true;
          return false;
        }
      }

      if (this.account.name != undefined) {
        if (this.account.name.trim().length == 0) {
          this.$root.alert.message = this.$t('missingName');
          this.$root.alert.isShow = true;
          return false;
        }
      } else {
        this.account.name = "";
        this.$root.alert.message = this.$t('missingName');
        this.$root.alert.isShow = true;
        return false;
      }

      return true;
    },
    reset: function reset() {
      this.title = "";
      this.activeTab = 'tab1';
      this.placeIndex = -1;
      this.selectedTab = null;
      this.places = [];
      this.cities = [];
      this.account = {
        name: '',
        email: '',
        communityId: '',
        description: '',
        language: '',
        places: [],
        cities: [],
        joinKey: '',
        invitationTypes: []
      };
    }
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupUser__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PopupUser__);





var usersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Users');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Contractors',
  components: { PopupUser: __WEBPACK_IMPORTED_MODULE_3__components_PopupUser___default.a },
  data: function data() {
    return {
      txtSearch: '',
      users: [],
      contractors: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'מנהל עבודה', Password: '', Active: false, Approved: false }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      users: usersRef.orderByChild("Type").equalTo("מנהל עבודה")
    };
  },
  created: function created() {
    this.$Log("Vue [Contractors] is created ...");
    var vm = this;
    if (!vm.$root.isAdmin) {
      vm.loadMyContractors();
    }
  },
  ready: function ready() {
    this.$Log("Vue [Contractors] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Contractors] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Contractors] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.$root.isAdmin) {
        return vm.filteredRowsWithPermission(vm.users);
      } else {
        return vm.filteredRowsWithPermission(vm.contractors);
      }
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveUser') {
        this.remove();
      }
    }
  },
  methods: {
    filteredRowsWithPermission: function filteredRowsWithPermission(usersArr) {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = usersArr.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                if (vm.isActiveUsers) {
                  if (row.Active) {
                    return row;
                  }
                } else {
                  return row;
                }
              }
            });
          });
        } catch (e) {}
      } else {
        if (vm.isActiveUsers) {
          result = usersArr.filter(function (row) {
            if (row.Active) {
              return row;
            }
          });
        } else {
          result = usersArr;
        }
      }

      return result;
    },
    loadMyContractors: function loadMyContractors() {
      var vm = this;
      vm.contractors = [];
      var customerKey = vm.$root.user['.key'];
      var diariesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Diaries');
      diariesRef.orderByChild("CustomerKey").equalTo(customerKey).once('value').then(function (snapshot) {
        var obj = snapshot.val();
        if (obj) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);

          var _loop = function _loop() {
            var key = keys[i];
            var diary = obj[key];
            console.log("diary >>>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(diary));
            if (diary.AddedUsers && diary.AddedUsers.length > 0) {
              var _loop2 = function _loop2() {
                var user = vm.users.find(function (usr) {
                  return usr['.key'] == diary.AddedUsers[u].UserKey;
                });

                if (user) {
                  var userExist = vm.contractors.find(function (exist) {
                    return exist['.key'] == user['.key'];
                  });
                  if (!userExist) {
                    vm.contractors.push(user);
                  }
                }
              };

              for (u = 0; u < diary.AddedUsers.length; u++) {
                _loop2();
              }
            }
          };

          for (var i = 0; i < keys.length; i++) {
            var u;

            _loop();
          }
        }
      });
    },
    currency: function currency(N) {
      N = parseFloat(N);
      if (!isNaN(N)) N = N.toFixed(2);else N = '0.00';
      return N + " ₪";
    },
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'מנהל עבודה חדש',
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'מנהל עבודה', Password: '', Active: false, Approved: false }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת מנהל עבודה',
        data: {
          '.key': row['.key'],
          FullName: row.FullName,
          Username: row.Username,
          Identity: row.Identity,
          Type: row.Type,
          Password: row.Password,
          Active: row.Active,
          Approved: row.Approved
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveUser',
        isConfirmed: false
      };
    },
    remove: function remove() {
      usersRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var vm = this;

      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };

      usersRef.push(item);
    },
    update: function update() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };
      usersRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PopupCustomer__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PopupCustomer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PopupCustomer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupAddDiaries__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupAddDiaries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PopupAddDiaries__);




var usersRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Users');



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Customers',
  components: { PopupCustomer: __WEBPACK_IMPORTED_MODULE_2__components_PopupCustomer___default.a, PopupAddDiaries: __WEBPACK_IMPORTED_MODULE_3__components_PopupAddDiaries___default.a },
  data: function data() {
    return {
      txtSearch: '',
      customers: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', Password: '', TotalDiaries: 0, UsedDiaries: 0 }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      users: usersRef.orderByChild("Type").equalTo("רוכש")
    };
  },
  created: function created() {
    this.$Log("Vue [Customers] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Customers] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Customers] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Customers] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = vm.users.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                if (vm.isActiveUsers) {
                  if (row.Active) {
                    return row;
                  }
                } else {
                  return row;
                }
              }
            });
          });
        } catch (e) {}
      } else {
        result = vm.users;
      }

      return result;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveUser') {
        this.remove();
      }
    },
    '$root.confirmAddDiaries.isConfirmed': function $rootConfirmAddDiariesIsConfirmed(val) {
      if (val) {
        var totalDieries = Number(this.$root.confirmAddDiaries.totalDiaries);
        if (this.popup.data.TotalDiaries) {
          totalDieries += Number(this.popup.data.TotalDiaries);
        }
        usersRef.child(this.popup.data['.key']).child("TotalDiaries").set(totalDieries);
      }
    }
  },
  methods: {
    currency: function currency(N) {
      N = parseFloat(N);
      if (!isNaN(N)) N = N.toFixed(2);else N = '0.00';
      return N + " ₪";
    },
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'לקוח חדש',
        data: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', Password: '', TotalDiaries: 0, UsedDiaries: 0 }
      };
    },
    addDiaries: function addDiaries(row) {
      this.popup.data = row;
      this.$root.confirmAddDiaries = {
        isVisible: true,
        totalDiaries: 1,
        isConfirmed: false
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת לקוח',
        data: {
          '.key': row['.key'],
          FullName: row.FullName,
          ContactPerson: row.ContactPerson,
          Phone: row.Phone,
          Username: row.Username,
          Password: row.Password,
          TotalDiaries: row.TotalDiaries,
          UsedDiaries: row.UsedDiaries
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveUser',
        isConfirmed: false
      };
    },
    remove: function remove() {
      usersRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {

      var item = {
        FullName: this.popup.data.FullName,
        ContactPerson: this.popup.data.ContactPerson ? this.popup.data.ContactPerson : '',
        Phone: this.popup.data.Phone ? this.popup.data.Phone : '',
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved,
        TotalDiaries: 10,
        UsedDiaries: 0 };

      usersRef.push(item);
    },
    update: function update() {

      var item = {
        FullName: this.popup.data.FullName,
        ContactPerson: 'ttt',
        Phone: 'ttt',
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved,
        TotalDiaries: 10,
        UsedDiaries: 0 };

      usersRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupDiary__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupDiary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PopupDiary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_no_image_png__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_no_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_no_image_png__);





var diariesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Diaries');
var diariesUsersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Diaries');
var customersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Customers');
var statusesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Statuses');
var projectsRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Projects');
var messagesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Messages');




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Diaries',
  components: { PopupDiary: __WEBPACK_IMPORTED_MODULE_3__components_PopupDiary___default.a },
  data: function data() {
    return {
      txtSearch: '',
      isLoading: false,
      diaries: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        isEdit: false,
        title: '',
        data: {
          '.key': '', Title: '',
          CustomerName: '',
          CustomerKey: '',
          ProjectName: '',
          ProjectKey: '',
          CreateDate: '',
          UpdateDate: '',
          SendToCustomer: false,
          SendToInspectors: false,
          SendToContractors: false,
          Info: '',
          AddedUsers: null
        }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      statuses: statusesRef.orderByKey()
    };
  },
  created: function created() {
    this.$Log("Vue [Diaries] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Diaries] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Diaries] is mounted ...");
    this.loadDiaries();
  },
  updated: function updated() {
    this.$Log("Vue [Diaries] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    usedDiaries: function usedDiaries() {
      return this.diaries.length;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = vm.diaries.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                return row;
              }
            });
          });
        } catch (e) {}
      } else {
        result = vm.diaries;
      }

      return result;
    }
  },
  watch: {
    diaries: function diaries(val) {
      this.$forceUpdate();
    },
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveDiary') {
        this.remove();
      }
    }
  },
  methods: {
    shortString: function shortString(str, len) {
      if (str.length > len) {
        return str.substring(0, len) + '...';
      } else {
        return str;
      }
    },
    getHref: function getHref(row) {
      return '#/Diary/' + row['.key'];
    },
    loadDiaries: function loadDiaries() {
      var vm = this;

      vm.isLoading = true;

      if (vm.$root.isAdmin) {
        vm.loadAllDiaries();
      }
      if (vm.$root.isCustomer) {
        vm.loadCustDiaries();
      } else {
        vm.loadMyDiaries();
      }
    },
    loadAllDiaries: function loadAllDiaries() {
      this.$Log("Vue [Diaries] loadAllDiaries() ...");
      var vm = this;
      vm.diaries = [];
      diariesRef.orderByKey().once('value').then(function (snapshot) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(snapshot.val()));
        var obj = snapshot.val();
        if (obj) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var diary = obj[key];
            diary['.key'] = key;
            vm.diaries.push(diary);
          }
        }
        vm.isLoading = false;
      });
    },
    loadCustDiaries: function loadCustDiaries() {
      this.$Log("Vue [Diaries] loadCustDiaries() ...");
      var vm = this;
      vm.diaries = [];
      console.log("vm.$root.user['.key']  >>> " + vm.$root.user['.key']);
      diariesRef.orderByChild('CustomerKey').equalTo(vm.$root.user['.key']).once('value').then(function (snapshot) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(snapshot.val()));
        var obj = snapshot.val();
        if (obj) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);

          var _loop = function _loop() {
            var key = keys[i];
            var diary = obj[key];
            diary['.key'] = key;

            var found = projectsRef.orderByKey().equalTo(diary.ProjectKey).once('value').then(function (snapshotProj) {
              var objProj = snapshotProj.val();
              if (objProj) {
                var keyP = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objProj)[0];
                var proj = objProj[keyP];
                console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(diary));
                if (proj.Images && proj.Images.length > 0) {
                  diary.Image = proj.Images[0];
                } else {
                  diary.Image = __WEBPACK_IMPORTED_MODULE_4__assets_no_image_png___default.a;
                }
                console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(diary));
                var status = vm.statuses.filter(function (st) {
                  if (st['.key'] == proj.StatusKey) {
                    diary.Status = st;
                    diary.Color = st.Color;

                    vm.diaries.push(diary);
                    return true;
                  }
                });

                return true;
              } else {
                return false;
              }
            });
          };

          for (var i = 0; i < keys.length; i++) {
            _loop();
          }
        }
        vm.isLoading = false;
      });
    },
    loadMyDiaries: function loadMyDiaries() {
      this.$Log("Vue [Diaries] loadMyDiaries() ...");
      var vm = this;
      vm.diaries = [];

      console.log("vm.$root.user['.key']  >>> " + vm.$root.user['.key']);
      messagesRef.orderByChild("ToUserKey").equalTo(vm.$root.user['.key']).once('value').then(function (snapshotMsg) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(snapshotMsg.val()));
        var objMsg = snapshotMsg.val();
        if (objMsg) {
          var msgKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objMsg);
          for (var j = 0; j < msgKeys.length; j++) {
            var mk = msgKeys[j];
            var msg = objMsg[mk];
            if (msg.IsConfirmed) {
              console.log("[MSG]  >>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(msg));
              console.log("[MSG]  DiaryKey>>> " + msg.DiaryKey);
              diariesRef.orderByKey().equalTo(msg.DiaryKey).once('value').then(function (snapshot) {
                console.log("Diary >>>>>>>>>>>>>>>>>>>>>>");
                console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(snapshot.val()));
                var obj = snapshot.val();
                if (obj) {
                  var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);

                  var _loop2 = function _loop2() {
                    var key = keys[i];
                    var diary = obj[key];
                    diary['.key'] = key;

                    console.log("ProjectKey >>>>>>>> " + diary.ProjectKey);

                    var found = projectsRef.orderByKey().equalTo(diary.ProjectKey).once('value').then(function (snapshotProj) {
                      var objProj = snapshotProj.val();
                      if (objProj) {
                        var keyP = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objProj)[0];
                        var proj = objProj[keyP];

                        if (proj.Images && proj.Images.length > 0) {
                          diary.Image = proj.Images[0];
                        } else {
                          diary.Image = __WEBPACK_IMPORTED_MODULE_4__assets_no_image_png___default.a;
                        }

                        var status = vm.statuses.filter(function (st) {
                          if (st['.key'] == proj.StatusKey) {
                            diary.Status = st;
                            diary.Color = st.Color;

                            vm.diaries.push(diary);
                            return true;
                          }
                        });

                        return true;
                      } else {
                        return false;
                      }
                    });
                  };

                  for (var i = 0; i < keys.length; i++) {
                    _loop2();
                  }
                }
              });
            }
          }
        }
        vm.isLoading = false;
      });
    },
    addNew: function addNew() {
      if (this.$root.isCustomer) {
        if (this.$root.user.TotalDiaries <= 0) {
          this.$root.alert = { isShow: true, message: 'אין חבילות/יומנים בחשבונך!', timeout: 3000, isTop: true };
          return;
        }

        if (this.$root.user.TotalDiaries == this.usedDiaries) {
          this.$root.alert = { isShow: true, message: 'כל היומנים בשימוש!', timeout: 3000, isTop: true };
          return;
        }
      }

      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'יומן חדש',
        data: {
          '.key': '', Title: '',
          CustomerName: this.$root.user.FullName,
          CustomerKey: this.$root.user['.key'],
          ProjectName: '',
          ProjectKey: '',
          CreateDate: '',
          UpdateDate: '',
          SendToCustomer: false,
          SendToInspectors: false,
          SendToContractors: false,
          Info: '',
          AddedUsers: null
        }
      };
    },
    open: function open(row) {
      if (this.$root.device.isMobile || this.$root.device.isTablet) {
        this.$router.push({ name: 'Diary', params: { diaryKey: row['.key'] } });
      } else {
        var routeData = this.$router.resolve({ name: 'Diary', params: { diaryKey: row['.key'] } });
        window.open(routeData.href, '_blank');
      }
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת יומן',
        data: {
          '.key': row['.key'],
          Title: row.Title,
          CustomerName: row.CustomerName,
          CustomerKey: row.CustomerKey,
          ProjectName: row.ProjectName,
          ProjectKey: row.ProjectKey,
          CreateDate: row.CreateDate,
          UpdateDate: this.$moment().format('DD/MM/YYYY'),
          Info: row.Info,
          SendToCustomer: row.SendToCustomer,
          SendToInspectors: row.SendToInspectors,
          SendToContractors: row.SendToContractors,
          AddedUsers: row.AddedUsers,
          Pages: row.Pages
        }
      };

      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(row));
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק יומן זה?' + '<br/><p style="color:red;">* מחיקת יומן תמחק גם את ההערות שלו!</p>',
        caller: 'RemoveDiary',
        isConfirmed: false
      };
    },
    remove: function remove() {
      var vm = this;
      diariesRef.child(vm.popup.data['.key']).remove().then(function (snap) {
        vm.loadDiaries();
      });
    },
    insert: function insert() {
      var vm = this;
      if (vm.popup.data.AddedUsers == undefined) {
        vm.popup.data.AddedUsers = null;
      }

      var item = {
        Title: vm.popup.data.Title,
        CustomerName: vm.popup.data.CustomerName,
        CustomerKey: vm.popup.data.CustomerKey,
        ProjectName: vm.popup.data.ProjectName,
        ProjectKey: vm.popup.data.ProjectKey,
        CreateDate: vm.$moment().format('DD/MM/YYYY'),
        UpdateDate: vm.$moment().format('DD/MM/YYYY'),
        Info: vm.popup.data.Info,
        SendToCustomer: vm.popup.data.SendToCustomer,
        SendToInspectors: vm.popup.data.SendToInspectors,
        SendToContractors: vm.popup.data.SendToContractors,
        AddedUsers: vm.popup.data.AddedUsers
      };

      diariesRef.push(item).then(function (snap) {
        var diaryKey = snap.key;

        if (item.AddedUsers) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.AddedUsers);
          for (var u = 0; u < keys.length; u++) {
            var key = keys[u];
            var user = item.AddedUsers[key];
            if (!user.IsConfirmed) {
              var msg = {
                CreateDate: vm.$moment().format('DD/MM/YYYY'),
                DiaryKey: diaryKey,
                IsConfirmed: false,
                SenderName: vm.$root.user.FullName,
                SenderKey: vm.$root.user['.key'],
                Text: vm.$root.user.FullName + ' מבקש לצרף אותך ליומן',
                ToUserKey: user.UserKey,
                Type: 'אישור'
              };
              messagesRef.push(msg);
            }
          }
        }

        vm.loadDiaries();
      });
    },
    update: function update() {
      var vm = this;
      if (vm.popup.data.AddedUsers == undefined) {
        vm.popup.data.AddedUsers = null;
      }

      var item = {
        Title: vm.popup.data.Title,
        CustomerName: vm.popup.data.CustomerName,
        CustomerKey: vm.popup.data.CustomerKey,
        ProjectName: vm.popup.data.ProjectName,
        ProjectKey: vm.popup.data.ProjectKey,
        CreateDate: vm.popup.data.CreateDate,
        UpdateDate: vm.$moment().format('DD/MM/YYYY'),
        Info: vm.popup.data.Info,
        SendToCustomer: vm.popup.data.SendToCustomer,
        SendToInspectors: vm.popup.data.SendToInspectors,
        SendToContractors: vm.popup.data.SendToContractors,
        AddedUsers: vm.popup.data.AddedUsers,
        Pages: vm.popup.data.Pages ? vm.popup.data.Pages : null
      };

      diariesRef.child(vm.popup.data['.key']).set(item).then(function (snap) {
        vm.loadDiaries();
      });

      if (item.AddedUsers) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.AddedUsers);
        for (var u = 0; u < keys.length; u++) {
          var key = keys[u];
          var user = item.AddedUsers[key];
          if (!user.IsConfirmed) {
            var msg = {
              CreateDate: vm.$moment().format('DD/MM/YYYY'),
              DiaryKey: vm.popup.data['.key'],
              IsConfirmed: false,
              SenderName: vm.$root.user.FullName,
              SenderKey: vm.$root.user['.key'],
              Text: vm.$root.user.FullName + ' מבקש לצרף אותך ליומן',
              ToUserKey: user.UserKey,
              Type: 'אישור'
            };
            messagesRef.push(msg);
          }
        }
      }
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jszip__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SubMenu__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SubMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SubMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake_min_js__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts_js__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_yomanet_png__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_yomanet_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_yomanet_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PopupConfim__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PopupConfim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_PopupConfim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DiaryPage__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DiaryPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_DiaryPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DiaryPageMobile__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DiaryPageMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_DiaryPageMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Note__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Note__);











__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake_min_js___default.a.vfs = __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts_js___default.a.pdfMake.vfs;


var statusesRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref('Statuses');








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Diary',
  components: { SubMenu: __WEBPACK_IMPORTED_MODULE_4__components_SubMenu___default.a, PopupConfim: __WEBPACK_IMPORTED_MODULE_9__components_PopupConfim___default.a, DiaryPage: __WEBPACK_IMPORTED_MODULE_10__components_DiaryPage___default.a, DiaryPageMobile: __WEBPACK_IMPORTED_MODULE_11__components_DiaryPageMobile___default.a, Note: __WEBPACK_IMPORTED_MODULE_12__components_Note___default.a },
  data: function data() {
    return {
      txtSearch: '',
      txtAdvanceSearch: '',
      advanceSearchNotes: [],
      advanceSearch: false,
      diary: null,
      project: null,
      pages: [],
      isActiveUsers: false,
      planLink: '',
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', Title: '', CustomerName: '', CustomerKey: '', ProjectName: '', ProjectKey: '', CreateDate: '', UpdateDate: '', Info: '', Users: null }
      },
      currentDate: '',
      zip: null
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      statuses: statusesRef.orderByKey()
    };
  },
  created: function created() {
    this.$Log("Vue [Diary] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Diary] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Diary] is mounted ...");
    this.loadData();
  },
  updated: function updated() {
    this.$Log("Vue [Diary] is updated ...");
  },

  computed: {
    canDownloadDiary: function canDownloadDiary() {
      var setting = this.$root.settings.find(function (s) {
        return s['.key'] == 'Download';
      });

      if (setting) {
        return setting.KeyValue;
      } else {
        return false;
      }
    },
    title: function title() {
      if (this.diary) {
        if (this.diary.Title.length > 20) {
          return this.diary.Title.substring(0, 20) + "...";
        } else {
          return this.diary.Title;
        }
      } else {
        return '';
      }
    },
    projectName: function projectName() {
      if (this.diary) {
        return this.diary.ProjectName;
      } else {
        return '';
      }
    },
    diaryKey: function diaryKey() {
      return this.$route.params.diaryKey;
    },
    hasData: function hasData() {
      return this.advanceSearchNotes != null && this.advanceSearchNotes != undefined && this.advanceSearchNotes.length > 0;
    },
    weatherInfo: function weatherInfo() {
      var wth = 'אין נתונים';
      if (this.$root.weather) {
        if (this.$root.weather.currently) {
          wth = this.$root.weather.currently.summary + ' ' + Math.round(this.$root.weather.currently.temperature) + '°';
        }
      }

      return wth;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveDiary') {
        this.remove();
      }
    },
    advanceSearch: function advanceSearch(val) {
      this.txtAdvanceSearch = '';
    },
    txtAdvanceSearch: function txtAdvanceSearch(val) {
      this.searchDiary();
    }
  },
  methods: {
    selectNote: function selectNote(note) {
      var vm = this;
      vm.advanceSearch = false;
      for (var i = 0; i < vm.pages.length; i++) {
        if (vm.pages[i].PageKey == note.PageKey) {
          vm.$root.activeDiaryPage = vm.pages[i];
          break;
        }
      }
    },
    searchDiary: function searchDiary() {
      var vm = this;
      if (vm.txtAdvanceSearch.length > 2) {
        var txt = String(vm.txtAdvanceSearch);
        try {
          if (vm.pages.length > 0) {
            for (var i = 0; i < vm.pages.length; i++) {
              if (vm.pages[i].PageKey) {
                var notesPath = 'DiaryPages/' + vm.pages[i].PageKey;
                var notesRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref(notesPath);

                notesRef.orderByKey().once('value').then(function (snapshotNotes) {
                  var objArr = snapshotNotes.val();
                  var snapshotKey = snapshotNotes.key;

                  if (objArr && objArr.Notes) {
                    if (Array.isArray(objArr.Notes)) {
                      objArr.Notes.filter(function (row) {
                        if (row.Info.indexOf(txt) > -1 || row.UserFullName.indexOf(txt) > -1) {
                          var exist = vm.advanceSearchNotes.filter(function (nt) {
                            if (nt.Info == row.Info && nt.Date == row.Date) {
                              return nt;
                            }
                          });

                          if (exist.length == 0) {
                            row.PageKey = snapshotKey;
                            vm.advanceSearchNotes.push(row);
                          }
                        }
                      });
                    } else {
                      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objArr.Notes);

                      for (var k = 0; k < keys.length; k++) {
                        var row = objArr.Notes[k];
                        if (row) {
                          if (row.Info.indexOf(txt) > -1 || row.UserFullName.indexOf(txt) > -1) {
                            var exist = vm.advanceSearchNotes.filter(function (nt) {
                              if (nt.Info == row.Info && nt.Date == row.Date) {
                                return nt;
                              }
                            });

                            if (exist.length == 0) {
                              row.PageKey = snapshotKey;
                              vm.advanceSearchNotes.push(row);
                            }
                          }
                        }
                      }
                    }
                  }
                });
              }
            }
          }
        } catch (e) {}
      } else {
        vm.advanceSearchNotes = [];
      }
    },
    sendMail: function sendMail(page, event) {
      var vm = this;
      var docWeather = "מזג אויר";
      var weatherPath = 'DiaryPages/' + page.PageKey + '/Weather';
      var weatherRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref(weatherPath);
      weatherRef.orderByKey().once('value').then(function (snapWeather) {
        var objWeather = snapWeather.val();
        vm.downloadOrSendPageWithWeather(vm, true, objWeather, page, event);
      });
    },
    downloadPage: function downloadPage(page, event) {
      var vm = this;
      var docWeather = "מזג אויר";
      var weatherPath = 'DiaryPages/' + page.PageKey + '/Weather';
      var weatherRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref(weatherPath);
      weatherRef.orderByKey().once('value').then(function (snapWeather) {
        var objWeather = snapWeather.val();
        vm.downloadOrSendPageWithWeather(vm, false, objWeather, page, event);
      });
    },
    downloadOrSendPageWithWeather: function downloadOrSendPageWithWeather(vm, isSend, weather, page, event) {

      event.stopPropagation();

      vm.zip = new __WEBPACK_IMPORTED_MODULE_2_jszip___default.a();
      var dateFolder = page.Date.replace("/", ".").replace("/", ".");
      var zipFilename = dateFolder + ".zip";
      var zipFolder = vm.zip.folder(dateFolder);
      var pdfFilename = "דף יומן " + dateFolder + ".pdf";

      var fonts = {
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf'
        },
        Hebrew: {
          normal: 'Narkis-Hebrew',
          bold: 'Narkis-Hebrew',
          italics: 'Narkis-Hebrew',
          bolditalics: 'Narkis-Hebrew'
        },
        Arabic: {
          normal: 'Amiri-Arabic-Regular.ttf',
          bold: 'Amiri-Arabic-Regular.ttf',
          italics: 'Amiri-Arabic-Regular.ttf',
          bolditalics: 'Amiri-Arabic-Regular.ttf'
        }
      };

      __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake_min_js___default.a.fonts = fonts;

      var nbspace = " ";
      var specialChar = "∞";
      var arbText = 'إذا لم تستح فاصنع ما شئت';

      arbText = arbText.split(" ").join(nbspace);


      var docTitle = "דף יומן ";
      docTitle = docTitle.split(" ").join(nbspace);

      var docWeather = "מזג אויר";
      docWeather = "(" + docWeather + ": " + weather + ")";
      docWeather = vm.replaceChars(docWeather);
      docWeather = vm.reverseEnglish(docWeather);
      docWeather = vm.reverseChars(docWeather);
      docWeather = docWeather.split(" ").join(nbspace);

      var docProject = "פרויקט";
      docProject = "(" + docProject + ": " + vm.diary.ProjectName + ")";
      docProject = vm.replaceChars(docProject);
      docProject = vm.reverseEnglish(docProject);
      docProject = vm.reverseChars(docProject);
      docProject = docProject.split(" ").join(nbspace);

      var customerName = vm.diary.CustomerName.split(" ").join(nbspace);
      var imgBase64 = "";
      var img = document.getElementById('imgYoman');
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      imgBase64 = dataURL;

      var docDefinition = {
        header: {
          columns: [page.Date, { text: customerName, alignment: 'right' }],
          margin: 10
        },
        content: [{
          image: 'yomanetImg',
          width: 50,
          alignment: 'center'
        }, {
          text: docTitle,
          alignment: 'center',
          margin: 5,
          fontSize: 24
        }, {
          text: page.Date,
          alignment: 'center',
          margin: 5,
          fontSize: 24
        }, {
          text: docProject,
          alignment: 'center',
          margin: 5,
          color: '#555'
        }, {
          text: docWeather,
          alignment: 'center',
          margin: 5,
          color: '#555'
        }],
        images: {
          yomanetImg: imgBase64
        },

        defaultStyle: {
          font: 'Hebrew'
        },

        styles: {
          header: {
            font: 'Arabic',
            fontSize: 22,
            bold: true
          },
          anotherStyle: {
            alignment: 'right'
          },
          arabic: {
            font: 'Arabic',
            fontSize: 18,
            alignment: 'right'
          }
        }
      };

      var notesPath = 'DiaryPages/' + page.PageKey + '/Notes';
      var notesRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref(notesPath);

      var notes = [];
      var notesGeneral = [];
      var notesInfo = [];
      var notesInspector = [];
      var notesContractor = [];
      var files = [];

      notesRef.orderByKey().once('value').then(function (snapNotes) {
        var objNotes = snapNotes.val();
        if (objNotes) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objNotes);
          var zipAdded = 0;
          var attachCount = 0;
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var objNote = objNotes[key];

            var auther = objNote.UserFullName + " )" + objNote.UserType + "(:";
            auther = auther.split(" ").join(nbspace) + "  " + objNote.Time;

            var info = objNote.Info;
            info = vm.replaceChars(info);
            info = vm.reverseEnglish(info);
            info = vm.reverseDate(info);
            info = vm.reverseChars(info);
            info = info.split(" ").join(nbspace);

            notes.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });

            notes.push({ text: info, alignment: 'right', margin: 5 });


            if (objNote.IsGeneral) {
              notesGeneral.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
              notesGeneral.push({ text: info, alignment: 'right', margin: 5 });
            } else if (objNote.IsInfo) {
              notesInfo.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
              notesInfo.push({ text: info, alignment: 'right', margin: 5 });
            } else {
              if (objNote.UserType == 'מפקח') {
                notesInspector.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
                notesInspector.push({ text: info, alignment: 'right', margin: 5 });
              } else if (objNote.UserType == 'מנהל עבודה') {
                notesContractor.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
                notesContractor.push({ text: info, alignment: 'right', margin: 5 });
              }
            }

            if (objNote.Attachments) {
              if (objNote.IsGeneral) {
                notesGeneral.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
              } else if (objNote.IsInfo) {
                notesInfo.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
              } else {
                if (objNote.UserType == 'מפקח') {
                  notesInspector.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
                } else if (objNote.UserType == 'מנהל עבודה') {
                  notesContractor.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
                }
              }
              var attachKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objNote.Attachments);
              attachCount += attachKeys.length;
              for (var a = 0; a < attachKeys.length; a++) {
                var attachKey = attachKeys[a];
                var fileUrl = objNote.Attachments[attachKey].FileUrl;
                var fileName = objNote.Attachments[attachKey].FileName;

                files.push({ fileUrl: fileUrl, fileName: fileName });

                if (objNote.IsGeneral) {
                  notesGeneral.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });
                } else if (objNote.IsInfo) {
                  notesInfo.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });
                } else {
                  if (objNote.UserType == 'מפקח') {
                    notesInspector.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });
                  } else if (objNote.UserType == 'מנהל עבודה') {
                    notesContractor.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });
                  }
                }
              }
            }
          }

          docDefinition.content.push({ text: "הערות כלליות:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', margin: [20, 20, 0, 20] });
          docDefinition.content.push(notesGeneral);

          docDefinition.content.push({ text: "תיאור עבודה:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', margin: [20, 20, 0, 20] });
          docDefinition.content.push(notesInfo);

          var tableBody = [];

          tableBody.push([{ text: "הערות מפקח:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', border: [false, true, false, false], margin: [20, 20, 0, 20] }, { text: "הערות מנהל עבודה:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', margin: [20, 20, 0, 20] }]);

          var lenInspector = notesInspector.length;
          var lenContractor = notesContractor.length;
          var max = 0;

          max = lenContractor;
          if (lenInspector >= lenContractor) {
            max = lenInspector;
          }

          for (var m = 0; m < max; m++) {
            tableBody.push([notesInspector[m] ? notesInspector[m] : " ", notesContractor[m] ? notesContractor[m] : " "]);
          }

          var table = {
            table: {
              widths: [250, 250],
              headerRows: 1,
              body: tableBody
            },
            layout: 'noBorders'
          };

          docDefinition.content.push(table);

          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notesInspector));

          var pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake_min_js___default.a.createPdf(docDefinition);
          pdfDocGenerator.getBlob(function (blob) {

            if (isSend) {
              vm.uploadPDF(pdfFilename, blob, function (pdfUrl) {
                var pdfTitle = "דף יומן " + dateFolder;
                console.log(pdfUrl);
                vm.sendToMail(vm, page, pdfTitle, pdfUrl);
                return;
              });
            }

            zipFolder.file(pdfFilename, blob, { binary: true });

            if (files.length > 0) {
              for (var fl = 0; fl < files.length; fl++) {

                var url = files[fl].fileUrl;
                var name = files[fl].fileName;

                vm.getBinaryFile(files[fl], function (data, file) {
                  zipFolder.file(file.fileName, data, { binary: true });
                  zipAdded++;
                  if (zipAdded == attachCount) {
                    vm.zip.generateAsync({ type: "blob" }).then(function (content) {
                      __WEBPACK_IMPORTED_MODULE_3_file_saver___default.a.saveAs(content, zipFilename);
                    });
                  }
                });
              }
            } else {
              if (zipAdded == attachCount) {
                vm.zip.generateAsync({ type: "blob" }).then(function (content) {
                  __WEBPACK_IMPORTED_MODULE_3_file_saver___default.a.saveAs(content, zipFilename);
                });
              }
            }
          });
        }
      });
    },
    getBinaryFile: function getBinaryFile(file, callback) {
      JSZipUtils.getBinaryContent(file.fileUrl, function (err, data) {
        if (!err) {
          callback(data, file);
        } else {
          console.log("Added file Error: " + err);
        }
      });
    },
    replaceChars: function replaceChars(txt) {
      var chars = "*=+:\n°";
      var newTxt = "";
      var arr = txt.split('');
      for (var i = 0; i < arr.length; i++) {
        var index = -1;
        var chr = arr[i];
        index = chars.indexOf(arr[i]);
        if (index >= 0) {
          chr = " " + chr + " ";
        }

        newTxt = newTxt + chr;
      }
      return newTxt;
    },
    reverseEnglish: function reverseEnglish(txt) {
      var english = /^[A-Za-z0-9/\\:]*$/;

      var arr = txt.split(" ");
      for (var i = 0; i < arr.length; i++) {
        if (english.test(arr[i])) {
          console.log(arr[i]);
          arr[i] = arr[i].split("").reverse().join("");
        }
      }
      txt = arr.join(" ");
      return txt;
    },
    reverseDate: function reverseDate(txt) {
      var dateReg = /(\d{4}([.\-/ ])\d{2}\2\d{2}|\d{2}([.\-/ ])\d{2}\3\d{4})/;
      var arr = txt.split(" ");
      for (var i = 0; i < arr.length; i++) {
        if (dateReg.test(arr[i])) {
          arr[i] = arr[i].split("").reverse().join("");
        }
      }
      txt = arr.join(" ");
      return txt;
    },
    reverseChars: function reverseChars(txt) {
      var tmpCharL = "δ";
      var tmpCharR = "∞";
      var left = "({[";
      var right = ")}]";

      var arr = txt.split("");
      for (var i = 0; i < arr.length; i++) {
        var index = -1;
        index = left.indexOf(arr[i]);
        if (index >= 0) {
          arr[i] = " " + right[index] + " ";
        } else {
          index = right.indexOf(arr[i]);
          if (index >= 0) {
            arr[i] = " " + left[index] + " ";
          }
        }
      }
      txt = arr.join("");
      return txt;
    },
    loadData: function loadData() {
      var vm = this;
      console.log('[Diary].loadData() ...');
      var diaryRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref('Diaries/' + vm.$route.params.diaryKey).once('value').then(function (snapDiary) {

        vm.diary = snapDiary.val();
        vm.diary['.key'] = vm.$route.params.diaryKey;
        console.log(vm.diary);
        var projectRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref('Projects/' + vm.diary.ProjectKey).once('value').then(function (snapProject) {

          var prj = snapProject.val();
          if (prj) {
            vm.project = prj;
            vm.project['.key'] = vm.diary.ProjectKey;
          } else {
            vm.project = {
              Name: 'לא קיים!!',
              City: '',
              Address: '',
              Location: { lat: 0, lng: 0 },
              Info: '',
              StatusKey: '',
              UserKey: '',
              Active: '',
              Images: '',
              CreateDate: '',
              UpdateDate: '',
              StartDate: '',
              EndDate: ''
            };
            vm.project['.key'] = vm.diary.ProjectKey;
          }

          vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.project.Location.lat, vm.project.Location.lng, function (error, data) {
            if (error) {
              console.log('vm.$GetWeather() Error: ');
              console.log(error);


              vm.$root.weather = {
                currently: {
                  time: 0,
                  summary: 'No Data',
                  temperature: 0
                }
              };
              vm.currentDate = vm.$moment().format('DD/MM/YYYY');
            }
            if (!error) {
              console.log('vm.$GetWeather() Data: ');
              console.log(data);
              vm.$root.weather = data;

              vm.currentDate = vm.$moment().format('DD/MM/YYYY');
            }

            if (true) {
              vm.pages = [];
              console.log(vm.currentDate);
              console.log(vm.diary.Pages);

              if (vm.diary.Pages) {
                var keysPg = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(vm.diary.Pages);
                keysPg.forEach(function (key) {
                  vm.pages.push(vm.diary.Pages[key]);
                });
              }

              if (vm.pages.length > 0) {
                var len = vm.pages.length;
                if (vm.pages[len - 1].Date != vm.currentDate) {
                  vm.pages.push({ PageKey: null, Date: vm.currentDate, Weather: vm.weatherInfo });
                }
                vm.pages = vm.pages.reverse();
              } else {
                vm.pages.push({ PageKey: null, Date: vm.currentDate, Weather: vm.weatherInfo });
              }

              if (vm.$root.activeDiaryPage.PageKey == null) {
                vm.$root.activeDiaryPage = vm.pages[0];
              }

              var plansRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref('Plans').orderByChild("ProjectKey").equalTo(vm.project['.key']).once('value').then(function (snapPlan) {
                var obj = snapPlan.val();
                if (obj) {
                  var planKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj)[0];
                  vm.planLink = '/#/Plan/' + planKey;
                } else {
                  vm.planLink = '';
                }
              });
            }
          });
        }).catch(function (errorProject) {
          console.log('Project Error: ');
          console.log(errorProject);
        });
      }).catch(function (errorDiary) {
        console.log('Diary Error: ');
        console.log(errorDiary);
      });
    },
    loadPlanLink: function loadPlanLink() {
      var vm = this;
      var plansRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref('Plans').orderByChild("ProjectKey").equalTo(vm.project['.key']).once('value').then(function (snapPlan) {
        var obj = snapPlan.val();
        if (obj) {
          var planKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj)[0];
          vm.planLink = '/#/Plan/' + planKey;
        }
      });
    },
    getStatus: function getStatus() {
      var vm = this;

      if (vm.project) {
        var status = vm.statuses.find(function (st) {
          return st['.key'] == vm.project.StatusKey;
        });

        if (status) {
          return status.Name;
        }
      }

      return '';
    },
    getPlanUrl: function getPlanUrl() {},
    dayClick: function dayClick(page) {
      this.selectedDate = page.Date;
      this.$root.activeDiaryPage = page;
      this.loadData();
    },
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'יומן חדש',
        data: { '.key': '', Title: '', CustomerName: '', CustomerKey: '', ProjectName: '', ProjectKey: '', CreateDate: '', UpdateDate: '', Info: '', Users: null }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת יומן',
        data: {
          '.key': row['.key'],
          Title: row.FullName,
          CustomerName: row.ContactPerson,
          CustomerKey: row.Phone,
          ProjectName: row.Username,
          ProjectKey: row.Password,
          CreateDate: row.TotalDiaries,
          UpdateDate: row.UsedDiaries,
          Info: row.Info,
          Users: row.Users
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveUser',
        isConfirmed: false
      };
    },
    remove: function remove() {
      diariesRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var item = {
        Title: this.popup.data.FullName,
        CustomerName: this.popup.data.ContactPerson,
        CustomerKey: this.popup.data.Phone,
        ProjectName: this.popup.data.Username,
        ProjectKey: this.popup.data.Password,
        CreateDate: this.popup.data.TotalDiaries,
        UpdateDate: this.popup.data.UsedDiaries,
        Info: this.popup.data.Info,
        Users: this.popup.data.Users
      };

      diariesRef.push(item);
    },
    update: function update() {
      var item = {
        Title: this.popup.data.FullName,
        CustomerName: this.popup.data.ContactPerson,
        CustomerKey: this.popup.data.Phone,
        ProjectName: this.popup.data.Username,
        ProjectKey: this.popup.data.Password,
        CreateDate: this.popup.data.TotalDiaries,
        UpdateDate: this.popup.data.UsedDiaries,
        Info: this.popup.data.Info,
        Users: this.popup.data.Users
      };
      diariesRef.child(this.popup.data['.key']).set(item);
    },
    sendToMail: function sendToMail(vm, page, pdfTitle, pdfUrl) {
      console.log('Share.sendMail()');
      console.log(pdfTitle);
      console.log(pdfUrl);
      var pdfUrlPath = 'DiaryPages/' + page.PageKey + '/PdfUrl';
      console.log(pdfUrlPath);
      __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref(pdfUrlPath).set(pdfUrl);

      pdfUrl = encodeURIComponent(pdfUrl);

      var title = ' יומנט  ' + pdfTitle;
      var subject = title;
      var body = '';
      var newLine = '%0D%0A';

      body += ' שלום רב,';
      body += newLine;
      body += newLine;

      body += title + ' : ';
      body += newLine;
      body += newLine;

      body += pdfUrl;

      body += newLine;
      body += newLine;
      body += newLine;

      body += 'בברכה,';
      body += 'יומנט';
      body += newLine;
      body += newLine;
      body += newLine;

      console.log(body);

      var sendTo = vm.$root.user.Username;

      var command = 'mailto:' + sendTo + '?subject=' + subject + '&body=' + body;

      if (sendTo && sendTo.length > 0) {
        command = 'mailto:' + sendTo + '?subject=' + subject + '&body=' + body;
        console.log(command);
        window.location = command;
      } else {
        alert('חסר כתובת מייל לשליחה !!');
      }
    },
    uploadPDF: function uploadPDF(pdfFilename, blob, callback) {
      var storageRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["d" /* storage */].ref('Diary/' + pdfFilename);

      var task = storageRef.put(blob);
      var percent = 0;
      task.on('state_changed', function progress(snap) {
        console.log("bytesTransferred = " + snap.bytesTransferred + ' of ' + snap.totalBytes);
        percent = snap.bytesTransferred / snap.totalBytes * 100;
        console.log("percent = " + percent + ' %');
        console.log("percent = " + Math.floor(percent) + ' %');
      }, function error(err) {}, function complete() {
        console.log("Upload Completed !");

        task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('File available at', downloadURL);
          callback(downloadURL);
        });
      });
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupUser__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PopupUser__);





var usersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Users');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Entrepreneurs',
  components: { PopupUser: __WEBPACK_IMPORTED_MODULE_3__components_PopupUser___default.a },
  data: function data() {
    return {
      txtSearch: '',
      users: [],
      contractors: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'יזם', Password: '', Active: false, Approved: false }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      users: usersRef.orderByChild("Type").equalTo("יזם")
    };
  },
  created: function created() {
    this.$Log("Vue [Entrepreneurs] is created ...");
    var vm = this;
    if (!vm.$root.isAdmin) {
      vm.loadMyContractors();
    }
  },
  ready: function ready() {
    this.$Log("Vue [Entrepreneurs] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Entrepreneurs] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Entrepreneurs] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.$root.isAdmin) {
        return vm.filteredRowsWithPermission(vm.users);
      } else {
        return vm.filteredRowsWithPermission(vm.contractors);
      }
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveEntrepreneur') {
        this.remove();
      }
    }
  },
  methods: {
    filteredRowsWithPermission: function filteredRowsWithPermission(usersArr) {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = usersArr.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                if (vm.isActiveUsers) {
                  if (row.Active) {
                    return row;
                  }
                } else {
                  return row;
                }
              }
            });
          });
        } catch (e) {}
      } else {
        if (vm.isActiveUsers) {
          result = usersArr.filter(function (row) {
            if (row.Active) {
              return row;
            }
          });
        } else {
          result = usersArr;
        }
      }

      return result;
    },
    loadMyContractors: function loadMyContractors() {
      var vm = this;
      vm.contractors = [];
      var customerKey = vm.$root.user['.key'];
      var diariesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Diaries');
      diariesRef.orderByChild("CustomerKey").equalTo(customerKey).once('value').then(function (snapshot) {
        var obj = snapshot.val();
        if (obj) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);

          var _loop = function _loop() {
            var key = keys[i];
            var diary = obj[key];
            console.log("diary >>>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(diary));
            if (diary.AddedUsers && diary.AddedUsers.length > 0) {
              var _loop2 = function _loop2() {
                var user = vm.users.find(function (usr) {
                  return usr['.key'] == diary.AddedUsers[u].UserKey;
                });

                if (user) {
                  var userExist = vm.contractors.find(function (exist) {
                    return exist['.key'] == user['.key'];
                  });
                  if (!userExist) {
                    vm.contractors.push(user);
                  }
                }
              };

              for (u = 0; u < diary.AddedUsers.length; u++) {
                _loop2();
              }
            }
          };

          for (var i = 0; i < keys.length; i++) {
            var u;

            _loop();
          }
        }
      });
    },
    currency: function currency(N) {
      N = parseFloat(N);
      if (!isNaN(N)) N = N.toFixed(2);else N = '0.00';
      return N + " ₪";
    },
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'יזם חדש',
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'יזם', Password: '', Active: true, Approved: false }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת יזם',
        data: {
          '.key': row['.key'],
          FullName: row.FullName,
          Username: row.Username,
          Identity: row.Identity,
          Type: row.Type,
          Password: row.Password,
          Active: row.Active,
          Approved: row.Approved
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveEntrepreneur',
        isConfirmed: false
      };
    },
    remove: function remove() {
      usersRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var vm = this;

      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };

      usersRef.push(item);
    },
    update: function update() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };
      usersRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupUser__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PopupUser__);





var usersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Users');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Inspectors',
  components: { PopupUser: __WEBPACK_IMPORTED_MODULE_3__components_PopupUser___default.a },
  data: function data() {
    return {
      txtSearch: '',
      users: [],
      inspectors: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: '', Password: '', Active: false, Approved: false }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      users: usersRef.orderByChild("Type").equalTo("מפקח")
    };
  },
  created: function created() {
    this.$Log("Vue [Inspectors] is created ...");
    var vm = this;
    if (!vm.$root.isAdmin) {
      vm.loadMyInspectors();
    }
  },
  ready: function ready() {
    this.$Log("Vue [Inspectors] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Inspectors] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Inspectors] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.$root.isAdmin) {
        return vm.filteredRowsWithPermission(vm.users);
      } else {
        return vm.filteredRowsWithPermission(vm.inspectors);
      }
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveUser') {
        this.remove();
      }
    }
  },
  methods: {
    filteredRowsWithPermission: function filteredRowsWithPermission(usersArr) {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = usersArr.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                if (vm.isActiveUsers) {
                  if (row.Active) {
                    return row;
                  }
                } else {
                  return row;
                }
              }
            });
          });
        } catch (e) {}
      } else {
        if (vm.isActiveUsers) {
          result = usersArr.filter(function (row) {
            if (row.Active) {
              return row;
            }
          });
        } else {
          result = usersArr;
        }
      }

      return result;
    },
    loadMyInspectors: function loadMyInspectors() {
      var vm = this;
      vm.inspectors = [];
      var customerKey = vm.$root.user['.key'];
      var diariesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Diaries');
      diariesRef.orderByChild("CustomerKey").equalTo(customerKey).once('value').then(function (snapshot) {
        var obj = snapshot.val();
        if (obj) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);

          var _loop = function _loop() {
            var key = keys[i];
            var diary = obj[key];
            console.log("diary >>>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(diary));
            if (diary.AddedUsers && diary.AddedUsers.length > 0) {
              var _loop2 = function _loop2() {
                var user = vm.users.find(function (usr) {
                  return usr['.key'] == diary.AddedUsers[u].UserKey;
                });

                if (user) {
                  var userExist = vm.inspectors.find(function (exist) {
                    return exist['.key'] == user['.key'];
                  });
                  if (!userExist) {
                    vm.inspectors.push(user);
                  }
                }
              };

              for (u = 0; u < diary.AddedUsers.length; u++) {
                _loop2();
              }
            }
          };

          for (var i = 0; i < keys.length; i++) {
            var u;

            _loop();
          }
        }
      });
    },
    currency: function currency(N) {
      N = parseFloat(N);
      if (!isNaN(N)) N = N.toFixed(2);else N = '0.00';
      return N + " ₪";
    },
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'מפקח חדש',
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'מפקח', Password: '', Active: false, Approved: false }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת מפקח',
        data: {
          '.key': row['.key'],
          FullName: row.FullName,
          Username: row.Username,
          Identity: row.Identity,
          Type: row.Type,
          Password: row.Password,
          Active: row.Active,
          Approved: row.Approved
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveUser',
        isConfirmed: false
      };
    },
    remove: function remove() {
      usersRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };

      usersRef.push(item);
    },
    update: function update() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };
      usersRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SubMenu__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SubMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SubMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Notification__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupConfim__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupConfim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PopupConfim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_user_png__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_user_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_user_png__);



var usersRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Users');







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Layout',
  components: {
    SubMenu: __WEBPACK_IMPORTED_MODULE_1__components_SubMenu___default.a,
    user: null,
    Notification: __WEBPACK_IMPORTED_MODULE_2__components_Notification___default.a,
    PopupConfim: __WEBPACK_IMPORTED_MODULE_3__components_PopupConfim___default.a,
    messages: []
  },
  data: function data() {
    return {};
  },
  created: function created() {
    this.$Log("Vue [Layout] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Layout] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Layout] is mounted ...");

    if (this.user && this.user[0] && this.user[0]['.key'] == this.$root.user['.key']) {
      this.$root.user.Active = this.user[0].Active;
      this.$root.user.Approved = this.user[0].Approved;
      this.$root.user.FullName = this.user[0].FullName;
      this.$root.user.Identity = this.user[0].Identity;
      this.$root.user.MessagesCounter = this.user[0].MessagesCounter;
      this.$root.user.Password = this.user[0].Password;
      this.$root.user.Token = this.user[0].Token;
      this.$root.user.Type = this.user[0].Type;
      this.$root.user.Username = this.user[0].Username;
    }
  },
  updated: function updated() {
    this.$Log("Vue [Layout] is updated ...");
  },

  methods: {}
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PopupRegister__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PopupRegister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PopupRegister__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupPasswordReset__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupPasswordReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PopupPasswordReset__);




var usersRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Users');



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: { PopupRegister: __WEBPACK_IMPORTED_MODULE_2__components_PopupRegister___default.a, PopupPasswordReset: __WEBPACK_IMPORTED_MODULE_3__components_PopupPasswordReset___default.a },
  data: function data() {
    return {
      isPasswordReset: false,
      isRegister: false,
      username: '',
      password: ''
    };
  },
  created: function created() {
    this.$ForceLog("Vue [login] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [login] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [login] is mounted ...");


    if (this.$root.isLoginFromReset) {
      this.$root.isLoginFromReset = false;
      this.$root.alert.isShow = true;
    }
  },
  updated: function updated() {
    this.$Log("Vue [login] is updated ...");
  },

  methods: {
    resetError: function resetError() {
      this.$root.loginError = "";
    },
    clearUser: function clearUser() {
      this.username = "";
    },
    clearPassword: function clearPassword() {
      this.password = "";
    }
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);




var messagesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Messages');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Messages',
  data: function data() {
    return {
      txtSearch: '',
      messages: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '' }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      messages: messagesRef.orderByChild("ToUserKey").equalTo(vm.$root.user['.key'])
    };
  },
  created: function created() {
    this.$Log("Vue [Messages] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Messages] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Messages] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Messages] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = vm.messages.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                if (vm.isActiveUsers) {
                  if (row.Active) {
                    return row;
                  }
                } else {
                  return row;
                }
              }
            });
          });
        } catch (e) {}
      } else {
        result = vm.messages;
      }


      return result;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveMessage') {
        this.remove();
      }
      if (val && this.$root.confirm.caller == 'ConfirmMessage') {
        this.confirmYesMessage();
      }
    },
    messages: function messages(val) {
      if (val) {
        this.$root.messagesCounter = 0;
        for (var m = 0; m < this.messages.length; m++) {
          if (!this.messages[m].IsConfirmed) {
            this.$root.messagesCounter++;
          }
        }
      }
    }
  },
  methods: {
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת מפקח',
        data: {
          '.key': row['.key'],
          FullName: row.FullName,
          Username: row.Username,
          Identity: row.Identity,
          Type: row.Type,
          Password: row.Password,
          Active: row.Active,
          Approved: row.Approved
        }
      };
    },
    confirmMessage: function confirmMessage(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'אישור',
        question: 'האם אתה בטוח ברצונך לאשר בקשה זו?',
        caller: 'ConfirmMessage',
        isConfirmed: false
      };
    },
    confirm: function confirm(row) {
      this.popup.data['.key'] = row['.key'];
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveMessage',
        isConfirmed: false
      };
    },
    remove: function remove() {
      messagesRef.child(this.popup.data['.key']).remove();
    },
    confirmYesMessage: function confirmYesMessage() {
      var vm = this;
      var diaryRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Diaries/' + vm.popup.data.DiaryKey + "/AddedUsers");

      var addedUsers = diaryRef.orderByChild("UserKey").equalTo(vm.popup.data.ToUserKey).once('value').then(function (snapshot) {
        var obj = snapshot.val();

        if (obj) {
          var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj)[0];

          var addedUserPath = 'Diaries/' + vm.popup.data.DiaryKey + '/AddedUsers/' + key + '/IsConfirmed';
          var messagePath = 'Messages/' + vm.popup.data['.key'] + '/IsConfirmed';
          var updateObj = {};
          updateObj[addedUserPath] = true;
          updateObj[messagePath] = true;

          __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref().update(updateObj);
        }
      });
    },
    insert: function insert() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };

      messagesRef.push(item);
    },
    update: function update() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };
      messagesRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MyAccount',
  data: function data() {
    return {
      error: '',

      user: { '.key': '', FullName: '', Username: '', Identity: '', Type: '', Password: '', Active: false, Approved: false },
      confirmPassword: ''
    };
  },
  created: function created() {
    this.$Log("Vue [MyAccount] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [MyAccount] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [MyAccount] is mounted ...");
    var vm = this;

    vm.user = JSON.parse(vm.$localStorage.get('user'));
  },
  updated: function updated() {
    this.$Log("Vue [MyAccount] is updated ...");
  },

  computed: {},
  watch: {},
  methods: {
    save: function save() {
      var vm = this;
      if (vm.isValid()) {
        var item = {
          FullName: vm.user.FullName,
          Username: vm.user.Username,
          Identity: vm.user.Identity,
          Type: vm.user.Type,
          Password: vm.user.Password,
          TotalDiaries: vm.user.TotalDiaries,
          UsedDiaries: vm.user.UsedDiaries,
          MessagesCounter: vm.user.MessagesCounter,
          ContactPerson: vm.user.ContactPerson,
          Active: vm.user.Active,
          Approved: vm.user.Approved
        };

        var usersRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Users/' + vm.user['.key']);
        usersRef.set(item);
        vm.$root.alert.message = "החשבון עודכן בהצלחה";
        vm.$root.alert.isShow = true;
        vm.$localStorage.set('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(vm.user));
      }
    },
    cancel: function cancel() {
      var vm = this;
      vm.user = JSON.parse(vm.$localStorage.get('user'));
    },
    isValid: function isValid() {
      var vm = this;
      vm.error = "";

      if (vm.user.Username == undefined || vm.user.Username.length == 0) {
        vm.error = "* שם משתמש לא נכון";
        return false;
      }

      if (vm.user.Password == undefined || vm.user.Password.length == 0) {
        vm.error = "* נא הכנס סיסמה";
        return false;
      }

      if (vm.user.Password != vm.confirmPassword) {
        vm.error = "* אימות סיסמה נכשל";
        return false;
      }

      if (vm.user.FullName.length == 0) {
        vm.error = "* נא הכנס שם מלא";
        return false;
      }

      if (vm.user.Identity.length == 0) {
        vm.error = "* נא הכנס תעודת זהות";
        return false;
      }

      return true;
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupUser__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopupUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PopupUser__);





var usersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Users');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Observers',
  components: { PopupUser: __WEBPACK_IMPORTED_MODULE_3__components_PopupUser___default.a },
  data: function data() {
    return {
      txtSearch: '',
      users: [],
      observers: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: '', Password: '', Active: false, Approved: false }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      users: usersRef.orderByChild("Type").equalTo("משקיף")
    };
  },
  created: function created() {
    this.$Log("Vue [Observers] is created ...");
    var vm = this;
    if (!vm.$root.isAdmin) {
      vm.loadMyObservers();
    }
  },
  ready: function ready() {
    this.$Log("Vue [Observers] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Observers] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Observers] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.$root.isAdmin) {
        return vm.filteredRowsWithPermission(vm.users);
      } else {
        return vm.filteredRowsWithPermission(vm.observers);
      }
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveUser') {
        this.remove();
      }
    }
  },
  methods: {
    filteredRowsWithPermission: function filteredRowsWithPermission(usersArr) {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = usersArr.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                if (vm.isActiveUsers) {
                  if (row.Active) {
                    return row;
                  }
                } else {
                  return row;
                }
              }
            });
          });
        } catch (e) {}
      } else {
        if (vm.isActiveUsers) {
          result = usersArr.filter(function (row) {
            if (row.Active) {
              return row;
            }
          });
        } else {
          result = usersArr;
        }
      }

      return result;
    },
    loadMyObservers: function loadMyObservers() {
      var vm = this;
      vm.observers = [];
      var customerKey = vm.$root.user['.key'];
      var diariesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].ref('Diaries');
      diariesRef.orderByChild("CustomerKey").equalTo(customerKey).once('value').then(function (snapshot) {
        var obj = snapshot.val();
        if (obj) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);

          var _loop = function _loop() {
            var key = keys[i];
            var diary = obj[key];
            console.log("diary >>>> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(diary));
            if (diary.AddedUsers && diary.AddedUsers.length > 0) {
              var _loop2 = function _loop2() {
                var user = vm.users.find(function (usr) {
                  return usr['.key'] == diary.AddedUsers[u].UserKey;
                });

                if (user) {
                  var userExist = vm.observers.find(function (exist) {
                    return exist['.key'] == user['.key'];
                  });
                  if (!userExist) {
                    vm.observers.push(user);
                  }
                }
              };

              for (u = 0; u < diary.AddedUsers.length; u++) {
                _loop2();
              }
            }
          };

          for (var i = 0; i < keys.length; i++) {
            var u;

            _loop();
          }
        }
      });
    },
    currency: function currency(N) {
      N = parseFloat(N);
      if (!isNaN(N)) N = N.toFixed(2);else N = '0.00';
      return N + " ₪";
    },
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'משקיף חדש',
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'משקיף', Password: '', Active: false, Approved: false }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת משקיף',
        data: {
          '.key': row['.key'],
          FullName: row.FullName,
          Username: row.Username,
          Identity: row.Identity,
          Type: row.Type,
          Password: row.Password,
          Active: row.Active,
          Approved: row.Approved
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveUser',
        isConfirmed: false
      };
    },
    remove: function remove() {
      usersRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };

      usersRef.push(item);
    },
    update: function update() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };
      usersRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PDF__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PDF___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PDF__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PDFMobile__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PDFMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PDFMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Folder__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Folder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Folder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PopupConfim__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PopupConfim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PopupConfim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PopupAddFile__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PopupAddFile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PopupAddFile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SubMenu__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SubMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SubMenu__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Plan',
  components: { SubMenu: __WEBPACK_IMPORTED_MODULE_7__components_SubMenu___default.a, PDF: __WEBPACK_IMPORTED_MODULE_2__components_PDF___default.a, PDFMobile: __WEBPACK_IMPORTED_MODULE_3__components_PDFMobile___default.a, Folder: __WEBPACK_IMPORTED_MODULE_4__components_Folder___default.a, PopupConfirm: __WEBPACK_IMPORTED_MODULE_5__components_PopupConfim___default.a, PopupAddFile: __WEBPACK_IMPORTED_MODULE_6__components_PopupAddFile___default.a },
  data: function data() {
    return {
      isFilesVisible: false,
      treeData: null,
      rootFolder: {
        Title: "משפחת מורן-08",
        Key: "Root",
        SubFolders: [{
          Title: "אדריכלות",
          Key: 1,
          SubFolders: [],
          Files: [{ Key: 0, Title: 'Document 04Document 04Document 04', Url: 'tttttttt04' }, { Key: 0, Title: 'Document 05', Url: 'tttttttt05' }, { Key: 0, Title: 'Document 06', Url: 'tttttttt06' }]
        }, {
          Title: "ביוב ומים",
          Key: 2,
          SubFolders: [{
            Title: "אלומיניום",
            Key: 9,
            SubFolders: [],
            Files: [{ Key: 0, Title: 'Document 99Document 99Document 99', Url: 'tttttttt04' }, { Key: 0, Title: 'Document 99', Url: 'tttttttt05' }, { Key: 0, Title: 'Document 99', Url: 'tttttttt06' }]
          }],
          Files: [{ Key: 0, Title: 'DocumentDocumentDocument 07', Url: 'tttttttt07' }, { Key: 0, Title: 'Document 08', Url: 'tttttttt08' }, { Key: 0, Title: 'Document 09', Url: 'tttttttt09' }]
        }],
        Files: [{ Title: 'Document 01', Url: 'tttttttt01' }, { Title: 'Document 02', Url: 'tttttttt02' }, { Title: 'Document 03', Url: 'tttttttt03' }]
      },
      plan: {
        Name: '',
        Info: '',
        ProjectName: ''
      },
      rootData: null,
      planFilesTree: []
    };
  },
  created: function created() {
    this.$Log("Vue [Plan] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Plan] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Plan] is mounted ...");
    this.loadData();
    this.loadFiles();
    this.$root.selectedFile = '';
  },
  updated: function updated() {
    this.$Log("Vue [Plan] is updated ...");
  },

  computed: {
    rootPath: function rootPath() {
      return "PlaneFiles/" + this.$route.params.planKey + "/Root/";
    },
    canEdit: function canEdit() {
      if (this.$root.isAdmin) {
        return true;
      } else {
        return this.plan.UserKey == this.$root.user['.key'];
      }
    }
  },
  watch: {
    '$root.selectedFile': function $rootSelectedFile(val) {
      this.isFilesVisible = false;
    },
    '$root.isUpdatedPlan': function $rootIsUpdatedPlan(val) {
      if (val) {
        this.loadFiles();
        this.$root.isUpdatedPlan = false;
      }
    }
  },
  methods: {
    getStatus: function getStatus() {
      return "TEST";
    },
    loadData: function loadData() {
      var vm = this;
      var plansRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Plans').orderByKey().equalTo(vm.$route.params.planKey).once('value').then(function (snapPlan) {
        var obj = snapPlan.val();
        if (obj) {
          var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj)[0];
          var p = obj[key];
          p['.key'] = key;
          vm.plan = p;
        }
      });
    },
    loadFiles: function loadFiles() {
      var vm = this;
      var planeFilesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('PlaneFiles/' + vm.$route.params.planKey).once('value').then(function (snapPlanFiles) {
        vm.planFilesTree = snapPlanFiles.val();

        var objTree = snapPlanFiles.val();

        if (objTree) {

          vm.rootData = objTree;
        }
      });
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PopupPlan__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PopupPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PopupPlan__);




var plansRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Plans');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Plans',
  components: { PopupPlan: __WEBPACK_IMPORTED_MODULE_2__components_PopupPlan___default.a },
  data: function data() {
    return {
      txtSearch: '',
      plans: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        isEdit: false,
        title: '',
        data: {
          '.key': '',
          Title: '',
          Info: '',
          UserKey: '',
          ProjectKey: '',
          ProjectName: '',

          CreateDate: '',
          UpdateDate: ''
        }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      plans: vm.$root.isAdmin ? plansRef.orderByKey() : plansRef.orderByChild("UserKey").equalTo(vm.$root.user['.key'])
    };
  },
  created: function created() {
    this.$Log("Vue [Plans] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Plans] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Plans] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Plans] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = vm.plans.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                return row;
              }
            });
          });
        } catch (e) {}
      } else {
        result = vm.plans;
      }

      return result;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemovePlan') {
        this.remove();
      }
    }
  },
  methods: {
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'תוכנית בנייה חדשה',
        data: {
          '.key': '',
          Name: '',
          Info: '',
          UserKey: '',
          ProjectKey: '',
          ProjectName: '',

          CreateDate: '',
          UpdateDate: ''
        }
      };
    },
    open: function open(row) {
      var routeData = this.$router.resolve({ name: 'Plan', params: { planKey: row['.key'] } });

      if (this.$root.device.isTablet) {
        this.$router.push({ name: 'Plan', params: { planKey: row['.key'] } });
      } else {
        window.open(routeData.href, '_blank');
      }
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת תוכנית בנייה',
        data: {
          '.key': row['.key'],
          Name: row.Name,
          Info: row.Info,
          UserKey: row.UserKey,
          ProjectKey: row.ProjectKey,
          ProjectName: row.ProjectName,

          CreateDate: row.CreateDate,
          UpdateDate: this.$moment().format('DD/MM/YYYY')
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemovePlan',
        isConfirmed: false
      };
    },
    remove: function remove() {
      plansRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var item = {
        Name: this.popup.data.Name,
        Info: this.popup.data.Info,
        UserKey: this.$root.user['.key'],
        ProjectKey: this.popup.data.ProjectKey,
        ProjectName: this.popup.data.ProjectName,

        CreateDate: this.$moment().format('DD/MM/YYYY'),
        UpdateDate: this.$moment().format('DD/MM/YYYY')
      };

      var ref = plansRef.push(item);
      var newKey = ref.key;

      var planFilesPath = 'PlaneFiles/' + newKey + '/Root/Title';
      var planFilesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref(planFilesPath);
      planFilesRef.set(item.Name);
    },
    update: function update() {
      var item = {
        Name: this.popup.data.Name,
        Info: this.popup.data.Info,
        UserKey: this.$root.user['.key'],
        ProjectKey: this.popup.data.ProjectKey,
        ProjectName: this.popup.data.ProjectName,

        CreateDate: this.popup.data.CreateDate,
        UpdateDate: this.$moment().format('DD/MM/YYYY')
      };
      plansRef.child(this.popup.data['.key']).set(item);

      var planFilesPath = 'PlaneFiles/' + this.popup.data['.key'] + '/Root/Title';
      var planFilesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref(planFilesPath);
      planFilesRef.set(this.popup.data.Name);
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Toolbar__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TableProjects__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TableProjects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TableProjects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataMap__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DataMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PopupProject__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PopupProject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PopupProject__);




var projectsRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Projects');
var statusesRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Statuses');






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Projects',
  components: {
    Toolbar: __WEBPACK_IMPORTED_MODULE_2__components_Toolbar___default.a,
    TableProjects: __WEBPACK_IMPORTED_MODULE_3__components_TableProjects___default.a,
    DataMap: __WEBPACK_IMPORTED_MODULE_4__components_DataMap___default.a,
    PopupProject: __WEBPACK_IMPORTED_MODULE_5__components_PopupProject___default.a
  },
  data: function data() {
    return {
      txtSearch: '',
      selectedStatus: '',
      isMap: false,
      projects: [],
      statuses: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: {
          '.key': '',
          Name: '',
          City: '',
          Address: '',
          Location: { lat: 0, lng: 0 },
          Info: '',
          StatusKey: '',
          UserKey: '',
          Active: true,
          Images: [],
          CreateDate: '',
          UpdateDate: ''
        }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      projects: vm.$root.isAdmin ? projectsRef.orderByKey() : projectsRef.orderByChild("UserKey").equalTo(vm.$root.user['.key']),
      statuses: statusesRef.orderByKey()
    };
  },
  created: function created() {
    this.$Log("Vue [Projects] is created ...");
    if (this.$root.user.Type != "מנהל מערכת" && this.$root.user.Type != "רוכש") {
      this.$router.push({ name: 'MyDiaries' });
    }
  },
  ready: function ready() {
    this.$Log("Vue [Projects] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Projects] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Projects] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      var filteredProjects = vm.projects.filter(function (row) {
        if (vm.selectedStatus == "") {
          return true;
        } else {
          return row.StatusKey == vm.selectedStatus;
        }
      });
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          var rowsCount = 0;
          result = filteredProjects.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (key != "logo") {
                if (key == "Entrepreneur") {
                  if (String(row[key].FullName).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                    rowsCount++;
                    return row;
                  }
                } else {
                  if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                    rowsCount++;
                    return row;
                  }
                }
              }
            });
          });
        } catch (e) {}
      } else {
        var result = filteredProjects;
      }

      if (result && result.length > 0) {
        for (var r = 0; r < result.length; r++) {
          result[r].Percent = vm.calcProgress(result[r]);
          result[r].zIndex = 5000;
        }
      }

      return result;
    },
    counter: function counter() {
      return this.filteredRows.length;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveProject') {
        this.remove();
      }
    }
  },
  methods: {
    calcProgress: function calcProgress(row) {
      var startDate = this.$moment(row.StartDate, 'DD/MM/YYYY');
      var endDate = this.$moment(row.EndDate, 'DD/MM/YYYY');
      var today = this.$moment();
      var totalDays = 0;
      var duration;

      duration = this.$moment.duration(endDate.diff(startDate));
      var daysProject = duration.asDays();

      duration = this.$moment.duration(today.diff(startDate));
      var daysStarted = duration.asDays();

      duration = this.$moment.duration(endDate.diff(today));
      var daysEnded = duration.asDays();

      var percent = 0;

      if (daysStarted <= 0) {
        percent = 0;
      } else if (daysEnded <= 0) {
        percent = 100;
      } else {
        percent = daysStarted / daysProject * 100;
      }

      return Math.round(percent, 0);
    },
    getStatusColor: function getStatusColor(statusKey) {
      var selectedColor = '#F7941D';
      for (var i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i]['.key'] == statusKey) {
          selectedColor = this.statuses[i].Color;
          break;
        }
      }
      return selectedColor;
    },
    getStatusName: function getStatusName(statusKey) {
      var selectedName = '';
      for (var i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i]['.key'] == statusKey) {
          selectedName = this.statuses[i].Name;
          break;
        }
      }
      return selectedName;
    },
    addNew: function addNew(location) {
      if (location == null || location == undefined) {
        location = { lat: 0, lng: 0 };
      }
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'פרויקט חדש',
        data: {
          '.key': '',
          Name: '',
          City: '',
          Address: '',
          Location: location,
          Info: '',
          StatusKey: '',
          UserKey: this.$root.user['.key'],
          Active: true,
          Images: [],
          CreateDate: '',
          UpdateDate: '',
          StartDate: this.$moment().format("YYYY-MM-DD"),
          EndDate: this.$moment().format("YYYY-MM-DD"),
          Entrepreneur: { UserKey: '', FullName: '' }
        }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת פרויקט',
        data: {
          '.key': row['.key'],
          Name: row.Name,
          City: row.City,
          Address: row.Address,
          Location: row.Location,
          Info: row.Info,
          StatusKey: row.StatusKey,
          UserKey: row.UserKey,
          Active: row.Active,
          Images: row.Images,
          CreateDate: row.CreateDate,
          UpdateDate: this.$moment().format('DD/MM/YYYY'),
          StartDate: this.$moment(row.StartDate, 'DD/MM/YYYY').format("YYYY-MM-DD"),
          EndDate: this.$moment(row.EndDate, 'DD/MM/YYYY').format("YYYY-MM-DD"),
          Entrepreneur: row.Entrepreneur ? row.Entrepreneur : { UserKey: '', FullName: '' }
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveProject',
        isConfirmed: false
      };
    },
    remove: function remove() {
      projectsRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var item = {
        Name: this.popup.data.Name,
        City: this.popup.data.City,
        Address: this.popup.data.Address,
        Location: this.popup.data.Location,
        Info: this.popup.data.Info,
        StatusKey: this.popup.data.StatusKey,
        UserKey: this.popup.data.UserKey,
        Active: this.popup.data.Active,
        Images: this.popup.data.Images,
        CreateDate: this.$moment().format('DD/MM/YYYY'),
        UpdateDate: this.$moment().format('DD/MM/YYYY'),
        StartDate: this.$moment(this.popup.data.StartDate, "YYYY-MM-DD").format('DD/MM/YYYY'),
        EndDate: this.$moment(this.popup.data.EndDate, "YYYY-MM-DD").format('DD/MM/YYYY'),
        Entrepreneur: this.popup.data.Entrepreneur
      };
      projectsRef.push(item);
    },
    update: function update() {
      var item = {
        Name: this.popup.data.Name,
        City: this.popup.data.City,
        Address: this.popup.data.Address,
        Location: this.popup.data.Location,
        Info: this.popup.data.Info,
        StatusKey: this.popup.data.StatusKey,
        UserKey: this.popup.data.UserKey,
        Active: this.popup.data.Active,
        Images: this.popup.data.Images,
        CreateDate: this.popup.data.CreateDate,
        UpdateDate: this.popup.data.UpdateDate,
        StartDate: this.$moment(this.popup.data.StartDate, "YYYY-MM-DD").format('DD/MM/YYYY'),
        EndDate: this.$moment(this.popup.data.EndDate, "YYYY-MM-DD").format('DD/MM/YYYY'),
        Entrepreneur: this.popup.data.Entrepreneur
      };
      projectsRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportProjects__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportProjects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ReportProjects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ReportCustomers__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ReportCustomers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ReportCustomers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ReportDiaries__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ReportDiaries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ReportDiaries__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Reports',
  components: { ReportProjects: __WEBPACK_IMPORTED_MODULE_0__components_ReportProjects___default.a, ReportCustomers: __WEBPACK_IMPORTED_MODULE_1__components_ReportCustomers___default.a, ReportDiaries: __WEBPACK_IMPORTED_MODULE_2__components_ReportDiaries___default.a },
  data: function data() {
    return {
      txtSearch: '',
      selectedReport: '',
      reports: ['דוח פרויקטים', 'דוח לקוחות']
    };
  },
  created: function created() {
    this.$Log("Vue [Reports] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Reports] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Reports] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Reports] is updated ...");
  },

  computed: {
    rptProjects: function rptProjects() {
      return this.selectedReport == 'דוח פרויקטים';
    },
    rptCustomers: function rptCustomers() {
      return this.selectedReport == 'דוח לקוחות';
    },
    rptDiaries: function rptDiaries() {
      return this.selectedReport == 'דוח יומנים';
    }
  },
  methods: {}
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_user_png__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_user_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_user_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TablePackages__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TablePackages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TablePackages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TableStatuses__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TableStatuses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TableStatuses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TableSettings__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TableSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TableSettings__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    TablePackages: __WEBPACK_IMPORTED_MODULE_1__components_TablePackages___default.a,
    TableStatuses: __WEBPACK_IMPORTED_MODULE_2__components_TableStatuses___default.a,
    TableSettings: __WEBPACK_IMPORTED_MODULE_3__components_TableSettings___default.a
  },
  data: function data() {
    return {
      txtSearch: '',
      customersList: [],
      isDelete: false,
      isEdit: false,
      isNew: false,
      selectedTab: "tab-0"
    };
  },
  created: function created() {
    this.$Log("Vue [Settings] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Settings] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Settings] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Settings] is updated ...");
  },

  computed: {},
  watch: {},
  methods: {}
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PopupUser__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PopupUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PopupUser__);








var usersRef = __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* db */].ref('Users');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Users',
  components: { PopupUser: __WEBPACK_IMPORTED_MODULE_5__components_PopupUser___default.a },
  data: function data() {
    return {
      txtSearch: '',
      users: [],
      isActiveUsers: false,
      popup: {
        isVisible: false,
        title: '',
        question: '',
        caller: '',
        isConfirmed: false,
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: '', Password: '', Active: false, Approved: false }
      }
    };
  },

  firebase: function firebase() {
    var vm = this;
    return {
      users: usersRef.orderByChild("Type").equalTo("מנהל מערכת")
    };
  },
  created: function created() {
    this.$Log("Vue [Users] is created ...");
  },
  ready: function ready() {
    this.$Log("Vue [Users] is ready ...");
  },
  mounted: function mounted() {
    this.$Log("Vue [Users] is mounted ...");
  },
  updated: function updated() {
    this.$Log("Vue [Users] is updated ...");
  },

  computed: {
    hasData: function hasData() {
      return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
    },
    filteredRows: function filteredRows() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var result = [];
        try {
          result = vm.users.filter(function (row) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
              if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                if (vm.isActiveUsers) {
                  if (row.Active) {
                    return row;
                  }
                } else {
                  return row;
                }
              }
            });
          });
        } catch (e) {}
      } else {
        if (vm.isActiveUsers) {
          result = vm.users.filter(function (row) {
            if (row.Active) {
              return row;
            }
          });
        } else {
          result = vm.users;
        }
      }

      return result;
    }
  },
  watch: {
    '$root.confirm.isConfirmed': function $rootConfirmIsConfirmed(val) {
      if (val && this.$root.confirm.caller == 'RemoveUser') {
        this.remove();
      }
    }
  },
  methods: {
    currency: function currency(N) {
      N = parseFloat(N);
      if (!isNaN(N)) N = N.toFixed(2);else N = '0.00';
      return N + " ₪";
    },
    addNew: function addNew() {
      this.popup = {
        isVisible: true,
        isEdit: false,
        title: 'משתמש חדש',
        data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'מנהל מערכת', Password: '', Active: false, Approved: false }
      };
    },
    edit: function edit(row) {
      this.popup = {
        isVisible: true,
        isEdit: true,
        title: 'עריכת משתמש',
        data: {
          '.key': row['.key'],
          FullName: row.FullName,
          Username: row.Username,
          Identity: row.Identity,
          Type: row.Type,
          Password: row.Password,
          Active: row.Active,
          Approved: row.Approved
        }
      };
    },
    confirm: function confirm(row) {
      this.popup.data = row;
      this.$root.confirm = {
        isVisible: true,
        title: 'מחיקה',
        question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
        caller: 'RemoveUser',
        isConfirmed: false
      };
    },
    remove: function remove() {
      usersRef.child(this.popup.data['.key']).remove();
    },
    insert: function insert() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };

      usersRef.push(item);

      var createUserUrl = "https://us-central1-getnet-c2357.cloudfunctions.net/CreateUser";
      createUserUrl = createUserUrl + "?" + "userData=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item);

      __WEBPACK_IMPORTED_MODULE_2_jsonp___default()(createUserUrl, {}, function (error, data) {
        console.log("user ERROR >> " + error);
        console.log("user DATA >> " + data);
        console.log("user ERROR >> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        console.log("user DATA >> " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      });
    },
    update: function update() {
      var item = {
        FullName: this.popup.data.FullName,
        Username: this.popup.data.Username,
        Identity: this.popup.data.Identity,
        Type: this.popup.data.Type,
        Password: this.popup.data.Password,
        Active: this.popup.data.Active,
        Approved: this.popup.data.Approved
      };
      usersRef.child(this.popup.data['.key']).set(item);
    }
  }
});

/***/ }),
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_duration_format__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_duration_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_duration_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_jsonp__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobile_detect__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobile_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_i18n__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__routes__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_resource__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_api_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_moment_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_log_js__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__langs_hebrew_json__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__langs_hebrew_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__langs_hebrew_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__firebase__ = __webpack_require__(3);




var _ref;




















var mapKey = 'AIzaSyBoTa88_jMgJnMFJRiNzovZjTprk8MOxj0';
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__, {
    load: {
        key: 'AIzaSyBun7sj5tRwMXnUTnzENiwJofZgnYhr504',
        v: '3.30',
        libraries: 'places, geometry, drawing',
        language: 'he'
    }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__plugins_api_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16__plugins_moment_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_17__plugins_log_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_jsonp___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

var labels = { iw: __WEBPACK_IMPORTED_MODULE_18__langs_hebrew_json___default.a };

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */], labels);
var i18n = new __WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]({
    locale: 'iw',
    fallbackLocale: 'iw',
    messages: labels
});




var usersRef = __WEBPACK_IMPORTED_MODULE_20__firebase__["a" /* db */].ref('Users');
var settingsRef = __WEBPACK_IMPORTED_MODULE_20__firebase__["a" /* db */].ref('Settings');

new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]((_ref = {
    i18n: i18n,
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_13__routes__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_11__App___default.a },
    data: function data() {
        return {
            detect: new __WEBPACK_IMPORTED_MODULE_10_mobile_detect___default.a(window.navigator.userAgent),
            device: { isMobile: false, os: '' },
            activeSubMenu: false,
            activeMobileMenu: false,
            token: null,
            loginError: '',
            config: {
                version: '1.0',
                isDebug: true,
                username: '',
                password: '',
                apiUrl: ''
            },
            timezone: null,
            weather: null,
            activeDiaryPage: { Date: '', PageKey: null, Weather: '' },
            isTest: true,
            online: false,
            user: null,
            customer: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', Password: '', TotalDiaries: 0, UsedDiaries: 0 },
            language: 'en',
            isRTL: true,
            customersList: [],
            notification: { isShow: false, activityId: null, info: '', from: '', event: '' },
            alert: { isShow: false, message: '', timeout: 3000, isTop: true },
            isLoginFromReset: false,
            isReady: false,
            confirm: {
                isVisible: false,
                title: '',
                question: '',
                caller: '',
                isConfirmed: false
            },
            confirmAddDiaries: {
                isVisible: false,
                totalDiaries: 0,
                isConfirmed: false
            },
            confirmAddFile: {
                isVisible: false,
                caller: '',
                isConfirmed: false,
                path: ''
            },
            userTypes: ['מנהל מערכת', 'רוכש', 'מנהל עבודה', 'מפקח'],
            isNewNote: false,
            isNewGeneralNote: false,
            isNewInfoNote: false,
            isEditNote: false,
            auth: null,
            isAdmin: false,
            isCustomer: false,
            isObserver: false,
            isInspector: false,
            isContractor: false,
            userKey: null,
            messagesCounter: 0,
            selectedFile: '',
            isUpdatedPlan: false,
            settings: false
        };
    },

    computed: {
        activePage: function activePage() {
            return this.$route.name;
        }
    },
    watch: {
        userKey: function userKey(val) {
            var vm = this;
            var messagesRef = __WEBPACK_IMPORTED_MODULE_20__firebase__["a" /* db */].ref('Messages').orderByChild("ToUserKey").equalTo(val);
            messagesRef.on('value', function (snapshot) {
                vm.messagesCounter = 0;
                var data = snapshot.val();
                if (data) {
                    var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data);
                    for (var k = 0; k < keys.length; k++) {
                        var key = keys[k];
                        var msg = data[key];
                        if (!msg.IsConfirmed) {
                            vm.messagesCounter++;
                        }
                    }
                }
            });
        },
        language: function language(val) {
            i18n.locale = val;
            if (val == "iw") {
                this.isRTL = true;
            } else {
                this.isRTL = false;
            }
        },

        $route: function $route(val) {
            this.$root.activePage = val.path;
        },
        activePage: function activePage(val) {
            console.log("Active page = " + val);
        },
        'confirm.isConfirmed': function confirmIsConfirmed(val) {
            if (val && this.$root.confirm.caller == 'Logout') {
                this.logout();
            }
        }
    },
    created: function created() {
        this.$ForceLog("Vue [main] is created ...");

        var vm = this;

        if ('serviceWorker' in navigator) {
            console.log("Start registring service worker ...");
            navigator.serviceWorker.register('static/fcm-sw.js').then(function (registration) {
                console.log("Service worker was registered.");
                return __WEBPACK_IMPORTED_MODULE_20__firebase__["b" /* fcm */].useServiceWorker(registration);
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_20__firebase__["b" /* fcm */].requestPermission().then(function () {
                    console.log('Notification permission granted.');
                    return __WEBPACK_IMPORTED_MODULE_20__firebase__["b" /* fcm */].getToken();
                }).then(function (token) {
                    console.log('Notification token is ready.');
                    console.log(token);
                    vm.token = token;
                }).catch(function (err) {
                    console.log('Unable to get permission to notify.', err);
                });
            }).catch(function (err) {
                console.log("Service worker failed :", err);
            });
        } else {}

        __WEBPACK_IMPORTED_MODULE_20__firebase__["b" /* fcm */].onMessage(function (payload) {
            console.log("Message received. ", payload);

            var notificationOptions = {
                body: payload.notification.body,
                icon: payload.notification.icon
            };
            new Notification(payload.notification.title, notificationOptions);
        });

        console.log("this.detect.mobile() >> " + vm.detect.mobile());
        console.log("this.detect.phone() >> " + vm.detect.phone());
        console.log("this.detect.tablet() >> " + vm.detect.tablet());
        console.log("this.detect.userAgent() >> " + vm.detect.userAgent());
        console.log("this.detect.os() >> " + vm.detect.os());
        console.log("this.detect.is('iPhone') >> " + vm.detect.is('iPhone'));
        console.log("this.detect.is('AndroidOS') >> " + vm.detect.is('AndroidOS'));
        console.log("this.detect.version('Webkit') >> " + vm.detect.version('Webkit'));

        vm.user = vm.$localStorage.get('user');
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(vm.user));

        vm.device.isMobile = false;
        vm.device.isTablet = false;

        if (vm.detect.phone()) {
            vm.device.isMobile = true;
            vm.activeSubMenu = false;
            vm.device.os = this.detect.os();
            console.log(">>> Run on mobile <<<");
        } else if (vm.detect.tablet()) {
            vm.device.isTablet = true;
            vm.activeSubMenu = true;
            console.log(">>> Run on tablet <<<");
        } else {
            vm.activeSubMenu = true;
            console.log(">>> Run on browser <<<");
        }

        if (vm.user != null) {
            vm.user = JSON.parse(vm.user);


            vm.userKey = vm.user['.key'];

            vm.isAdmin = vm.user.Type == 'מנהל מערכת';
            vm.isCustomer = vm.user.Type == 'רוכש';
            vm.isObserver = vm.user.Type == 'משקיף';
            vm.isInspector = vm.user.Type == 'מפקח';
            vm.isContractor = vm.user.Type == 'מנהל עבודה';

            if (vm.$route.path == "/" || vm.$route.path == "Login") {
                vm.loginDirect();
            }
        } else {
            vm.goto('Login');
        }
    },
    ready: function ready() {
        this.$Log("Vue [main] is ready ...");
    },
    mounted: function mounted() {
        this.$Log("Vue [main] is mounted ...");
    },
    updated: function updated() {
        this.$Log("Vue [main] is updated ...");
    }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'watch', {
    isCustomer: function isCustomer(val) {
        if (val) {
            this.loadCustomer();
        }
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'firebase', function firebase() {
    var vm = this;
    return {
        settings: settingsRef.orderByKey()
    };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'methods', {
    appClick: function appClick(event) {
        this.$Log('app11');
    },
    loadCustomer: function loadCustomer() {},
    goto: function goto(page) {
        this.$router.push({ name: page });
    },
    confirmSignout: function confirmSignout() {
        this.$root.confirm = {
            isVisible: true,
            title: 'تسجيل الخروج',
            question: 'هل أنت متأكد ترغب بتسجيل الخروج?',
            caller: 'Signout',
            isConfirmed: false
        };
    },
    logout: function logout() {
        var vm = this;
        vm.$root.user = null;
        vm.$localStorage.remove('user');
        vm.goto('Login');
    },
    loginDirect: function loginDirect() {
        var vm = this;
        vm.$Log("Vue [main] is loginDirect ...");

        vm.goto('Diaries');
    },
    login: function login(username, password) {
        var vm = this;

        vm.isAdmin = false;
        vm.isCustomer = false;
        vm.isObserver = false;
        vm.isInspector = false;
        vm.isContractor = false;

        if (vm.isValidLogin(username, password)) {
            usersRef.orderByChild("Username").equalTo(username.toLowerCase()).once('value').then(function (snapshot) {
                var obj = snapshot.val();

                if (obj) {
                    var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj)[0];
                    var usr = obj[key];
                    if (usr.Password == password) {
                        vm.user = usr;
                        vm.user.Token = vm.token;
                        var userRef = __WEBPACK_IMPORTED_MODULE_20__firebase__["a" /* db */].ref("Users/" + key);
                        userRef.set(vm.$root.user);

                        vm.user['.key'] = key;
                        vm.userKey = vm.user['.key'];
                        vm.$localStorage.set('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(vm.$root.user));
                        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(vm.user));

                        vm.isAdmin = vm.user.Type == 'מנהל מערכת';
                        vm.isCustomer = vm.user.Type == 'רוכש';
                        vm.isObserver = vm.user.Type == 'משקיף';
                        vm.isInspector = vm.user.Type == 'מפקח';
                        vm.isContractor = vm.user.Type == 'מנהל עבודה';

                        vm.goto('Diaries');
                    } else {
                        vm.loginError = "* שם משתמש או סיסמה לא נכונים";
                    }
                } else {
                    vm.loginError = "* שם משתמש או סיסמה לא נכונים";
                }
            });
        } else {}
    },
    isValidLogin: function isValidLogin(username, password) {
        var vm = this;
        var valid = false;
        vm.loginError = "";

        if (username == undefined || username.length == 0) {
            vm.loginError = "* נא הכנס שם משתמש";
        } else {
            if (password == undefined || password.length == 0) {
                vm.loginError = "* נא הכנס סיסמה";
            } else {
                valid = true;
            }
        }

        return valid;
    }
}), _ref));

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 236,
	"./af.js": 236,
	"./ar": 243,
	"./ar-dz": 237,
	"./ar-dz.js": 237,
	"./ar-kw": 238,
	"./ar-kw.js": 238,
	"./ar-ly": 239,
	"./ar-ly.js": 239,
	"./ar-ma": 240,
	"./ar-ma.js": 240,
	"./ar-sa": 241,
	"./ar-sa.js": 241,
	"./ar-tn": 242,
	"./ar-tn.js": 242,
	"./ar.js": 243,
	"./az": 244,
	"./az.js": 244,
	"./be": 245,
	"./be.js": 245,
	"./bg": 246,
	"./bg.js": 246,
	"./bn": 247,
	"./bn.js": 247,
	"./bo": 248,
	"./bo.js": 248,
	"./br": 249,
	"./br.js": 249,
	"./bs": 250,
	"./bs.js": 250,
	"./ca": 251,
	"./ca.js": 251,
	"./cs": 252,
	"./cs.js": 252,
	"./cv": 253,
	"./cv.js": 253,
	"./cy": 254,
	"./cy.js": 254,
	"./da": 255,
	"./da.js": 255,
	"./de": 258,
	"./de-at": 256,
	"./de-at.js": 256,
	"./de-ch": 257,
	"./de-ch.js": 257,
	"./de.js": 258,
	"./dv": 259,
	"./dv.js": 259,
	"./el": 260,
	"./el.js": 260,
	"./en-au": 261,
	"./en-au.js": 261,
	"./en-ca": 262,
	"./en-ca.js": 262,
	"./en-gb": 263,
	"./en-gb.js": 263,
	"./en-ie": 264,
	"./en-ie.js": 264,
	"./en-nz": 265,
	"./en-nz.js": 265,
	"./eo": 266,
	"./eo.js": 266,
	"./es": 268,
	"./es-do": 267,
	"./es-do.js": 267,
	"./es.js": 268,
	"./et": 269,
	"./et.js": 269,
	"./eu": 270,
	"./eu.js": 270,
	"./fa": 271,
	"./fa.js": 271,
	"./fi": 272,
	"./fi.js": 272,
	"./fo": 273,
	"./fo.js": 273,
	"./fr": 276,
	"./fr-ca": 274,
	"./fr-ca.js": 274,
	"./fr-ch": 275,
	"./fr-ch.js": 275,
	"./fr.js": 276,
	"./fy": 277,
	"./fy.js": 277,
	"./gd": 278,
	"./gd.js": 278,
	"./gl": 279,
	"./gl.js": 279,
	"./gom-latn": 280,
	"./gom-latn.js": 280,
	"./he": 281,
	"./he.js": 281,
	"./hi": 282,
	"./hi.js": 282,
	"./hr": 283,
	"./hr.js": 283,
	"./hu": 284,
	"./hu.js": 284,
	"./hy-am": 285,
	"./hy-am.js": 285,
	"./id": 286,
	"./id.js": 286,
	"./is": 287,
	"./is.js": 287,
	"./it": 288,
	"./it.js": 288,
	"./ja": 289,
	"./ja.js": 289,
	"./jv": 290,
	"./jv.js": 290,
	"./ka": 291,
	"./ka.js": 291,
	"./kk": 292,
	"./kk.js": 292,
	"./km": 293,
	"./km.js": 293,
	"./kn": 294,
	"./kn.js": 294,
	"./ko": 295,
	"./ko.js": 295,
	"./ky": 296,
	"./ky.js": 296,
	"./lb": 297,
	"./lb.js": 297,
	"./lo": 298,
	"./lo.js": 298,
	"./lt": 299,
	"./lt.js": 299,
	"./lv": 300,
	"./lv.js": 300,
	"./me": 301,
	"./me.js": 301,
	"./mi": 302,
	"./mi.js": 302,
	"./mk": 303,
	"./mk.js": 303,
	"./ml": 304,
	"./ml.js": 304,
	"./mr": 305,
	"./mr.js": 305,
	"./ms": 307,
	"./ms-my": 306,
	"./ms-my.js": 306,
	"./ms.js": 307,
	"./my": 308,
	"./my.js": 308,
	"./nb": 309,
	"./nb.js": 309,
	"./ne": 310,
	"./ne.js": 310,
	"./nl": 312,
	"./nl-be": 311,
	"./nl-be.js": 311,
	"./nl.js": 312,
	"./nn": 313,
	"./nn.js": 313,
	"./pa-in": 314,
	"./pa-in.js": 314,
	"./pl": 315,
	"./pl.js": 315,
	"./pt": 317,
	"./pt-br": 316,
	"./pt-br.js": 316,
	"./pt.js": 317,
	"./ro": 318,
	"./ro.js": 318,
	"./ru": 319,
	"./ru.js": 319,
	"./sd": 320,
	"./sd.js": 320,
	"./se": 321,
	"./se.js": 321,
	"./si": 322,
	"./si.js": 322,
	"./sk": 323,
	"./sk.js": 323,
	"./sl": 324,
	"./sl.js": 324,
	"./sq": 325,
	"./sq.js": 325,
	"./sr": 327,
	"./sr-cyrl": 326,
	"./sr-cyrl.js": 326,
	"./sr.js": 327,
	"./ss": 328,
	"./ss.js": 328,
	"./sv": 329,
	"./sv.js": 329,
	"./sw": 330,
	"./sw.js": 330,
	"./ta": 331,
	"./ta.js": 331,
	"./te": 332,
	"./te.js": 332,
	"./tet": 333,
	"./tet.js": 333,
	"./th": 334,
	"./th.js": 334,
	"./tl-ph": 335,
	"./tl-ph.js": 335,
	"./tlh": 336,
	"./tlh.js": 336,
	"./tr": 337,
	"./tr.js": 337,
	"./tzl": 338,
	"./tzl.js": 338,
	"./tzm": 340,
	"./tzm-latn": 339,
	"./tzm-latn.js": 339,
	"./tzm.js": 340,
	"./uk": 341,
	"./uk.js": 341,
	"./ur": 342,
	"./ur.js": 342,
	"./uz": 344,
	"./uz-latn": 343,
	"./uz-latn.js": 343,
	"./uz.js": 344,
	"./vi": 345,
	"./vi.js": 345,
	"./x-pseudo": 346,
	"./x-pseudo.js": 346,
	"./yo": 347,
	"./yo.js": 347,
	"./zh-cn": 348,
	"./zh-cn.js": 348,
	"./zh-hk": 349,
	"./zh-hk.js": 349,
	"./zh-tw": 350,
	"./zh-tw.js": 350
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 773;

/***/ }),
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/helmetSmall.3908b69.png";

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon.428f467.png";

/***/ }),
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(910),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(863),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(611)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(911),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(917),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(864),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(895),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(887),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(608)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(907),
  /* scopeId */
  "data-v-7fd35c1d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(883),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(594)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(893),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(881),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(898),
  /* scopeId */
  "data-v-6e153452",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(891),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(613)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(913),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(886),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(878),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(869),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(597)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(896),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(606)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(905),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(877),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(885),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(865),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(890),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(612)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(912),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(595)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(894),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(615)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(915),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(871),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(888),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(868),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(903),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(610)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(909),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(873),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(862),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(614)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(914),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(616)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(916),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(875),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(577)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(876),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(884),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(901),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(867),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(900),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(902),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(593)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(892),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(879),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(899),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(889),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(866),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(870),
  /* scopeId */
  "data-v-1fac3a7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(882),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(874),
  /* scopeId */
  "data-v-2a495d6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "fullToolbar"
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("recent_actors")]), _vm._v("\n    " + _vm._s(_vm.$t('projects')) + "\n    "), _c('v-btn', {
    staticStyle: {
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "fab": "",
      "light": "",
      "small": "",
      "color": "primary",
      "title": "הוסף חדש"
    },
    nativeOn: {
      "click": function($event) {
        _vm.isNew = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "width": "120px",
      "height": "30px"
    },
    attrs: {
      "light": "",
      "small": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("list")]), _vm._v("הצג רשימה\n    ")], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "width": "120px",
      "height": "30px"
    },
    attrs: {
      "light": "",
      "small": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("place")]), _vm._v("הצג מפה\n    ")], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px",
      "text-align": "center!important"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "border-left": "1px solid #eee"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n            שם פרויקט\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Name),
      expression: "$parent.popup.data.Name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n            ישוב\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.City),
      expression: "$parent.popup.data.City"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.City = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n            כתובת\n          ")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Address),
      expression: "$parent.popup.data.Address"
    }],
    staticStyle: {
      "background-color": "yellow"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Address = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n            תיאור פרויקט\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Info),
      expression: "$parent.popup.data.Info"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Info = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n            יזם\n          ")]), _vm._v(" "), (_vm.$parent.popup.data.Entrepreneur.UserKey) ? _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "margin": "10px 40px 10px 40px",
      "padding": "5px",
      "text-align": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$parent.popup.data.Entrepreneur.FullName) + "\n              "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:right",
      value: ({
        html: 'מחיקה'
      }),
      expression: "{ html: 'מחיקה' }",
      arg: "right"
    }],
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.removeEntrepreneur()
      }
    }
  }, [_vm._v("delete")])], 1)]) : _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtSearchEntrepreneur),
      expression: "txtSearchEntrepreneur"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "חפש יזם"
    },
    domProps: {
      "value": (_vm.txtSearchEntrepreneur)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtSearchEntrepreneur = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filteredEntrepreneurs.length) ? _c('div', {
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px",
      "margin-right": "45px",
      "max-height": "150px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.filteredEntrepreneurs), function(item) {
    return _c('v-layout', {
      staticClass: "divAddedUser",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "xs12": "",
        "right": ""
      },
      on: {
        "click": function($event) {
          _vm.selectEntrepreneur(item)
        }
      }
    }, [_vm._v(_vm._s(item.FullName))])], 1)
  })) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n            שלב התקדמות\n          ")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-right": "50px"
    },
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticClass: "divColorIcon",
    style: ({
      'background-color': _vm.selectedColor
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "width": "170px",
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.StatusKey),
      expression: "$parent.popup.data.StatusKey"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "width": "168px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$parent.popup.data.StatusKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("בחר שלב")]), _vm._v(" "), _vm._l((_vm.$parent.statuses), function(status) {
    return _c('option', {
      domProps: {
        "value": status['.key']
      }
    }, [_vm._v(_vm._s(status.Name))])
  })], 2)])])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n            תאריך התחלה\n          ")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "50px"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.StartDate),
      expression: "$parent.popup.data.StartDate"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.StartDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.StartDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n            תאריך סיום\n          ")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "50px"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.EndDate),
      expression: "$parent.popup.data.EndDate"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "date",
      "min": _vm.startDate
    },
    domProps: {
      "value": (_vm.$parent.popup.data.EndDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.EndDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "height": "75%",
      "position": "relative"
    }
  }, [(_vm.hasImages) ? _c('img', {
    staticClass: "imgPreview",
    attrs: {
      "src": _vm.activeImage
    }
  }) : _c('img', {
    staticClass: "imgPreview",
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v(" "), (_vm.hasImages) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'מחיקה'
      }),
      expression: "{ html: 'מחיקה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 btnRemoveImage",
    on: {
      "click": _vm.removeImage
    }
  }, [_vm._v("close")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right"
    }
  }, _vm._l((_vm.$parent.popup.data.Images), function(img) {
    return _c('img', {
      class: ['imgThumb', _vm.activeImage == img ? 'active' : ''],
      attrs: {
        "src": img
      },
      on: {
        "click": function($event) {
          _vm.activeImage = img
        }
      }
    })
  })), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "vertical-align": "bottom",
      "text-align": "right"
    }
  }, [_c('label', {
    staticClass: "file-select"
  }, [_vm._v("\n            העלאת תמונה\n            "), _c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showProgress),
      expression: "!showProgress"
    }, {
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'העלאת תמונה'
      }),
      expression: "{ html: 'העלאת תמונה' }",
      arg: "bottom"
    }],
    staticClass: "green--text",
    attrs: {
      "right": ""
    }
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }],
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.upload
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.canEdit) ? _c('v-flex', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1) : _c('v-flex', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        סגור חלון\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-layout', {
    staticClass: "fullToolbar",
    staticStyle: {
      "width": "100%",
      "height": "80px"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": "",
      "right": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "width": "100%",
      "padding-top": "15px",
      "color": "#fff"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    staticStyle: {
      "font-size": "30px",
      "padding": "10px",
      "float": "right"
    }
  }, [_vm._v("business_center")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "30px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.$t('projects')))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "width": "100%",
      "padding-top": "10px",
      "color": "#fff"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "right": ""
    }
  }, [(!_vm.isMap) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'הצג מפה'
      }),
      expression: "{ html: 'הצג מפה' }",
      arg: "bottom"
    }],
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.isMap = !_vm.isMap
      }
    }
  }, [_vm._v("place")]) : _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'הצג רשימה'
      }),
      expression: "{ html: 'הצג רשימה' }",
      arg: "bottom"
    }],
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.isMap = !_vm.isMap
      }
    }
  }, [_vm._v("list")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStatus),
      expression: "selectedStatus"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1",
      "disabled": "disabled"
    }
  }, [_vm._v("סינון שלב התקדמות")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("הצג הכל")]), _vm._v(" "), _vm._l((_vm.statuses), function(status) {
    return _c('option', {
      domProps: {
        "value": status['.key']
      }
    }, [_vm._v(_vm._s(status.Name))])
  })], 2)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "20px",
      "float": "right",
      "padding-top": "10px"
    }
  }, [_vm._v("נמצאו: " + _vm._s(_vm.counter) + " פרויקטים")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "left": ""
    }
  }, [(!_vm.$root.device.isMobile) ? _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  }) : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1)], 1), _vm._v(" "), (!_vm.isMap) ? _c('TableProjects') : _c('DataMap'), _vm._v(" "), _c('PopupProject')], 1)
},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: [_vm.$root.isRTL ? 'RLT' : ''],
    attrs: {
      "standalone": ""
    }
  }, [_c('v-navigation-drawer', {
    class: [_vm.$root.device.isTablet ? 'tabletMenu' : '', _vm.$root.isRTL ? 'navigation-drawer--right' : '', 'elevation-10'],
    staticStyle: {
      "padding": "0px",
      "margin": "0px",
      "z-index": "200"
    },
    attrs: {
      "hide-overlay": "",
      "light": ""
    },
    model: {
      value: (_vm.$root.activeSubMenu),
      callback: function($$v) {
        _vm.$root.activeSubMenu = $$v
      },
      expression: "$root.activeSubMenu"
    }
  }, [_c('SubMenu')], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "z-index": "100"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.$root.alert.timeout,
      "top": _vm.$root.alert.isTop
    },
    model: {
      value: (_vm.$root.alert.isShow),
      callback: function($$v) {
        _vm.$root.alert.isShow = $$v
      },
      expression: "$root.alert.isShow"
    }
  }, [_vm._v(_vm._s(_vm.$root.alert.message))]), _vm._v(" "), _c('PopupConfim'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('div', {
    class: ['mobileMenu', _vm.$root.activeMobileMenu ? 'activeMenu' : '']
  }, [_c('SubMenu')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.packages), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData  sp"
    }, [_vm._v(_vm._s(row.Name))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Diaries))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(_vm.currency(row.Price)))]), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1)])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupPackage')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם חבילה")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("מספר יומנים")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("מחיר ₪")]), _vm._v(" "), _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  })])])
}]}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        שם לקוח\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.FullName),
      expression: "$parent.popup.data.FullName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.FullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.FullName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        איש קשר\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.ContactPerson),
      expression: "$parent.popup.data.ContactPerson"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.ContactPerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.ContactPerson = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        טלפון\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Phone),
      expression: "$parent.popup.data.Phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Phone = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        שם משתמש\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Username),
      expression: "$parent.popup.data.Username"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Username = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.isRTL ? 'fullContentRTL' : 'fullContent']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("equalizer")]), _vm._v("\n        " + _vm._s(_vm.$t('reports')) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedReport),
      expression: "selectedReport"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedReport = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("בחר דוח")]), _vm._v(" "), _vm._l((_vm.reports), function(rpt) {
    return _c('option', {
      domProps: {
        "value": rpt
      }
    }, [_vm._v(_vm._s(rpt))])
  })], 2)]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), (_vm.rptProjects) ? _c('ReportProjects') : _vm._e(), _vm._v(" "), (_vm.rptCustomers) ? _c('ReportCustomers') : _vm._e(), _vm._v(" "), (_vm.rptDiaries) ? _c('ReportDiaries') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('div', {
    staticClass: "scrollContent"
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("\n        Key\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("\n        Date\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("\n        Weather\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("\n        Diary\n      ")])], 1), _vm._v(" "), _vm._l((_vm.diaryPages), function(page) {
    return _c('v-layout', {
      staticStyle: {
        "padding": "20px",
        "margin": "20px",
        "background-color": "#eee"
      },
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v("\n        " + _vm._s(page.Date) + "\n      ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v("\n        " + _vm._s(page['.key']) + "\n      ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v("\n        " + _vm._s(page.Weather) + "\n      ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('span', {
      staticClass: "custom-dropdown custom-dropdown--white",
      staticStyle: {
        "float": "right"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (page.selectedDiaryKey),
        expression: "page.selectedDiaryKey"
      }],
      staticClass: "custom-dropdown__select custom-dropdown__select--white",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          page.selectedDiaryKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.pageSelected(page)
        }]
      }
    }, _vm._l((_vm.diaries), function(diary) {
      return _c('option', {
        domProps: {
          "value": diary['.key']
        }
      }, [_vm._v(_vm._s(diary.Title))])
    }))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "button",
        "value": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.deletePage(page)
        }
      }
    })]), _vm._v(" "), _vm._l((_vm.getNotesArr(page)), function(note) {
      return _c('v-layout', {
        staticStyle: {
          "padding": "20px",
          "margin": "20px",
          "width": "100%",
          "background-color": "#aaa"
        },
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }, [_vm._v("\n          " + _vm._s(note.Time) + "\n        ")]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }, [_vm._v("\n          " + _vm._s(note.UserFullName) + "-" + _vm._s(note.UserType) + "\n        ")]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs4": ""
        }
      }, [_vm._v("\n          " + _vm._s(note.Info) + "\n        ")]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs2": ""
        }
      }, [_c('input', {
        attrs: {
          "type": "button",
          "value": "Delete"
        },
        on: {
          "click": function($event) {
            _vm.deleteNote(page, note)
          }
        }
      })])], 1)
    })], 2)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEdit) ? _c('NoteEditor', {
    attrs: {
      "noteData": _vm.noteData,
      "index": _vm.index
    }
  }) : _c('div', {
    class: ['note', _vm.noteData.IsTopNote ? 'topNote' : ''],
    staticStyle: {
      "background-color": "rgba(0,0,0,0.05)",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "padding": "10px"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.noteData.Time) + " " + _vm._s(_vm.noteData.UserFullName))])]), _c('span', [_vm._v(" (" + _vm._s(_vm.noteData.UserType) + ")")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.noteInfo)
    }
  }), _vm._v(" "), (_vm.noteData.Attachments) ? _c('div', {
    staticClass: "filesList"
  }, [_c('div', {
    staticStyle: {
      "color": "brown"
    }
  }, [_vm._v("קבצים מצורפים:")]), _vm._v(" "), _vm._l((_vm.noteData.Attachments), function(file) {
    return _c('div', [(file.Type == 'Record') ? _c('audio', {
      staticClass: "audioChat",
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": file.FileUrl,
        "type": "audio/mp3"
      }
    })]) : _c('a', {
      staticStyle: {
        "color": "blue",
        "text-decoration": "underline",
        "display": "block"
      },
      attrs: {
        "target": "_blank",
        "href": file.FileUrl
      }
    }, [_vm._v(_vm._s(file.FileName))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('div', {
    staticClass: "noteCtrls"
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'עריכה'
      }),
      expression: "{ html: 'עריכה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2",
    on: {
      "click": function($event) {
        _vm.edit(_vm.noteData)
      }
    }
  }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'מחיקה'
      }),
      expression: "{ html: 'מחיקה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.confirm(_vm.noteData['.key'])
      }
    }
  }, [_vm._v("delete")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.statuses), function(row) {
    return _c('tr', {
      class: {
        'trSelect': row.selected
      }
    }, [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.Name))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_c('div', {
      staticClass: "divColor",
      style: ({
        'background-color': row.Color
      })
    })]), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1)])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupStatus')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שלב התקדמות")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("צבע")]), _vm._v(" "), _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  })])])
}]}

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.isRTL ? 'fullContentRTL' : 'fullContent']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("group")]), _vm._v("\n      משתמשים\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isActiveUsers),
      expression: "isActiveUsers"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isActiveUsers) ? _vm._i(_vm.isActiveUsers, null) > -1 : (_vm.isActiveUsers)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isActiveUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isActiveUsers = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isActiveUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isActiveUsers = $$c
        }
      }
    }
  }), _vm._v(" הצג פעיל בלבד\n    ")], 1), _vm._v(" "), _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם מלא")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("שם משתמש")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תעודת זהות")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("פעיל")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("מאושר")]), _vm._v(" "), _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  })])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.FullName))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Username))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Identity))]), _vm._v(" "), _c('td', {
      staticClass: "tdData"
    }, [(row.Active) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1), _vm._v(" "), _c('td', {
      staticClass: "tdData"
    }, [(row.Approved) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1)])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupUser')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("assignment")]), _vm._v("יומנים\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  }) : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.$root.isCustomer || _vm.$root.isAdmin) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.$root.isCustomer) ? _c('span', {
    staticStyle: {
      "padding-right": "10px",
      "padding-left": "10px"
    }
  }, [_vm._v("סה\"כ יומנים בחשבון")]) : _vm._e(), (_vm.$root.isCustomer) ? _c('b', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$root.user.TotalDiaries))]) : _vm._e(), _vm._v(" "), (_vm.$root.isCustomer) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (_vm.$root.isCustomer) ? _c('span', {
    staticStyle: {
      "padding-right": "10px",
      "padding-left": "10px"
    }
  }, [_vm._v("סה\"כ יומנים בשימוש")]) : _vm._e(), (_vm.$root.isCustomer) ? _c('b', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.usedDiaries))]) : _vm._e()], 1), _vm._v(" "), (_vm.$root.isAdmin) ? _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("כותרת")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("לקוח")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("פרויקט")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תאריך יצירה")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תאריך עדכון")]), _vm._v(" "), _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin && _vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.Title))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.CustomerName))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.ProjectName))]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.CreateDate))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.UpdateDate))]), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'פתח יומן'
        }),
        expression: "{ html: 'פתח יומן' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.open(row)
        }
      }
    }, [_vm._v("reply_all")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1)])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.$root.isAdmin && _vm.hasData) ? _c('div', {
    class: [_vm.$root.device.isMobile ? 'scrollContentMobile' : 'scrollContent']
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('v-card', {
      class: ['cardDiary', _vm.$root.device.isMobile ? 'cardDiaryMobile' : '']
    }, [_c('v-container', {
      style: ({
        'background-color': row.Color
      }),
      attrs: {
        "grid-list-lg": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('img', {
      attrs: {
        "src": row.Image
      }
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('div', {
      staticStyle: {
        "padding-right": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.shortString(row.Title, 15)))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.shortString(row.ProjectName, 15)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.Status['Name']))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.CreateDate))])])])], 1), _vm._v(" "), _c('v-layout', {
      staticStyle: {
        "padding-left": "20px"
      },
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.shortString(row.Info, 30)))])])], 1), _vm._v(" "), _c('v-layout', {
      staticStyle: {
        "padding-left": "20px"
      },
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "btnPlans",
      staticStyle: {
        "margin": "0px"
      },
      on: {
        "click": function($event) {
          _vm.open(row)
        }
      }
    }, [_c('v-layout', [_c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('i', {
      staticClass: "material-icons icon"
    }, [_vm._v("reply_all")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("פתח יומן")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    })], 1)], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }), _vm._v(" "), (_vm.$root.isCustomer) ? _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isCustomer) ? _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (!_vm.hasData && !_vm.isLoading) ? _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticStyle: {
      "padding-top": "50px",
      "color": "#aaa"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('PopupDiary')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: [_vm.$root.isRTL ? 'RLT' : ''],
    attrs: {
      "standalone": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('div', {
    class: ['mobileMenu', _vm.$root.activeMobileMenu ? 'activeMenu' : '']
  }, [_c('SubMenu')], 1)]), _vm._v(" "), _c('v-navigation-drawer', {
    class: [_vm.$root.device.isTablet ? 'tabletMenu' : '', _vm.$root.isRTL ? 'navigation-drawer--right' : '', 'elevation-10'],
    staticStyle: {
      "padding": "0px",
      "margin": "0px",
      "z-index": "200"
    },
    attrs: {
      "light": ""
    },
    model: {
      value: (_vm.$root.activeSubMenu),
      callback: function($$v) {
        _vm.$root.activeSubMenu = $$v
      },
      expression: "$root.activeSubMenu"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "background-color": "#3A2D01",
      "height": "200px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "color": "#fff",
      "padding": "20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": ""
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": ""
    }
  }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_vm._v("שם פרויקט:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('b', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.projectName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_vm._v("סטטוס פרויקט:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('b', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.getStatus()))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md10": "",
      "sm10": ""
    }
  }, [_c('a', {
    staticClass: "btnPlans",
    attrs: {
      "target": "_blank",
      "href": _vm.planLink
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("picture_as_pdf")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("תוכנית בנייה")])])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    class: ['submenu', _vm.$root.device.isTablet ? 'tabletMenu' : ''],
    staticStyle: {
      "overflow": "hidden",
      "margin-bottom": "50px"
    },
    attrs: {
      "right": ""
    },
    model: {
      value: (_vm.$root.activeSubMenu),
      callback: function($$v) {
        _vm.$root.activeSubMenu = $$v
      },
      expression: "$root.activeSubMenu"
    }
  }, [(_vm.$root.device.isTablet) ? _c('v-list', [_c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.$root.goto('Diaries');
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "text-align": "right!important",
      "margin": "10px"
    }
  }, [_vm._v("חזרה")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'הורדה'
      }),
      expression: "{ html: 'הורדה' }",
      arg: "bottom"
    }],
    staticClass: "material-icons",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.$root.goto('Diaries')
      }
    }
  }, [_vm._v("close")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "listScroll"
  }, _vm._l((_vm.pages), function(page) {
    return _c('v-list-tile', {
      class: ['subMenuItem', _vm.$root.activeDiaryPage.Date == page.Date ? 'active' : ''],
      nativeOn: {
        "click": function($event) {
          _vm.dayClick(page)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticStyle: {
        "text-align": "right!important",
        "margin": "10px"
      }
    }, [_vm._v(_vm._s(page.Date))])], 1), _vm._v(" "), _c('v-list-tile-action', [(page && page.PageKey) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'שליחה'
        }),
        expression: "{ html: 'שליחה' }",
        arg: "bottom"
      }],
      staticClass: "material-icons",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.sendMail(page, $event)
        }
      }
    }, [_vm._v("mail")]) : _vm._e(), _vm._v(" "), (page && page.PageKey) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'הורדה'
        }),
        expression: "{ html: 'הורדה' }",
        arg: "bottom"
      }],
      staticClass: "material-icons",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.downloadPage(page, $event)
        }
      }
    }, [_vm._v("file_download")]) : _vm._e()])], 1)
  }))], 1)], 1)]), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "z-index": "100"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [(_vm.$root.device.isMobile) ? _c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right",
      "width": "200px"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("assignment")]), _vm._v(_vm._s(_vm.title) + "\n        ")]) : _c('div', {
    staticClass: "divDiary"
  }, [_c('img', {
    staticClass: "logoDiary",
    attrs: {
      "src": __webpack_require__(59)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "diaryTitle"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-layout', {
    staticStyle: {
      "width": "120px",
      "cursor": "pointer",
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.advanceSearch = true
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("search")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "100px"
    }
  }, [_vm._v("חיפוש מתקדם")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  }) : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), (_vm.$root.device.isMobile) ? _c('div', [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', [_c('div', [_vm._v("שם פרויקט: "), _c('b', [_vm._v(_vm._s(_vm.projectName))])]), _vm._v(" "), _c('div', [_vm._v("סטטוס פרויקט: "), _c('b', [_vm._v(_vm._s(_vm.getStatus()))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "150px"
    }
  }, [(_vm.planLink) ? _c('a', {
    staticClass: "btnPlans",
    attrs: {
      "target": "_blank",
      "href": _vm.planLink
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("picture_as_pdf")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("תוכניות בנייה")])])], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('th', [_c('v-layout', {
    on: {
      "click": function($event) {
        _vm.advanceSearch = true
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("search")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("חיפוש")])])], 1)], 1)])]), _vm._v(" "), (_vm.project) ? _c('DiaryPageMobile', {
    key: _vm.$root.activeDiaryPage.PageKey,
    attrs: {
      "pages": _vm.pages,
      "page": _vm.$root.activeDiaryPage,
      "location": _vm.project.Location,
      "pageKey": _vm.$root.activeDiaryPage.PageKey
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "divScroll"
  }, [(_vm.project) ? _c('DiaryPage', {
    key: _vm.$root.activeDiaryPage.PageKey,
    attrs: {
      "txtSearch": _vm.txtSearch,
      "page": _vm.$root.activeDiaryPage,
      "location": _vm.project.Location,
      "pageKey": _vm.$root.activeDiaryPage.PageKey
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.$root.alert.timeout,
      "top": _vm.$root.alert.isTop
    },
    model: {
      value: (_vm.$root.alert.isShow),
      callback: function($$v) {
        _vm.$root.alert.isShow = $$v
      },
      expression: "$root.alert.isShow"
    }
  }, [_vm._v(_vm._s(_vm.$root.alert.message))]), _vm._v(" "), _c('PopupConfim'), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "imgYoman",
      "src": __webpack_require__(59)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.advanceSearch),
      expression: "advanceSearch"
    }],
    staticClass: "advanceSearch elevation-10"
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "10px",
      "background-color": "#3A2D01",
      "color": "#fff"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    on: {
      "click": function($event) {
        _vm.advanceSearch = false
      }
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("חיפוש מתקדם")])])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtAdvanceSearch),
      callback: function($$v) {
        _vm.txtAdvanceSearch = $$v
      },
      expression: "txtAdvanceSearch"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  })], 1), _vm._v(" "), (_vm.hasData) ? _c('v-layout', {
    staticStyle: {
      "padding": "10px",
      "height": "calc(100% - 200px)",
      "overflow-y": "scroll"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.advanceSearchNotes), function(note, index) {
    return _c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectNote(note)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(note.Date))]), _vm._v(" "), _c('Note', {
      attrs: {
        "noteData": note,
        "index": index
      }
    })], 1)
  }))], 1) : _c('v-layout', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#aaa"
    }
  }, [_vm._v("אין נתונים")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticStyle: {
      "direction": "rtl"
    },
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: (_vm.$parent.isPasswordReset),
      callback: function($$v) {
        _vm.$parent.isPasswordReset = $$v
      },
      expression: "$parent.isPasswordReset"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("איפוס סיסמה")])], 1), _vm._v(" "), _c('v-flex', [_c('v-card-text', [_vm._v("שכחת סיסמה? הכנס כתובת המייל שלך ונשלח לך את הסיסמה למייל.")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        כתובת מייל\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-flex', [(_vm.error) ? _c('span', {
    staticStyle: {
      "color": "#c00000"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "actions": "",
      "wrap": ""
    }
  }, [_c('input', {
    staticClass: "btnPopupYes",
    attrs: {
      "type": "button",
      "value": "שלח סיסמה"
    },
    on: {
      "click": _vm.sendPassword
    }
  }), _vm._v("\n          \n      "), _c('input', {
    staticClass: "btnPopupNo",
    attrs: {
      "type": "button",
      "value": "ביטול"
    },
    on: {
      "click": _vm.cancel
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.$root.confirmAddFile.isVisible),
      callback: function($$v) {
        _vm.$root.confirmAddFile.isVisible = $$v
      },
      expression: "$root.confirmAddFile.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('v-flex', [_c('v-card-text', [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addType),
      expression: "addType"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "File"
    }
  }, [_vm._v("הוסף מסמך חדש")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Folder"
    }
  }, [_vm._v("הוסף תיקייה חדשה")])])])])], 1), _vm._v(" "), (_vm.addType == 'File') ? _c('v-flex', [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n          שם קובץ\n        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "right": ""
    }
  }, [_c('label', {
    staticClass: "file-select"
  }, [_vm._v("\n            בחר קובץ\n            "), _c('v-icon', {
    staticClass: "btnIcon mr-2",
    attrs: {
      "right": ""
    }
  }, [_vm._v("attachment")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.upload
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "right": ""
    }
  }, [(_vm.showProgress) ? _c('span', [_vm._v("מעלה קובץ...")]) : _vm._e(), _vm._v(" "), (_vm.showReady) ? _c('span', [_vm._v(_vm._s(_vm.readyFileName)), _c('v-icon', [_vm._v("check")])], 1) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addType == 'Folder') ? _c('v-flex', [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n          שם תיקייה\n        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.folderName),
      expression: "folderName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.folderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.folderName = $event.target.value
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("remove_red_eye")]), _vm._v("משקיפים\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  }) : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.$root.isAdmin) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isActiveUsers),
      expression: "isActiveUsers"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isActiveUsers) ? _vm._i(_vm.isActiveUsers, null) > -1 : (_vm.isActiveUsers)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isActiveUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isActiveUsers = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isActiveUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isActiveUsers = $$c
        }
      }
    }
  }), _vm._v(" הצג פעיל בלבד\n    ")], 1), _vm._v(" "), _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם משקיף")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("שם משתמש")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תעודת זהות")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("פעיל")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("מאושר")]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.FullName))]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Username))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Identity))]), _vm._v(" "), _c('td', {
      staticClass: "tdData"
    }, [(row.Active) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData"
    }, [(row.Approved) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1) : _vm._e()])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupUser')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', [_c('span', [_c('b', [_vm._v(_vm._s(_vm.currentNote.Time) + " " + _vm._s(_vm.currentNote.UserFullName))])]), _c('span', [_vm._v(" (" + _vm._s(_vm.currentNote.UserType) + ")")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentNote.Info),
      expression: "currentNote.Info"
    }],
    ref: "elText",
    class: ['txtNote', _vm.isTopNote ? 'topNote' : ''],
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.currentNote.Info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentNote.Info = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.currentNote.Attachments) ? _c('div', {
    staticClass: "filesList"
  }, _vm._l((_vm.currentNote.Attachments), function(file) {
    return _c('div', [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחק קובץ'
        }),
        expression: "{ html: 'מחק קובץ' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.removeFile(file)
        }
      }
    }, [_vm._v("delete")]), _vm._v(" "), _c('a', {
      attrs: {
        "target": "_blank",
        "href": file.FileUrl
      }
    }, [_vm._v(_vm._s(file.FileName))])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.showProgress) ? _c('div', [_vm._v("מעלה קובץ ...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "noteCtrls"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('Recorder', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "record:start": function($event) {}
    }
  }), _vm._v(" "), (_vm.$root.isContractor || _vm.$root.isInspector) ? _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("\n         \n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isTopNote),
      expression: "isTopNote"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isTopNote) ? _vm._i(_vm.isTopNote, null) > -1 : (_vm.isTopNote)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isTopNote,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isTopNote = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isTopNote = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isTopNote = $$c
        }
      }
    }
  }), _vm._v(" פיקוח עליון\n      ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "file-select"
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'העלאת קובץ'
      }),
      expression: "{ html: 'העלאת קובץ' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2",
    attrs: {
      "right": ""
    }
  }, [_vm._v("attachment")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.upload
    }
  })], 1), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'שמירה'
      }),
      expression: "{ html: 'שמירה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'ביטול'
      }),
      expression: "{ html: 'ביטול' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": ""
    }
  }, [(_vm.$root.activeMobileMenu) ? _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    staticStyle: {
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.closeMobileMenu()
      }
    }
  }, [_vm._v("arrow_back")]) : _vm._e(), _vm._v(" "), _c('img', {
    class: [_vm.$root.isRTL ? 'logoSmallRTL' : 'logoSmall'],
    attrs: {
      "src": __webpack_require__(59)
    },
    on: {
      "click": function($event) {
        _vm.menuClick('Home')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon w3-text-white",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("person")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "font-size": "16px",
      "padding": "5px 20px"
    },
    attrs: {
      "md11": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$root.user.FullName) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.isRTL ? 'fullContentRTL' : 'fullContent']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("settings")]), _vm._v("\n      " + _vm._s(_vm.$t('settings')) + "\n    ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "5px"
    },
    attrs: {
      "input": "tabChanged",
      "dark": "",
      "scrollable": false
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('v-tabs-bar', {
    staticStyle: {
      "background-color": "#fff",
      "border-bottom": "2px solid #F7941D"
    },
    slot: "activators"
  }, [_c('v-tabs-item', {
    attrs: {
      "href": "#tab-0"
    }
  }, [_vm._v("חבילות")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("שלבי התקדמות")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("הגדרות מערכת")])], 1), _vm._v(" "), _c('v-tabs-content', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "id": "tab-0"
    }
  }, [_c('TablePackages')], 1), _vm._v(" "), _c('v-tabs-content', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "id": "tab-1"
    }
  }, [_c('TableStatuses')], 1), _vm._v(" "), _c('v-tabs-content', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "id": "tab-2"
    }
  }, [_c('TableSettings')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['VueLabel', _vm.isFile ? 'file' : '']
  }, [_c('label', {
    attrs: {
      "for": 'folder' + _vm.Key,
      "title": _vm.Name
    },
    on: {
      "click": function($event) {
        _vm.selectFile(_vm.Url)
      }
    }
  }, [_vm._v(_vm._s(_vm.Title))]), _vm._v(" "), (_vm.canEdit) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'מחיקה'
      }),
      expression: "{ html: 'מחיקה' }",
      arg: "bottom"
    }],
    staticClass: "material-icons treeBtn",
    staticStyle: {
      "padding-left": "10px"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.confirm($event)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), (_vm.canEdit && _vm.isFolder) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'הוספה'
      }),
      expression: "{ html: 'הוספה' }",
      arg: "bottom"
    }],
    staticClass: "material-icons treeBtn",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showAddFile($event)
      }
    }
  }, [_vm._v("add")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.isRTL ? 'fullContentRTL' : 'fullContent']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("local_atm")]), _vm._v("יזמים\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.$root.isAdmin) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isActiveUsers),
      expression: "isActiveUsers"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isActiveUsers) ? _vm._i(_vm.isActiveUsers, null) > -1 : (_vm.isActiveUsers)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isActiveUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isActiveUsers = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isActiveUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isActiveUsers = $$c
        }
      }
    }
  }), _vm._v(" הצג פעיל בלבד\n    ")], 1), _vm._v(" "), _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם יזם")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("ת.ז. / ח.פ.")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("פעיל")]), _vm._v(" "), (_vm.$root.isAdmin) ? _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.FullName))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Identity))]), _vm._v(" "), _c('td', {
      staticClass: "tdData"
    }, [(row.Active) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1), _vm._v(" "), (_vm.$root.isAdmin) ? _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1) : _vm._e()])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupUser')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              שם תוכנית\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Name),
      expression: "$parent.popup.data.Name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              תיאור תוכנית בנייה\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Info),
      expression: "$parent.popup.data.Info"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Info = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              פרויקט\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.ProjectKey),
      expression: "$parent.popup.data.ProjectKey"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$parent.popup.data.ProjectKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setProjectName]
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project['.key']
      }
    }, [_vm._v(_vm._s(project.Name))])
  }))])])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px 50px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._v("\n          אחרי שמירת שם ותיאור תוכנית בניית ניתן לצרף מסמכים לתוכנית\n        ")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.canEdit) ? _c('v-flex', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n            שמירה\n            "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n            ביטול\n            "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1) : _c('v-flex', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n            סגור חלון\n            "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.$root.confirmAddDiaries.isVisible),
      callback: function($$v) {
        _vm.$root.confirmAddDiaries.isVisible = $$v
      },
      expression: "$root.confirmAddDiaries.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("הוספת יומנים ללקוח")])], 1), _vm._v(" "), _c('v-flex', [_c('v-card-text', [_vm._v("הכנס את מספר היומנים שברצונך להוסיף ללוקח")])], 1), _vm._v(" "), _c('v-flex', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.confirmAddDiaries.totalDiaries),
      expression: "$root.confirmAddDiaries.totalDiaries"
    }],
    staticStyle: {
      "width": "100px",
      "text-align": "center"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$root.confirmAddDiaries.totalDiaries)
    },
    on: {
      "change": _vm.checkValue,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$root.confirmAddDiaries.totalDiaries = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmed(true)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmed(false)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#fff",
      "height": "35px",
      "position": "fixed",
      "left": "0px",
      "top": "80px",
      "border-bottom": "1px dotted #ccc"
    }
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.page.Date))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "padding-left": "150px",
      "padding-top": "5px",
      "font-size": "16px"
    }
  }, [_c('span', [_vm._v("מזג אויר: ")]), _vm._v(" "), (_vm.diaryPage) ? _c('span', [(_vm.canAdd()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diaryPage.Weather),
      expression: "diaryPage.Weather"
    }],
    staticStyle: {
      "text-align": "center",
      "width": "250px!important"
    },
    attrs: {
      "type": "text",
      "placeholder": "הכנס מזג אויר"
    },
    domProps: {
      "value": (_vm.diaryPage.Weather)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.diaryPage.Weather = $event.target.value
      }
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.diaryPage.Weather)
    }
  })]) : _c('span', [(_vm.canAdd()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page.Weather),
      expression: "page.Weather"
    }],
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "הכנס מזג אויר"
    },
    domProps: {
      "value": (_vm.page.Weather)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page.Weather = $event.target.value
      }
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.Weather)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "34px",
      "font-size": "20px",
      "text-align": "center"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "border": "1px #aaa solid",
      "border-radius": "10px",
      "width": "100%"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-decoration": "underline",
      "text-align": "right",
      "float": "right",
      "padding-top": "10px"
    }
  }, [_vm._v("הערות כלליות")]), _vm._v(" "), (_vm.canAdd()) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף תיאור'
      }),
      expression: "{ html: 'הוסף תיאור' }",
      arg: "left"
    }],
    staticClass: "btnAdd ",
    staticStyle: {
      "text-decoration": "none",
      "font-size": "25px",
      "width": "25px!important",
      "height": "25px!important",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.addGeneralNote()
      }
    }
  }, [_vm._v("add")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$root.isNewGeneralNote) ? _c('NoteEditor', {
    attrs: {
      "index": "new",
      "date": _vm.currentDate,
      "time": _vm.currentTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notesGeneral && _vm.notesGeneral.length > 0) ? _c('div', _vm._l((_vm.notesGeneral), function(note, index) {
    return _c('Note', {
      attrs: {
        "noteData": note,
        "index": index,
        "canEdit": _vm.canEdit(note)
      }
    })
  })) : _c('div', [_c('h5', {
    staticStyle: {
      "padding-top": "20px",
      "color": "#aaa"
    }
  }, [_vm._v("אין נתונים")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "34px",
      "font-size": "20px",
      "text-align": "center"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "border": "1px #aaa solid",
      "border-radius": "10px",
      "width": "100%"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-decoration": "underline",
      "text-align": "right",
      "float": "right",
      "padding-top": "10px"
    }
  }, [_vm._v("תיאור העבודה")]), _vm._v(" "), (_vm.canAdd()) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף תיאור'
      }),
      expression: "{ html: 'הוסף תיאור' }",
      arg: "left"
    }],
    staticClass: "btnAdd ",
    staticStyle: {
      "text-decoration": "none",
      "font-size": "25px",
      "width": "25px!important",
      "height": "25px!important",
      "float": "right"
    },
    on: {
      "click": _vm.addInfoNote
    }
  }, [_vm._v("add")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$root.isNewInfoNote) ? _c('NoteEditor', {
    attrs: {
      "index": "new",
      "date": _vm.currentDate,
      "time": _vm.currentTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notesInfo && _vm.notesInfo.length > 0) ? _c('div', _vm._l((_vm.notesInfo), function(note, index) {
    return _c('Note', {
      attrs: {
        "noteData": note,
        "index": index,
        "canEdit": _vm.canEdit(note)
      }
    })
  })) : _c('div', [_c('h5', {
    staticStyle: {
      "padding-top": "20px",
      "color": "#aaa"
    }
  }, [_vm._v("אין נתונים")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "border": "1px #aaa solid",
      "border-radius": "10px",
      "width": "48%",
      "margin": "1%"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%!important",
      "display": "block",
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "15px",
      "float": "right",
      "font-size": "20px",
      "text-align": "right",
      "text-decoration": "underline"
    }
  }, [_vm._v("הערות מנהל עבודה:")]), _vm._v(" "), (_vm.$root.isContractor && _vm.canAdd()) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף הערה'
      }),
      expression: "{ html: 'הוסף הערה' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    staticStyle: {
      "text-decoration": "none",
      "font-size": "25px",
      "width": "25px!important",
      "height": "25px!important",
      "float": "right"
    },
    on: {
      "click": _vm.addNote
    }
  }, [_vm._v("add")]) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.$root.isNewNote && _vm.$root.isContractor) ? _c('NoteEditor', {
    attrs: {
      "index": "new",
      "date": _vm.currentDate,
      "time": _vm.currentTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notesContractor && _vm.notesContractor.length > 0) ? _c('div', _vm._l((_vm.notesContractor), function(note, index) {
    return _c('Note', {
      attrs: {
        "noteData": note,
        "index": index,
        "canEdit": _vm.canEdit(note)
      }
    })
  })) : _c('div', [_c('h5', {
    staticStyle: {
      "padding-top": "20px",
      "color": "#aaa"
    }
  }, [_vm._v("אין נתונים")])])], 1)]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px #aaa solid",
      "border-radius": "10px",
      "width": "48%",
      "margin": "1%"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%!important",
      "display": "block",
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "15px",
      "float": "right",
      "font-size": "20px",
      "text-align": "right",
      "text-decoration": "underline"
    }
  }, [_vm._v("הערות מפקח:")]), _vm._v(" "), (_vm.$root.isInspector && _vm.canAdd()) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף הערה'
      }),
      expression: "{ html: 'הוסף הערה' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    staticStyle: {
      "text-decoration": "none",
      "font-size": "25px",
      "width": "25px!important",
      "height": "25px!important",
      "float": "right"
    },
    on: {
      "click": _vm.addNote
    }
  }, [_vm._v("add")]) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.$root.isNewNote && _vm.$root.isInspector) ? _c('NoteEditor', {
    attrs: {
      "index": "new",
      "date": _vm.currentDate,
      "time": _vm.currentTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notesInspector && _vm.notesInspector.length > 0) ? _c('div', _vm._l((_vm.notesInspector), function(note, index) {
    return _c('Note', {
      attrs: {
        "noteData": note,
        "index": index,
        "canEdit": _vm.canEdit(note)
      }
    })
  })) : _c('div', [_c('h5', {
    staticStyle: {
      "padding-top": "20px",
      "color": "#aaa"
    }
  }, [_vm._v("אין נתונים")])])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "padding-left": "10px"
    }
  }, [_vm._v("סינון שלב התקדמות")]), _vm._v(" "), _c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStatus),
      expression: "selectedStatus"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("הצג הכל")]), _vm._v(" "), _vm._l((_vm.statuses), function(status) {
    return _c('option', {
      domProps: {
        "value": status['.key']
      }
    }, [_vm._v(_vm._s(status.Name))])
  })], 2)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "padding-left": "10px"
    }
  }, [_vm._v("עדכון אחרון לפני")]), _vm._v(" "), _c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLastUpdate),
      expression: "selectedLastUpdate"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLastUpdate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("הצג הכל")]), _vm._v(" "), _vm._l((_vm.updatesList), function(update) {
    return _c('option', {
      domProps: {
        "value": update.Value
      }
    }, [_vm._v(_vm._s(update.Text))])
  })], 2)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n       \n    ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'הדפסה'
      }),
      expression: "{ html: 'הדפסה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 ml-2 left"
  }, [_vm._v("print")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'ייצוא אקסל'
      }),
      expression: "{ html: 'ייצוא אקסל' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 ml-2 left"
  }, [_vm._v("file_download")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', {
      class: {
        'trSelect': row.selected
      }
    }, [_c('td', {
      staticClass: "tdData tdTxt  sp"
    }, [_vm._v(_vm._s(row.Name))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Address))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.City))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_c('div', {
      staticClass: "divColorIcon",
      style: ({
        'background-color': _vm.getStatusColor(row.StatusKey)
      })
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "30px"
      }
    }, [_vm._v(_vm._s(_vm.getStatusName(row.StatusKey)))])]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.CreateDate))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.UpdateDate))])])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px",
      "text-align": "center"
    }
  }, [_vm._v("אין נתונים")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם פרויקט")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("כתובת")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("ישוב")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("שלב התקדמות")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תאריך יצירה")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תאריך עדכון")])])])
}]}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("picture_as_pdf")]), _vm._v("תוכניות בנייה\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  }) : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם תוכנית")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תיאור")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("פרויקט")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תאריך יצירה")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תאריך עדכון")]), _vm._v(" "), _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  })])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.Name))]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Info))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.ProjectName))]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.CreateDate))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.UpdateDate))]), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'פתח תוכנית'
        }),
        expression: "{ html: 'פתח תוכנית' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.open(row)
        }
      }
    }, [_vm._v("reply_all")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1)])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupPlan')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticStyle: {
      "direction": "rtl"
    },
    attrs: {
      "persistent": "",
      "width": "500"
    },
    model: {
      value: (_vm.$parent.isRegister),
      callback: function($$v) {
        _vm.$parent.isRegister = $$v
      },
      expression: "$parent.isRegister"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("הרשמה למערכת")])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        סוג חשבון\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Type),
      expression: "Type"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("בחר סוג חשבון")]), _vm._v(" "), _vm._l((_vm.userTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(type))])
  })], 2)])])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        שם מלא\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FullName),
      expression: "FullName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.FullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.FullName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        תעודת זהות\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Identity),
      expression: "Identity"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Identity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Identity = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCustomer),
      expression: "isCustomer"
    }],
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        איש קשר\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ContactPerson),
      expression: "ContactPerson"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ContactPerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ContactPerson = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCustomer),
      expression: "isCustomer"
    }],
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        טלפון\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Phone),
      expression: "Phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Phone = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        שם משתמש (אימייל)\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Username),
      expression: "Username"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Username = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        סיסמה"), _c('br'), _vm._v(" (לפחות 6 אותיות/מספרים)\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Password),
      expression: "Password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Password = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        אימות סיסמה\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PasswordConfirm),
      expression: "PasswordConfirm"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.PasswordConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PasswordConfirm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('input', {
    staticClass: "btnPopupYes",
    attrs: {
      "type": "button",
      "value": "שמירה"
    },
    on: {
      "click": _vm.signup
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('input', {
    staticClass: "btnPopupNo",
    attrs: {
      "type": "button",
      "value": "ביטול"
    },
    on: {
      "click": _vm.cancel
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "divPDF"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.pdfContent) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("settings")]), _vm._v("הגדרות חשבון\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$root.device.isMobile) ? _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "500px",
      "width": "100%",
      "overflow-y": "scroll"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        סוג חשבון\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user.Type))])])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        שם מלא\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.FullName),
      expression: "user.FullName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.FullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.FullName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        תעודת זהות\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Identity),
      expression: "user.Identity"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Identity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Identity = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$root.isCustomer),
      expression: "$root.isCustomer"
    }],
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        איש קשר\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ContactPerson),
      expression: "user.ContactPerson"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.ContactPerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.ContactPerson = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        טלפון\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Phone),
      expression: "user.Phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Phone = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        שם משתמש\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Username),
      expression: "user.Username"
    }],
    staticStyle: {
      "background-color": "#eee",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.user.Username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Username = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        סיסמה\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Password),
      expression: "user.Password"
    }],
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Password = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n        אימות סיסמה\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding-top": "20px",
      "margin-right": "50px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "xs12": "",
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder"
  }, [_c('VueLabel', {
    attrs: {
      "isFolder": "true",
      "isRoot": _vm.isRoot,
      "Key": _vm.Key,
      "Name": _vm.folderData[_vm.Key].Title,
      "path": _vm.path,
      "canEdit": _vm.canEdit
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isChecked),
      expression: "isChecked"
    }],
    staticClass: "folderCheck",
    attrs: {
      "type": "checkbox",
      "id": 'folder' + _vm.Key
    },
    domProps: {
      "checked": Array.isArray(_vm.isChecked) ? _vm._i(_vm.isChecked, null) > -1 : (_vm.isChecked)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isChecked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isChecked = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._l((_vm.subFolders), function(folder, index) {
    return _c('Folder', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isChecked),
        expression: "isChecked"
      }],
      attrs: {
        "Key": Object.keys(folder)[0],
        "path": folder.Path,
        "folderData": folder,
        "canEdit": _vm.canEdit
      }
    })
  }), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('VueLabel', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isChecked),
        expression: "isChecked"
      }],
      staticClass: "file",
      attrs: {
        "isFile": "true",
        "Key": file.Key,
        "path": file.Path,
        "Name": file.Title,
        "Url": file.Url,
        "canEdit": _vm.canEdit
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "30px",
      "height": "30px"
    }
  }, [(!_vm.isRecording) ? _c('i', {
    staticClass: "material-icons btnRecord",
    on: {
      "click": _vm.startRecording
    }
  }, [_vm._v("mic")]) : _c('i', {
    staticClass: "material-icons btnRedRecord",
    on: {
      "click": _vm.stopRecording
    }
  }, [_vm._v("fiber_manual_record")])])
},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "mapMain",
    staticStyle: {
      "width": "100%",
      "height": "90vh"
    },
    attrs: {
      "id": "mapMain",
      "center": _vm.center,
      "zoom": _vm.zoom
    },
    on: {
      "click": function($event) {
        _vm.getMapPoint($event)
      },
      "center_changed": function($event) {
        _vm.updateCenter($event)
      },
      "dragend": function($event) {
        _vm.dragend($event)
      }
    }
  }, [_vm._l((_vm.$parent.filteredRows), function(project) {
    return _c('gmap-info-window', {
      ref: "infoImgProject",
      refInFor: true,
      attrs: {
        "position": project.Location,
        "options": _vm.infoMarkerOptions,
        "zIndex": project.zIndex,
        "opened": _vm.isOpen,
        "id": 'gmapProject' + project.userId
      },
      on: {
        "domready": _vm.projectReady
      }
    }, [_c('div', {
      staticClass: "divProjectArrow",
      style: ({
        'background-color': _vm.$parent.getStatusColor(project.StatusKey)
      }),
      attrs: {
        "id": 'arrow' + project.userId
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "divMarker",
      on: {
        "mouseover": function($event) {
          _vm.selectProject(project)
        },
        "mouseout": function($event) {
          _vm.resetProject(project)
        },
        "click": function($event) {
          _vm.$parent.edit(project)
        }
      }
    }, [_c('span', {
      staticClass: "divPercent",
      style: ({
        'z-index': project.zIndex + 5
      })
    }, [_vm._v(_vm._s(project.Percent) + "%")]), _vm._v(" "), _c('img', {
      staticClass: "imgProject",
      style: ({
        'border-color': _vm.$parent.getStatusColor(project.StatusKey),
        'z-index': project.zIndex
      }),
      attrs: {
        "id": 'project' + project['.key'],
        "src": __webpack_require__(805)
      }
    })])])
  }), _vm._v(" "), _c('gmap-info-window', {
    ref: "infoProject",
    attrs: {
      "position": _vm.selectedProject.Location,
      "options": _vm.infoOptions,
      "zIndex": _vm.selectedProject.zIndex,
      "opened": _vm.isOpenInfo
    }
  }, [_c('div', {
    staticClass: "infoWindow",
    attrs: {
      "id": "projectInfo"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#CC2636",
      "font-size": "14px"
    }
  }, [_c('img', {
    staticClass: "divIcon",
    attrs: {
      "src": __webpack_require__(806)
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.selectedProject.Name))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mapDivColor",
    style: ({
      'background-color': _vm.$parent.getStatusColor(_vm.selectedProject.StatusKey)
    })
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$parent.getStatusName(_vm.selectedProject.StatusKey)))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.selectedProject.City) + ", " + _vm._s(_vm.selectedProject.Address))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.selectedProject.Info))]), _vm._v(" "), (_vm.selectedProject.Images) ? _c('img', {
    staticClass: "imgProjectMap",
    attrs: {
      "src": _vm.selectedProject.Images[0]
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.$parent.popup.isVisible) ? _c('gmap-marker', {
    attrs: {
      "zIndex": 5200,
      "position": _vm.marker,
      "draggable": false
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "600"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs10": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$parent.popup.data.CreateDate))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              כותרת יומן\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Title),
      expression: "$parent.popup.data.Title"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Title = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              תיאור\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Info),
      expression: "$parent.popup.data.Info"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Info = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              פרויקט\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.ProjectKey),
      expression: "$parent.popup.data.ProjectKey"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$parent.popup.data.ProjectKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setProjectName]
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project['.key']
      }
    }, [_vm._v(_vm._s(project.Name))])
  }))])])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "right": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.SendToCustomer),
      expression: "$parent.popup.data.SendToCustomer"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.popup.data.SendToCustomer) ? _vm._i(_vm.$parent.popup.data.SendToCustomer, null) > -1 : (_vm.$parent.popup.data.SendToCustomer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.$parent.popup.data.SendToCustomer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.$parent.popup.data.SendToCustomer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.$parent.popup.data.SendToCustomer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$parent.popup.data.SendToCustomer = $$c
        }
      }
    }
  }), _vm._v(" שלח העתק יומי לרוכש\n            ")])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "right": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.SendToInspectors),
      expression: "$parent.popup.data.SendToInspectors"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.popup.data.SendToInspectors) ? _vm._i(_vm.$parent.popup.data.SendToInspectors, null) > -1 : (_vm.$parent.popup.data.SendToInspectors)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.$parent.popup.data.SendToInspectors,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.$parent.popup.data.SendToInspectors = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.$parent.popup.data.SendToInspectors = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$parent.popup.data.SendToInspectors = $$c
        }
      }
    }
  }), _vm._v(" שלח העתק יומי למפקח/ים\n            ")])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "right": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.SendToContractors),
      expression: "$parent.popup.data.SendToContractors"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.popup.data.SendToContractors) ? _vm._i(_vm.$parent.popup.data.SendToContractors, null) > -1 : (_vm.$parent.popup.data.SendToContractors)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.$parent.popup.data.SendToContractors,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.$parent.popup.data.SendToContractors = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.$parent.popup.data.SendToContractors = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$parent.popup.data.SendToContractors = $$c
        }
      }
    }
  }), _vm._v(" שלח העתק יומי למנהל עבודה\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(!_vm.$root.isCustomer) ? _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              לקוח\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.CustomerKey),
      expression: "$parent.popup.data.CustomerKey"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$parent.popup.data.CustomerKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setCustomerName]
    }
  }, _vm._l((_vm.customers), function(customer) {
    return _c('option', {
      domProps: {
        "value": customer['.key']
      }
    }, [_vm._v(_vm._s(customer.FullName))])
  }))])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              מפקח\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtSearchInspector),
      expression: "txtSearchInspector"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "חפש לפי תעודת זהות"
    },
    domProps: {
      "value": (_vm.txtSearchInspector)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtSearchInspector = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filteredInspectors.length) ? _c('div', {
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px",
      "margin-right": "10px",
      "max-height": "150px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.filteredInspectors), function(item) {
    return _c('v-layout', {
      staticClass: "divAddedUser",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "xs10": "",
        "right": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.FullName) + "\n                  ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [(!item.IsConfirmed) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:right",
        value: ({
          html: 'הוסף מפקח'
        }),
        expression: "{ html: 'הוסף מפקח' }",
        arg: "right"
      }],
      staticClass: "btnAddSmall",
      on: {
        "click": function($event) {
          _vm.addUser(item)
        }
      }
    }, [_vm._v("add")]) : _vm._e()], 1)], 1)
  })) : _vm._e()])], 1), _vm._v(" "), (_vm.selectedInspectors && _vm.selectedInspectors.length) ? _c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px",
      "margin-right": "10px",
      "max-height": "150px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.selectedInspectors), function(item) {
    return _c('v-layout', {
      staticClass: "divAddedUser",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "right",
        "font-size": "12px!important",
        "font-style": "italic"
      },
      attrs: {
        "xs10": "",
        "right": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.FullName) + "\n                  ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [(!item.IsConfirmed) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:right",
        value: ({
          html: 'מחק מפקח'
        }),
        expression: "{ html: 'מחק מפקח' }",
        arg: "right"
      }],
      staticClass: "btnAddSmall",
      on: {
        "click": function($event) {
          _vm.removeUser(item)
        }
      }
    }, [_vm._v("remove")]) : _vm._e()], 1)], 1)
  }))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              מנהל עבודה\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtSearchContractor),
      expression: "txtSearchContractor"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "חפש לפי תעודת זהות"
    },
    domProps: {
      "value": (_vm.txtSearchContractor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtSearchContractor = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filteredContractors.length) ? _c('div', {
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px",
      "margin-right": "10px",
      "max-height": "150px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.filteredContractors), function(item) {
    return _c('v-layout', {
      staticClass: "divAddedUser",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "xs10": "",
        "right": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.FullName) + "\n                  ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [(!item.IsConfirmed) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:right",
        value: ({
          html: 'הוסף מנהל עבודה'
        }),
        expression: "{ html: 'הוסף מנהל עבודה' }",
        arg: "right"
      }],
      staticClass: "btnAddSmall",
      on: {
        "click": function($event) {
          _vm.addUser(item)
        }
      }
    }, [_vm._v("add")]) : _vm._e()], 1)], 1)
  })) : _vm._e()])], 1), _vm._v(" "), (_vm.selectedContractors && _vm.selectedContractors.length) ? _c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px",
      "margin-right": "10px",
      "max-height": "150px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.selectedContractors), function(item) {
    return _c('v-layout', {
      staticClass: "divAddedUser",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "right",
        "font-size": "12px!important",
        "font-style": "italic"
      },
      attrs: {
        "xs10": "",
        "right": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.FullName) + "\n                  ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [(!item.IsConfirmed) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:right",
        value: ({
          html: 'מחק מנהל עבודה'
        }),
        expression: "{ html: 'מחק מנהל עבודה' }",
        arg: "right"
      }],
      staticClass: "btnAddSmall",
      on: {
        "click": function($event) {
          _vm.removeUser(item)
        }
      }
    }, [_vm._v("remove")]) : _vm._e()], 1)], 1)
  }))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              משקיף\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtSearchObserver),
      expression: "txtSearchObserver"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "חפש לפי תעודת זהות"
    },
    domProps: {
      "value": (_vm.txtSearchObserver)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtSearchObserver = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filteredObservers.length) ? _c('div', {
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px",
      "margin-right": "10px",
      "max-height": "150px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.filteredObservers), function(item) {
    return _c('v-layout', {
      staticClass: "divAddedUser",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "xs10": "",
        "right": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.FullName) + "\n                  ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [(!item.IsConfirmed) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:right",
        value: ({
          html: 'הוסף משקיף'
        }),
        expression: "{ html: 'הוסף משקיף' }",
        arg: "right"
      }],
      staticClass: "btnAddSmall",
      on: {
        "click": function($event) {
          _vm.addUser(item)
        }
      }
    }, [_vm._v("add")]) : _vm._e()], 1)], 1)
  })) : _vm._e()])], 1), _vm._v(" "), (_vm.selectedObservers && _vm.selectedObservers.length) ? _c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px",
      "margin-right": "10px",
      "max-height": "150px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.selectedObservers), function(item) {
    return _c('v-layout', {
      staticClass: "divAddedUser",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "right",
        "font-size": "12px!important",
        "font-style": "italic"
      },
      attrs: {
        "xs10": "",
        "right": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.FullName) + "\n                  ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [(!item.IsConfirmed) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:right",
        value: ({
          html: 'מחק משקיף'
        }),
        expression: "{ html: 'מחק משקיף' }",
        arg: "right"
      }],
      staticClass: "btnAddSmall",
      on: {
        "click": function($event) {
          _vm.removeUser(item)
        }
      }
    }, [_vm._v("remove")]) : _vm._e()], 1)], 1)
  }))])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n            שמירה\n            "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n            ביטול\n            "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        שם מלא\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.FullName),
      expression: "$parent.popup.data.FullName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.FullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.FullName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        תעודת זהות\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Identity),
      expression: "$parent.popup.data.Identity"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Identity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Identity = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (!_vm.isEntrepreneur) ? _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        שם משתמש\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Username),
      expression: "$parent.popup.data.Username"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Username = $event.target.value
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.isEntrepreneur) ? _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        סיסמה\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Password),
      expression: "$parent.popup.data.Password"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Password = $event.target.value
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Active),
      expression: "$parent.popup.data.Active"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.popup.data.Active) ? _vm._i(_vm.$parent.popup.data.Active, null) > -1 : (_vm.$parent.popup.data.Active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.$parent.popup.data.Active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.$parent.popup.data.Active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.$parent.popup.data.Active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$parent.popup.data.Active = $$c
        }
      }
    }
  }), _vm._v(" פעיל\n      ")]), _vm._v(" "), (!_vm.isEntrepreneur) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Approved),
      expression: "$parent.popup.data.Approved"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.popup.data.Approved) ? _vm._i(_vm.$parent.popup.data.Approved, null) > -1 : (_vm.$parent.popup.data.Approved)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.$parent.popup.data.Approved,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.$parent.popup.data.Approved = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.$parent.popup.data.Approved = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$parent.popup.data.Approved = $$c
        }
      }
    }
  }), _vm._v(" מאושר\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.notification.isShow) ? _c('div', {
    class: ['elevation-5', _vm.$root.isRTL ? 'notificationRTL' : 'notification'],
    on: {
      "click": function($event) {
        _vm.selectActivity(_vm.$root.notification.activityId)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-icon', [_vm._v("email")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 5px 10px 0px"
    },
    attrs: {
      "xs9": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "musketeerFont",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$root.notification.info) + " by " + _vm._s(_vm.$root.notification.from))])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "musketeerFont"
  }, [_vm._v("Event: " + _vm._s(_vm.$root.notification.event))])])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: [_vm.$root.isRTL ? 'RLT' : ''],
    attrs: {
      "standalone": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('div', {
    class: ['mobileMenu', _vm.$root.activeMobileMenu ? 'activeMenu' : '']
  }, [_c('SubMenu')], 1)]), _vm._v(" "), _c('v-navigation-drawer', {
    class: [_vm.$root.device.isTablet ? 'tabletMenu' : '', _vm.$root.isRTL ? 'navigation-drawer--right' : '', 'elevation-10'],
    staticStyle: {
      "padding": "0px",
      "margin": "0px",
      "z-index": "200"
    },
    attrs: {
      "light": ""
    },
    model: {
      value: (_vm.$root.activeSubMenu),
      callback: function($$v) {
        _vm.$root.activeSubMenu = $$v
      },
      expression: "$root.activeSubMenu"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "background-color": "#3A2D01",
      "height": "200px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "color": "#fff",
      "padding": "20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": ""
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.plan.Name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": ""
    }
  }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_vm._v("שם תוכנית עבודה:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('b', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.plan.Name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_vm._v("תיאור:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('b', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.plan.Info))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_vm._v("פרויקט:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": ""
    }
  }, [_c('b', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.plan.ProjectName))])])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    class: ['submenu', _vm.$root.device.isTablet ? 'tabletMenu' : ''],
    staticStyle: {
      "overflow": "hidden",
      "margin-bottom": "50px"
    },
    attrs: {
      "right": ""
    },
    model: {
      value: (_vm.$root.activeSubMenu),
      callback: function($$v) {
        _vm.$root.activeSubMenu = $$v
      },
      expression: "$root.activeSubMenu"
    }
  }, [(_vm.$root.device.isTablet) ? _c('v-list', [_c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.$root.goto('Plans');
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "text-align": "right!important",
      "margin": "10px"
    }
  }, [_vm._v("חזרה")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'הורדה'
      }),
      expression: "{ html: 'הורדה' }",
      arg: "bottom"
    }],
    staticClass: "material-icons",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.$root.goto('Plans')
      }
    }
  }, [_vm._v("close")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('Folder', {
    staticClass: "rootFolder",
    attrs: {
      "isRoot": "true",
      "Key": Object.keys(_vm.rootData)[0],
      "folderData": _vm.rootData,
      "path": _vm.rootPath,
      "canEdit": _vm.canEdit
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "z-index": "100"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [(_vm.$root.device.isMobile) ? _c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right",
      "width": "200px"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("picture_as_pdf")]), _vm._v(_vm._s(_vm.plan.Name) + "\n        ")]) : _c('div', {
    staticClass: "divDiary"
  }, [_c('img', {
    staticClass: "logoDiary",
    attrs: {
      "src": __webpack_require__(59)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "diaryTitle"
  }, [_vm._v(_vm._s(_vm.plan.Name))])]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-spacer') : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), (_vm.$root.device.isMobile || _vm.$root.device.isTablet) ? _c('div', [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', [_c('div', [_vm._v("שם תוכנית: "), _c('b', [_vm._v(_vm._s(_vm.plan.Name))])]), _vm._v(" "), _c('div', [_vm._v("תיאור: "), _c('b', [_vm._v(_vm._s(_vm.plan.Info))])]), _vm._v(" "), _c('div', [_vm._v("פרויקט: "), _c('b', [_vm._v(_vm._s(_vm.plan.ProjectName))])])]), _vm._v(" "), (_vm.$root.device.isMobile) ? _c('th', [_c('a', {
    staticClass: "btnPlans",
    on: {
      "click": function($event) {
        _vm.isFilesVisible = true
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("find_in_page")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("בחר תוכנית")])])], 1)], 1)]) : _vm._e()])]), _vm._v(" "), _c('PDFMobile', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "url": _vm.$root.selectedFile
    }
  })], 1) : _c('div', {
    staticClass: "divScroll"
  }, [_c('PDF', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "url": _vm.$root.selectedFile
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.$root.alert.timeout,
      "top": _vm.$root.alert.isTop
    },
    model: {
      value: (_vm.$root.alert.isShow),
      callback: function($$v) {
        _vm.$root.alert.isShow = $$v
      },
      expression: "$root.alert.isShow"
    }
  }, [_vm._v(_vm._s(_vm.$root.alert.message))]), _vm._v(" "), _c('PopupConfirm'), _vm._v(" "), _c('PopupAddFile'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.isFilesVisible),
      callback: function($$v) {
        _vm.isFilesVisible = $$v
      },
      expression: "isFilesVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("בחר קובץ")])], 1), _vm._v(" "), _c('v-flex', [_c('Folder', {
    staticClass: "rootFolder",
    attrs: {
      "isRoot": "true",
      "Key": Object.keys(_vm.rootData)[0],
      "folderData": _vm.rootData,
      "path": _vm.rootPath,
      "canEdit": _vm.canEdit
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticStyle: {
      "padding": "0px!important",
      "direction": "rtl"
    }
  }, [_c('v-container', {
    staticClass: "full loginGrd",
    attrs: {
      "fluid": "fluid"
    }
  }, [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row-sm": "",
      "column": "",
      "child-flex-sm": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "c1Intro"
  }, [_c('div', {
    staticClass: "c2Intro"
  }, [(_vm.$root.device.isMobile) ? _c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": __webpack_require__(361)
    }
  }) : _c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(361)
    }
  })])])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row-sm": "",
      "column": "",
      "child-flex-sm": "",
      "mt-2": ""
    }
  }, [_c('div'), _vm._v(" "), _c('div', [_c('h4', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("כניסה למערכת")])]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin": "auto",
      "width": "300px"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "lblWhiteR",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("אימייל")]), _vm._v(" "), _c('v-icon', {
    staticClass: "text-xl-right lblWhiteR",
    staticStyle: {
      "width": "20%",
      "float": "left",
      "text-align": "left!important",
      "display": "block"
    },
    on: {
      "click": _vm.clearUser
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "txtLogin",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": _vm.resetError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "lblWhiteL",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("סיסמה")]), _vm._v(" "), _c('v-icon', {
    staticClass: "text-xl-right lblWhiteR",
    staticStyle: {
      "width": "20%",
      "float": "left",
      "text-align": "left!important",
      "display": "block"
    },
    on: {
      "click": _vm.clearPassword
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "txtLogin",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": _vm.resetError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "lnkBtn",
    on: {
      "click": function($event) {
        _vm.isPasswordReset = true
      }
    }
  }, [_vm._v("שכחתי סיסמה")])])])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-3",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px"
    }
  }, [(_vm.$root.loginError) ? _c('span', {
    staticStyle: {
      "color": "#c00000"
    }
  }, [_vm._v(_vm._s(_vm.$root.loginError))]) : _vm._e()])])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin": "auto",
      "width": "300px"
    },
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('input', {
    staticClass: "btnBrown",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "button",
      "value": "כניסה"
    },
    on: {
      "click": function($event) {
        _vm.$root.login(_vm.username, _vm.password)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('input', {
    staticClass: "btnBrown",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "button",
      "value": "הרשמה"
    },
    on: {
      "click": function($event) {
        _vm.isRegister = true
      }
    }
  })])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.$root.alert.timeout,
      "top": _vm.$root.alert.isTop
    },
    model: {
      value: (_vm.$root.alert.isShow),
      callback: function($$v) {
        _vm.$root.alert.isShow = $$v
      },
      expression: "$root.alert.isShow"
    }
  }, [_vm._v(_vm._s(_vm.$root.alert.message))]), _vm._v(" "), _c('PopupRegister'), _vm._v(" "), _c('PopupPasswordReset')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("record_voice_over")]), _vm._v("מפקחים\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  }) : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.$root.isAdmin) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isActiveUsers),
      expression: "isActiveUsers"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isActiveUsers) ? _vm._i(_vm.isActiveUsers, null) > -1 : (_vm.isActiveUsers)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isActiveUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isActiveUsers = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isActiveUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isActiveUsers = $$c
        }
      }
    }
  }), _vm._v(" הצג פעיל בלבד\n    ")], 1), _vm._v(" "), _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם מפקח")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("שם משתמש")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תעודת זהות")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("פעיל")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("מאושר")]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.FullName))]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Username))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Identity))]), _vm._v(" "), _c('td', {
      staticClass: "tdData"
    }, [(row.Active) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData"
    }, [(row.Approved) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1) : _vm._e()])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupUser')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right",
      "position": "relative"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("chat")]), _vm._v("הודעות\n      \n    ")]), _vm._v(" "), (_vm.$root.messagesCounter) ? _c('div', {
    staticClass: "w3-badge",
    staticStyle: {
      "position": "absolute",
      "right": "140px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.messagesCounter))])]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  }) : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), (_vm.$root.device.isMobile) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', [_vm._v("הודעות ובקשות הצטרפות ליומן...")])])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContentMobile"
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('div', {
      staticClass: "note msg"
    }, [_c('v-layout', {
      staticStyle: {
        "padding": "5px"
      },
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('b', [_vm._v(_vm._s(row.SenderName))]), _vm._v(":\n          ")]), _vm._v(" "), _c('v-flex', {
      staticStyle: {
        "text-align": "left",
        "color": "#aaa",
        "font-size": "14px"
      },
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("\n            " + _vm._s(row.CreateDate) + "\n          ")])], 1), _vm._v(" "), _c('v-layout', {
      staticStyle: {
        "padding": "5px"
      },
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "right",
        "padding-right": "10px"
      },
      attrs: {
        "xs12": "",
        "right": ""
      }
    }, [_vm._v("\n            " + _vm._s(row.Text) + "\n          ")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "height": "30px"
      }
    }, [(row.IsConfirmed) ? _c('v-icon', {
      staticClass: "green--text",
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text",
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("block")]), _vm._v(" "), (row.IsConfirmed) ? _c('label', {
      staticClass: "green--text"
    }, [_vm._v("מאושר")]) : _c('label', {
      staticClass: "red--text"
    }, [_vm._v("לא מאושר")]), _vm._v(" "), (!row.IsConfirmed) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'אישור בקשה'
        }),
        expression: "{ html: 'אישור בקשה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      staticStyle: {
        "float": "left"
      },
      on: {
        "click": function($event) {
          _vm.confirmMessage(row)
        }
      }
    }, [_vm._v("check_circle")]) : _vm._e()], 1)], 1)
  })) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])])]) : _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("תאריך")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("השולח")]), _vm._v(" "), _c('th', {
    staticClass: "tdData",
    staticStyle: {
      "width": "480px"
    }
  }, [_vm._v("תוכן ההודעה")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("סוג הודעה")]) : _vm._e(), _vm._v(" "), (_vm.hasData) ? _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "100px!important"
    }
  }, [_vm._v("מאושר")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  })])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.CreateDate))]), _vm._v(" "), _c('td', {
      staticClass: "tdData"
    }, [_vm._v(_vm._s(row.SenderName))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt",
      staticStyle: {
        "width": "500px"
      }
    }, [_vm._v(_vm._s(row.Text))]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Type))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl",
      staticStyle: {
        "width": "100px!important"
      }
    }, [(row.IsConfirmed) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [(!row.IsConfirmed) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'אישור בקשה'
        }),
        expression: "{ html: 'אישור בקשה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirmMessage(row)
        }
      }
    }, [_vm._v("check_circle")]) : _vm._e()], 1)])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": function($event) {
        _vm.$parent.addNew(null)
      }
    }
  }, [_vm._v("add")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.$parent.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [(!_vm.$root.device.isMobile) ? _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.$parent.filteredRows), function(row) {
    return _c('tr', {
      class: {
        'trSelect': row.selected
      }
    }, [_c('td', {
      staticClass: "tdData sp",
      staticStyle: {
        "position": "relative",
        "width": "120px"
      }
    }, [(row.Images) ? _c('img', {
      staticClass: "thumb",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": row.Images[0]
      },
      on: {
        "click": function($event) {
          _vm.$parent.edit(row)
        },
        "error": function($event) {
          _vm.imageError(row)
        }
      }
    }) : _c('img', {
      staticClass: "thumb",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": __webpack_require__(38)
      },
      on: {
        "click": function($event) {
          _vm.$parent.edit(row)
        },
        "error": function($event) {
          _vm.imageError(row)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Name))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.City))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Address))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_c('div', {
      staticClass: "divColorIcon",
      style: ({
        'background-color': _vm.$parent.getStatusColor(row.StatusKey)
      })
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$parent.getStatusName(row.StatusKey)))])]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.StartDate))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.EndDate))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_c('v-progress-circular', {
      staticStyle: {
        "color": "#F7941D"
      },
      attrs: {
        "size": 50,
        "width": 5,
        "rotate": 360,
        "value": row.Percent,
        "color": "black"
      }
    }, [_vm._v("\n            " + _vm._s(row.Percent) + "%\n          ")])], 1), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [(row.Entrepreneur) ? _c('span', [_vm._v(_vm._s(row.Entrepreneur.FullName))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.$parent.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.$parent.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1)])
  })) : _c('div', _vm._l((_vm.$parent.filteredRows), function(row) {
    return _c('v-card', {
      staticClass: "cardDiary cardDiaryMobile w3-table-all"
    }, [_c('v-container', {
      attrs: {
        "grid-list-lg": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [(row.Images) ? _c('img', {
      staticClass: "thumb",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": row.Images[0]
      },
      on: {
        "click": function($event) {
          _vm.$parent.edit(row)
        },
        "error": function($event) {
          _vm.imageError(row)
        }
      }
    }) : _c('img', {
      staticClass: "thumb",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": __webpack_require__(38)
      },
      on: {
        "click": function($event) {
          _vm.$parent.edit(row)
        },
        "error": function($event) {
          _vm.imageError(row)
        }
      }
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('div', {
      staticStyle: {
        "padding-right": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('b', [_vm._v(_vm._s(row.Name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.City))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.Address))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.StartDate))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.EndDate))])])])], 1), _vm._v(" "), _c('v-layout', {
      staticStyle: {
        "padding-left": "20px"
      },
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(row.Entrepreneur) ? _c('div', {
      staticStyle: {
        "text-align": "right",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(row.Entrepreneur.FullName))]) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', {
      staticStyle: {
        "padding-left": "20px"
      },
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }), _vm._v(" "), (_vm.$root.isCustomer) ? _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.$parent.edit(row)
        }
      }
    }, [_vm._v("border_color")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isCustomer) ? _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.$parent.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)], 1)
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px",
      "text-align": "center"
    }
  }, [_vm._v("אין נתונים")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("תמונה")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("שם פרויקט")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("ישוב")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("כתובת")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("שלב התקדמות")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תאריך התחלה")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תאריך סיום")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("אחוז התקדמות")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("יזם")]), _vm._v(" "), _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  })])
}]}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: [_vm.$root.isRTL ? 'RLT' : ''],
    attrs: {
      "id": "app"
    },
    on: {
      "click": _vm.appClick
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-top"
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        שם חבילה\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Name),
      expression: "$parent.popup.data.Name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        מספר יומנים\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Diaries),
      expression: "$parent.popup.data.Diaries"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Diaries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Diaries = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        מחיר ₪\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Price),
      expression: "$parent.popup.data.Price"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Price = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.$root.confirm.isVisible),
      callback: function($$v) {
        _vm.$root.confirm.isVisible = $$v
      },
      expression: "$root.confirm.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$root.confirm.title))])], 1), _vm._v(" "), _c('v-flex', [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.$root.confirm.question)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmed(true)
      }
    }
  }, [_vm._v("\n        כן\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmed(false)
      }
    }
  }, [_vm._v("\n        לא\n        ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#fff",
      "height": "35px",
      "left": "0px",
      "right": "0px",
      "top": "0px",
      "border-bottom": "1px dotted #ccc"
    }
  }, [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "float": "left",
      "font-size": "16px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.activeDiaryPage),
      expression: "$root.activeDiaryPage"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    staticStyle: {
      "width": "130px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$root.activeDiaryPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v("בחר תאריך")]), _vm._v(" "), _vm._l((_vm.pages), function(pg) {
    return _c('option', {
      domProps: {
        "value": pg
      }
    }, [_vm._v(_vm._s(pg.Date))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "padding-top": "5px",
      "font-size": "16px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("מזג אויר: ")]), _vm._v(" "), (_vm.diaryPage) ? _c('span', [(_vm.canAdd()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diaryPage.Weather),
      expression: "diaryPage.Weather"
    }],
    staticStyle: {
      "text-align": "center",
      "width": "130px!important"
    },
    attrs: {
      "type": "text",
      "placeholder": "הכנס מזג אויר"
    },
    domProps: {
      "value": (_vm.diaryPage.Weather)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.diaryPage.Weather = $event.target.value
      }
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.diaryPage.Weather)
    }
  })]) : _c('span', [(_vm.canAdd()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page.Weather),
      expression: "page.Weather"
    }],
    staticStyle: {
      "text-align": "center",
      "width": "130px!important"
    },
    attrs: {
      "type": "text",
      "placeholder": "הכנס מזג אויר"
    },
    domProps: {
      "value": (_vm.page.Weather)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page.Weather = $event.target.value
      }
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.Weather)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollContentMobile"
  }, [_c('v-subheader', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "height": "25px",
      "line-height": "45px"
    }
  }, [_vm._v("הערות כלליות")]), _vm._v(" "), (_vm.canAdd()) ? _c('v-icon', {
    staticClass: "btnAdd",
    staticStyle: {
      "text-decoration": "none",
      "float": "left",
      "font-size": "25px",
      "width": "25px!important",
      "height": "25px!important"
    },
    on: {
      "click": _vm.addGeneralNote
    }
  }, [_vm._v("add")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.$root.isNewGeneralNote) ? _c('NoteEditor', {
    attrs: {
      "index": "new",
      "date": _vm.currentDate,
      "time": _vm.currentTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notesGeneral && _vm.notesGeneral.length > 0) ? _c('div', _vm._l((_vm.notesGeneral), function(note, index) {
    return _c('Note', {
      attrs: {
        "noteData": note,
        "index": index,
        "canEdit": _vm.canEdit(note)
      }
    })
  })) : _c('div', [_c('h5', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "14px"
    }
  }, [_vm._v(" -- אין נתונים -- ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "height": "25px",
      "line-height": "45px"
    }
  }, [_vm._v("תיאור העבודה")]), _vm._v(" "), (_vm.canAdd()) ? _c('v-icon', {
    staticClass: "btnAdd",
    staticStyle: {
      "text-decoration": "none",
      "float": "left",
      "font-size": "25px",
      "width": "25px!important",
      "height": "25px!important"
    },
    on: {
      "click": _vm.addInfoNote
    }
  }, [_vm._v("add")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.$root.isNewInfoNote) ? _c('NoteEditor', {
    attrs: {
      "index": "new",
      "date": _vm.currentDate,
      "time": _vm.currentTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notesInfo && _vm.notesInfo.length > 0) ? _c('div', _vm._l((_vm.notesInfo), function(note, index) {
    return _c('Note', {
      attrs: {
        "noteData": note,
        "index": index,
        "canEdit": _vm.canEdit(note)
      }
    })
  })) : _c('div', [_c('h5', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "14px"
    }
  }, [_vm._v(" -- אין נתונים -- ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "height": "25px",
      "line-height": "45px"
    }
  }, [_vm._v("הערות מנהל עבודה")]), _vm._v(" "), (_vm.$root.isContractor && _vm.canAdd()) ? _c('v-icon', {
    staticClass: "btnAdd",
    staticStyle: {
      "float": "left",
      "text-decoration": "none",
      "font-size": "25px",
      "width": "25px!important",
      "height": "25px!important"
    },
    on: {
      "click": _vm.addNote
    }
  }, [_vm._v("add")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.$root.isNewNote && _vm.$root.isContractor) ? _c('NoteEditor', {
    attrs: {
      "index": "new",
      "date": _vm.currentDate,
      "time": _vm.currentTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notesContractor && _vm.notesContractor.length > 0) ? _c('div', _vm._l((_vm.notesContractor), function(note, index) {
    return _c('Note', {
      attrs: {
        "noteData": note,
        "index": index,
        "canEdit": _vm.canEdit(note)
      }
    })
  })) : _c('div', [_c('h5', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "14px"
    }
  }, [_vm._v(" -- אין נתונים -- ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "height": "25px",
      "line-height": "45px"
    }
  }, [_vm._v("הערות מפקח")]), _vm._v(" "), (_vm.$root.isInspector && _vm.canAdd()) ? _c('v-icon', {
    staticClass: "btnAdd",
    staticStyle: {
      "float": "left",
      "text-decoration": "none",
      "font-size": "25px",
      "width": "25px!important",
      "height": "25px!important"
    },
    on: {
      "click": _vm.addNote
    }
  }, [_vm._v("add")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.$root.isNewNote && _vm.$root.isInspector) ? _c('NoteEditor', {
    attrs: {
      "index": "new",
      "date": _vm.currentDate,
      "time": _vm.currentTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notesInspector && _vm.notesInspector.length > 0) ? _c('div', _vm._l((_vm.notesInspector), function(note, index) {
    return _c('Note', {
      attrs: {
        "noteData": note,
        "index": index,
        "canEdit": _vm.canEdit(note)
      }
    })
  })) : _c('div', [_c('h5', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "14px"
    }
  }, [_vm._v(" -- אין נתונים -- ")])]), _vm._v(" "), _c('v-divider')], 1)])
},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = false
      }
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "background-color": "#3A2D01",
      "height": "200px"
    }
  }, [_c('v-toolbar-title', [_c('Logo')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "submenu",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "permanent": "",
      "right": ""
    }
  }, [_c('v-list', {
    staticClass: "listScroll"
  }, [_vm._l((_vm.menu), function(item) {
    return (_vm.canRead(item)) ? _c('v-list-tile', {
      key: item,
      class: ['subMenuItem', _vm.$root.activePage == item.page ? 'active' : ''],
      nativeOn: {
        "click": function($event) {
          _vm.menuClick(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('i', {
      staticClass: "material-icons icon"
    }, [_vm._v(_vm._s(item.icon))])]), _vm._v(" "), (_vm.$root.isRTL) ? _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticStyle: {
        "text-align": "right!important",
        "margin": "10px"
      }
    }, [_vm._v(_vm._s(item.title))])], 1) : _vm._e(), _vm._v(" "), (_vm.showBadge(item)) ? _c('v-list-tile-action', [_c('div', {
      staticClass: "w3-badge"
    }, [_c('b', [_vm._v(_vm._s(_vm.$root.messagesCounter))])])]) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('v-list-tile', {
    staticClass: "subMenuItem",
    nativeOn: {
      "click": function($event) {
        _vm.confirmSignout($event)
      }
    }
  }, [_c('v-list-tile-action', [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("lock")])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "text-align": "right!important",
      "margin": "10px"
    }
  }, [_vm._v("יציאה")])], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.settings), function(row) {
    return _c('tr', {
      class: {
        'trSelect': row.selected
      }
    }, [_c('td', {
      staticClass: "tdData  sp",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_vm._v(_vm._s(row.KeyName))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isEdit),
        expression: "!isEdit"
      }],
      staticClass: "tdData tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_vm._v(_vm._s(row.KeyValue))])])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp",
    staticStyle: {
      "width": "160px!important"
    }
  }, [_vm._v("שם מפתח")]), _vm._v(" "), _c('th', {
    staticClass: "tdData",
    staticStyle: {
      "width": "160px!important"
    }
  }, [_vm._v("ערך מפתח")]), _vm._v(" "), _c('th', {
    staticClass: "tdData",
    staticStyle: {
      "width": "150px!important"
    }
  })])])
}]}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        שם סטטוס\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Name),
      expression: "$parent.popup.data.Name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        צבע\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('ColorPicker', {
    ref: "colorPicker",
    model: {
      value: (_vm.$parent.popup.colors),
      callback: function($$v) {
        _vm.$parent.popup.colors = $$v
      },
      expression: "$parent.popup.colors"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "divPDFMobile"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "pdfCanvas"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "btnZoomIn",
    attrs: {
      "color": "warning",
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.zoomMobile('+')
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "btnZoomOut",
    attrs: {
      "color": "warning",
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.zoomMobile('-')
      }
    }
  }, [_c('v-icon', [_vm._v("remove")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("streetview")]), _vm._v("מנהלי עבודה\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  }) : _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = true
      }
    }
  }, [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.$root.isAdmin) ? _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isActiveUsers),
      expression: "isActiveUsers"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isActiveUsers) ? _vm._i(_vm.isActiveUsers, null) > -1 : (_vm.isActiveUsers)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isActiveUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isActiveUsers = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isActiveUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isActiveUsers = $$c
        }
      }
    }
  }), _vm._v(" הצג פעיל בלבד\n    ")], 1), _vm._v(" "), _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם מנהל עבודה")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("שם משתמש")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("תעודת זהות")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("פעיל")]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('th', {
    staticClass: "tdData"
  }, [_vm._v("מאושר")]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.FullName))]), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Username))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Identity))]), _vm._v(" "), _c('td', {
      staticClass: "tdData"
    }, [(row.Active) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1), _vm._v(" "), (!_vm.$root.device.isMobile) ? _c('td', {
      staticClass: "tdData"
    }, [(row.Approved) ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("done")]) : _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("block")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1) : _vm._e()])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupUser')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v("\n       \n    ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'הדפסה'
      }),
      expression: "{ html: 'הדפסה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 ml-2 left"
  }, [_vm._v("print")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'ייצוא אקסל'
      }),
      expression: "{ html: 'ייצוא אקסל' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 ml-2 left"
  }, [_vm._v("file_download")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.FullName))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.ContactPerson))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Phone))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Username))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.TotalDiaries))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.UsedDiaries))])])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם לקוח/רוכש")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("איש קשר")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("טלפון")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("חשבון משתמש")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("יומנים שנרכשו")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("יומנים בשימוש")])])])
}]}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.isRTL ? 'fullContentRTL' : 'fullContent']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("recent_actors")]), _vm._v("לקוחות\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "dark": "",
      "prepend-icon": "search",
      "single-line": ""
    },
    model: {
      value: (_vm.txtSearch),
      callback: function($$v) {
        _vm.txtSearch = $$v
      },
      expression: "txtSearch"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'הוסף חדש'
      }),
      expression: "{ html: 'הוסף חדש' }",
      arg: "left"
    }],
    staticClass: "btnAdd",
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp"
  }, [_vm._v("שם לקוח/רוכש")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("איש קשר")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("טלפון")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("חשבון משתמש")]), _vm._v(" "), _c('th', {
    staticClass: "tdData"
  }, [_vm._v("יומנים שנרכשו")]), _vm._v(" "), _c('th', {
    staticClass: "tdCtrl",
    staticStyle: {
      "width": "160px!important"
    }
  })])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "tdData sp"
    }, [_vm._v(_vm._s(row.FullName))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.ContactPerson))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Phone))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.Username))]), _vm._v(" "), _c('td', {
      staticClass: "tdData tdTxt"
    }, [_vm._v(_vm._s(row.TotalDiaries))]), _vm._v(" "), _c('td', {
      staticClass: "tdCtrl tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'הוספת יומנים'
        }),
        expression: "{ html: 'הוספת יומנים' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      staticStyle: {
        "font-size": "34px"
      },
      on: {
        "click": function($event) {
          _vm.addDiaries(row)
        }
      }
    }, [_vm._v("playlist_add")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'עריכה'
        }),
        expression: "{ html: 'עריכה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2",
      on: {
        "click": function($event) {
          _vm.edit(row)
        }
      }
    }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחיקה'
        }),
        expression: "{ html: 'מחיקה' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.confirm(row)
        }
      }
    }, [_vm._v("delete")])], 1)])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])]), _vm._v(" "), _c('PopupCustomer'), _vm._v(" "), _c('PopupAddDiaries')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 929 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 930 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 931 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 932 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 933 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[529]);


// WEBPACK FOOTER //
// static/js/app.7bbd3b3641ce633f7754.js